export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  GenericScalar: any;
  JSONString: any;
  Time: any;
  UUID: any;
  WONEGeneratorPattern: any;
};

export type Action = {
  __typename?: "Action";
  buttonAction?: Maybe<ButtonAction>;
  buttonText: Scalars["String"];
  buttonStyle: ButtonStyle;
};

export type AddressChoiceType = {
  __typename?: "AddressChoiceType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  name: Scalars["String"];
  addressSet: Array<AddressType>;
};

export type AddressType = {
  __typename?: "AddressType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  addressChoice?: Maybe<AddressChoiceType>;
  addressLine1?: Maybe<Scalars["String"]>;
  addressLine2?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country: Scalars["String"];
  postCode?: Maybe<Scalars["String"]>;
  userdetailSet: Array<UserDetailType>;
  corporatecompanySet: Array<CorporateCompanyType>;
  classsessionSet: Array<ClassSessionType>;
};

export type AdminMemberInfo = {
  __typename?: "AdminMemberInfo";
  id: Scalars["ID"];
  member: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email: Scalars["String"];
  timezone: Scalars["String"];
  action?: Maybe<Action>;
};

export type AdminSettingsScreen = {
  __typename?: "AdminSettingsScreen";
  title: Scalars["String"];
  subTitle: Scalars["String"];
  companyName: Scalars["String"];
  admins?: Maybe<Admins>;
  selectAdminList?: Maybe<Array<Maybe<SelectAdminList>>>;
};

export type Admins = {
  __typename?: "Admins";
  title: Scalars["String"];
  addButton: Action;
  adminSeats: Scalars["String"];
  labels: Array<Maybe<Scalars["String"]>>;
  members: Array<Maybe<AdminMemberInfo>>;
};

export type AppInfo = {
  platform: Platform;
  name: Scalars["String"];
  version: Scalars["String"];
  timeZone: Scalars["String"];
};

export type ArticleFeedbackChoiceInput = {
  id: Scalars["String"];
  label: Scalars["String"];
  value: Scalars["Int"];
};

export type ArticleType = {
  __typename?: "ArticleType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  author: Scalars["String"];
  title: Scalars["String"];
  subTitle: Scalars["String"];
  category: CategoryType;
  content: Scalars["String"];
  plans: Array<PlanType>;
  photo: Scalars["String"];
  photoWebpFull?: Maybe<Scalars["String"]>;
  photoWebp1080p?: Maybe<Scalars["String"]>;
  photoWebp720p?: Maybe<Scalars["String"]>;
  showOnCommunityPage: Scalars["Boolean"];
  pillar?: Maybe<PillarType>;
};

export type AssessmentEndStep = {
  __typename?: "AssessmentEndStep";
  id: Scalars["String"];
  shorthand?: Maybe<Scalars["String"]>;
  titleHtml?: Maybe<Scalars["String"]>;
  subtitleHtml?: Maybe<Scalars["String"]>;
};

export enum AssessmentEvent {
  StartAssessment = "START_ASSESSMENT",
  AssessmentStepViewed = "ASSESSMENT_STEP_VIEWED",
  AssessmentQuestionAnswered = "ASSESSMENT_QUESTION_ANSWERED",
  AssessmentQuestionSkipped = "ASSESSMENT_QUESTION_SKIPPED",
  AssessmentCompleted = "ASSESSMENT_COMPLETED",
  ExitAssessment = "EXIT_ASSESSMENT",
  AssessmentSubmissionError = "ASSESSMENT_SUBMISSION_ERROR",
}

export type AssessmentInfoStep = {
  __typename?: "AssessmentInfoStep";
  id: Scalars["String"];
  shorthand?: Maybe<Scalars["String"]>;
  titleHtml?: Maybe<Scalars["String"]>;
  subtitleHtml?: Maybe<Scalars["String"]>;
};

export type AssessmentQuestionStep = {
  __typename?: "AssessmentQuestionStep";
  id: Scalars["String"];
  titleHtml?: Maybe<Scalars["String"]>;
  subtitleHtml?: Maybe<Scalars["String"]>;
  shorthand?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  domain?: Maybe<Scalars["String"]>;
  input: Input;
  /** @deprecated deprecated */
  response?: Maybe<AssessmentResponse>;
};

export type AssessmentResponse = {
  __typename?: "AssessmentResponse";
  text?: Maybe<Scalars["String"]>;
  score?: Maybe<Scalars["Int"]>;
  optionId?: Maybe<Scalars["ID"]>;
};

export type AssessmentResultsInput = {
  responseJson: Scalars["JSONString"];
};

export type AssessmentSchedule = {
  __typename?: "AssessmentSchedule";
  previousAssessmentResponseId?: Maybe<Scalars["ID"]>;
  previousAssessmentTakenAt?: Maybe<Scalars["DateTime"]>;
  nextAssessmentDueAt?: Maybe<Scalars["DateTime"]>;
  isNextAssessmentDue: Scalars["Boolean"];
  daysUntilNextAssessmentDue?: Maybe<Scalars["Int"]>;
  hasResumableProgress: Scalars["Boolean"];
  resumableProgressExpiresAt?: Maybe<Scalars["DateTime"]>;
  resumableProgressSavedAt?: Maybe<Scalars["DateTime"]>;
  nextCheckInBookedAt?: Maybe<Scalars["DateTime"]>;
};

export type AssessmentSectionStep = {
  __typename?: "AssessmentSectionStep";
  id: Scalars["String"];
  shorthand?: Maybe<Scalars["String"]>;
  titleHtml?: Maybe<Scalars["String"]>;
  subtitleHtml?: Maybe<Scalars["String"]>;
};

export type AssessmentStep =
  | AssessmentWelcomeStep
  | AssessmentInfoStep
  | AssessmentSectionStep
  | AssessmentQuestionStep
  | AssessmentEndStep;

export type AssessmentWelcomeStep = {
  __typename?: "AssessmentWelcomeStep";
  id: Scalars["String"];
  shorthand?: Maybe<Scalars["String"]>;
  titleHtml?: Maybe<Scalars["String"]>;
  subtitleHtml?: Maybe<Scalars["String"]>;
};

export type BaseScore = {
  id?: Maybe<Scalars["ID"]>;
  shorthand: Scalars["String"];
  name: Scalars["String"];
  value?: Maybe<Scalars["Float"]>;
  minValue: Scalars["Float"];
  maxValue: Scalars["Float"];
  label?: Maybe<Scalars["String"]>;
  labelKey?: Maybe<Scalars["String"]>;
  blurb?: Maybe<Scalars["String"]>;
  /** Signed change from the previous reading, e.g. "+5" or "-3". */
  scoreDifference?: Maybe<Scalars["String"]>;
};

export type BiometricsType = {
  __typename?: "BiometricsType";
  vitalUserId?: Maybe<Scalars["String"]>;
  connectedSources?: Maybe<Array<Maybe<VitalProviderType>>>;
  lastNightsSleep?: Maybe<Scalars["String"]>;
  lastMeasuredHeartrate?: Maybe<Scalars["String"]>;
  stepCount?: Maybe<Scalars["Int"]>;
};

export type BiometricsVitalUserConnectedSourcesType = {
  __typename?: "BiometricsVitalUserConnectedSourcesType";
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  id: Scalars["ID"];
  user: BiometricsVitalUserType;
  isActive: Scalars["Boolean"];
};

export type BiometricsVitalUserType = {
  __typename?: "BiometricsVitalUserType";
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  id: Scalars["ID"];
  vitalUserId: Scalars["UUID"];
  clientUserId: Scalars["String"];
  userdetail: UserDetailType;
  biometricsvitaluserconnectedsourceSet: Array<BiometricsVitalUserConnectedSourcesType>;
};

export type BooleanInput = {
  __typename?: "BooleanInput";
  id: Scalars["String"];
  label: Scalars["String"];
  required: Scalars["Boolean"];
  reverseLogic?: Maybe<Scalars["Boolean"]>;
  checked?: Maybe<Scalars["Boolean"]>;
};

export type BusinessUnitType = {
  __typename?: "BusinessUnitType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  company: CorporateCompanyType;
  name: Scalars["String"];
  studentdetailSet: Array<StudentDetailType>;
};

export enum ButtonAction {
  SendInvite = "SEND_INVITE",
  Reactivate = "REACTIVATE",
  Deactivate = "DEACTIVATE",
  UploadCsv = "UPLOAD_CSV",
  AddMember = "ADD_MEMBER",
  AddAdmin = "ADD_ADMIN",
  RemoveAdmin = "REMOVE_ADMIN",
  AddDomain = "ADD_DOMAIN",
  RemoveDomain = "REMOVE_DOMAIN",
}

export enum ButtonStyle {
  Primary = "PRIMARY",
  Secondary = "SECONDARY",
  Disabled = "DISABLED",
}

export type CategoryScore = BaseScore & {
  __typename?: "CategoryScore";
  id?: Maybe<Scalars["ID"]>;
  shorthand: Scalars["String"];
  name: Scalars["String"];
  value?: Maybe<Scalars["Float"]>;
  minValue: Scalars["Float"];
  maxValue: Scalars["Float"];
  label?: Maybe<Scalars["String"]>;
  blurb?: Maybe<Scalars["String"]>;
};

export type CategoryType = {
  __typename?: "CategoryType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  name: Scalars["String"];
  description: Scalars["String"];
  articleSet: Array<ArticleType>;
};

export type ChangePassword = {
  __typename?: "ChangePassword";
  sentMail?: Maybe<Scalars["Boolean"]>;
  ok?: Maybe<Scalars["Boolean"]>;
  user?: Maybe<UserType>;
};

export type ChangePasswordInput = {
  oldPassword: Scalars["String"];
  newPassword: Scalars["String"];
};

export type ChangePasswordInputWithLink = {
  newPassword: Scalars["String"];
};

export type ChangePasswordWithLink = {
  __typename?: "ChangePasswordWithLink";
  sentMail?: Maybe<Scalars["Boolean"]>;
  ok?: Maybe<Scalars["Boolean"]>;
  user?: Maybe<UserType>;
};

export enum ClassSessionStatus {
  Scheduled = "SCHEDULED",
  Rescheduled = "RESCHEDULED",
  Cancelled = "CANCELLED",
}

export type ClassSessionType = {
  __typename?: "ClassSessionType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  classObj: TeacherClassModelType;
  teacher?: Maybe<TeacherDetailType>;
  student?: Maybe<StudentDetailType>;
  scheduledDate: Scalars["Date"];
  startTime?: Maybe<Scalars["String"]>;
  endTime?: Maybe<Scalars["String"]>;
  startDateTime?: Maybe<Scalars["DateTime"]>;
  endDateTime?: Maybe<Scalars["DateTime"]>;
  plan?: Maybe<PlanType>;
  address?: Maybe<AddressType>;
  credit: Scalars["Int"];
  status: ClassSessionStatus;
  studentComments?: Maybe<Scalars["String"]>;
  studentReminderEmail?: Maybe<Scalars["DateTime"]>;
  teacherReminderEmail?: Maybe<Scalars["DateTime"]>;
  sessionRegistrationPlatform?: Maybe<Scalars["String"]>;
  hasJoined: Scalars["Boolean"];
  sessionJoiningPlatform?: Maybe<Scalars["String"]>;
  joiningLink?: Maybe<Scalars["String"]>;
  isTeacherPaidIfCancelled: Scalars["Boolean"];
  reasonForCancellation?: Maybe<Scalars["String"]>;
  cancelledAt?: Maybe<Scalars["DateTime"]>;
  cancelledBy?: Maybe<UserType>;
  invitationSet: Array<InvitationType>;
  day?: Maybe<Scalars["String"]>;
  duration?: Maybe<Scalars["Int"]>;
  teacherPaymentPrice?: Maybe<Scalars["Float"]>;
};

export type CompanyAdmin = {
  __typename?: "CompanyAdmin";
  id: Scalars["ID"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  fullName: Scalars["String"];
  photoUrl?: Maybe<Scalars["String"]>;
  companyName: Scalars["String"];
  companyId: Scalars["ID"];
  companyType?: Maybe<Scalars["String"]>;
  integrationsScreen: IntegrationsScreen;
  membersScreen: MembersScreen;
  adminSettingsScreen: AdminSettingsScreen;
  dashboardScreen?: Maybe<DashboardScreen>;
};

export type CompanyEmailInvitationDetails = {
  __typename?: "CompanyEmailInvitationDetails";
  inviteNotSentCount?: Maybe<Scalars["Int"]>;
  initiated?: Maybe<Scalars["Int"]>;
  expectedTimeOfCompletion?: Maybe<Scalars["String"]>;
  sent?: Maybe<Scalars["Int"]>;
  learnersWithStatusInviteSent?: Maybe<Scalars["Int"]>;
};

export type CompanyLocationType = {
  __typename?: "CompanyLocationType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  company: CorporateCompanyType;
  location: Scalars["String"];
  studentdetailSet: Array<StudentDetailType>;
};

export type CompanyPortalAdminAdd = {
  __typename?: "CompanyPortalAdminAdd";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalAdminRemove = {
  __typename?: "CompanyPortalAdminRemove";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalDomainAdd = {
  __typename?: "CompanyPortalDomainAdd";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalDomainRemove = {
  __typename?: "CompanyPortalDomainRemove";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalHrisRemove = {
  __typename?: "CompanyPortalHRISRemove";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalMemberAdd = {
  __typename?: "CompanyPortalMemberAdd";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalMemberAddInput = {
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email: Scalars["String"];
  timezone: Scalars["String"];
};

export type CompanyPortalMemberDeactivate = {
  __typename?: "CompanyPortalMemberDeactivate";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalMemberReactivate = {
  __typename?: "CompanyPortalMemberReactivate";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalMemberSendInvite = {
  __typename?: "CompanyPortalMemberSendInvite";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalSelfSignUpUpdate = {
  __typename?: "CompanyPortalSelfSignUpUpdate";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanyPortalSignInOptionSettingsInput = {
  authId: Scalars["String"];
  isSignInEnabled: Scalars["Boolean"];
  oktaSettings?: Maybe<OktaSettingsInput>;
};

export type CompanyPortalSignInOptionUpdate = {
  __typename?: "CompanyPortalSignInOptionUpdate";
  ok?: Maybe<Scalars["Boolean"]>;
  companyAdmin: CompanyAdmin;
};

export type CompanySso = {
  __typename?: "CompanySSO";
  title: Scalars["String"];
  subTitle: Scalars["String"];
  signIn: SignInOptions;
  signUp: SignUpOptions;
};

export type CompanyTableauAuthType = {
  __typename?: "CompanyTableauAuthType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  company: CorporateCompanyType;
  email: Scalars["String"];
  views: Scalars["JSONString"];
};

export type Connections = {
  __typename?: "Connections";
  id: Scalars["ID"];
  logo: Scalars["String"];
  name: Scalars["String"];
  subCompanyName: Scalars["String"];
};

export type ContentTagType = {
  __typename?: "ContentTagType";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type CorporateCompanyAdminType = {
  __typename?: "CorporateCompanyAdminType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  company: CorporateCompanyType;
  admin: StudentDetailType;
};

export enum CorporateCompanyCalendarProvider {
  Google = "GOOGLE",
  Microsoft = "MICROSOFT",
}

export type CorporateCompanyType = {
  __typename?: "CorporateCompanyType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  photo?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  billingEmail: Scalars["String"];
  subscription: Scalars["Int"];
  individualCreditsPerEmployee: Scalars["Int"];
  feedbackLink?: Maybe<Scalars["String"]>;
  address?: Maybe<AddressType>;
  domain?: Maybe<Scalars["String"]>;
  noOfSeats?: Maybe<Scalars["Int"]>;
  subscriptionProduct: SubscriptionProductType1;
  stripeCustomerId?: Maybe<Scalars["String"]>;
  currentStripeSubscriptionId?: Maybe<Scalars["String"]>;
  subscriptionStatus?: Maybe<Scalars["String"]>;
  subscriptionCanceledAt?: Maybe<Scalars["DateTime"]>;
  subscriptionEndedAt?: Maybe<Scalars["DateTime"]>;
  checkoutPaymentStatus?: Maybe<Scalars["String"]>;
  calendarProvider?: Maybe<CorporateCompanyCalendarProvider>;
  disableWoneAssessmentCompanyQuestions: Scalars["Boolean"];
  resendInviteButtonLastClickedAt?: Maybe<Scalars["String"]>;
  shouldPreferMicrosoftAccountEmailOverUpn: Scalars["Boolean"];
  companylocationSet: Array<CompanyLocationType>;
  businessunitSet: Array<BusinessUnitType>;
  companytableauauth?: Maybe<CompanyTableauAuthType>;
  studentdetailSet: Array<StudentDetailType>;
  corporatecompanyadminSet: Array<CorporateCompanyAdminType>;
  groupsessionSet: Array<GroupSessionType>;
  paymentLink?: Maybe<Scalars["String"]>;
  seatsLeft?: Maybe<Scalars["Int"]>;
  seatsUsed?: Maybe<Scalars["Int"]>;
  nextPayment?: Maybe<Scalars["GenericScalar"]>;
  signUpLink?: Maybe<Scalars["String"]>;
  signUpLinkExpiresOn?: Maybe<Scalars["String"]>;
  emailInvitationDetails?: Maybe<CompanyEmailInvitationDetails>;
};

export type CreateUpdateFcmDevice = {
  __typename?: "CreateUpdateFCMDevice";
  ok?: Maybe<Scalars["Boolean"]>;
  fcmDevice?: Maybe<FcmDeviceTypeModel>;
};

export type DashboardScreen = {
  __typename?: "DashboardScreen";
  token: Scalars["String"];
  views: Scalars["JSONString"];
};

export type DateInput = {
  __typename?: "DateInput";
  id: Scalars["String"];
  label: Scalars["String"];
  required: Scalars["Boolean"];
  minDate?: Maybe<Scalars["String"]>;
  maxDate?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
};

export type DjangoDebug = {
  __typename?: "DjangoDebug";
  sql?: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

export type DjangoDebugSql = {
  __typename?: "DjangoDebugSQL";
  vendor: Scalars["String"];
  alias: Scalars["String"];
  sql?: Maybe<Scalars["String"]>;
  duration: Scalars["Float"];
  rawSql: Scalars["String"];
  params: Scalars["String"];
  startTime: Scalars["Float"];
  stopTime: Scalars["Float"];
  isSlow: Scalars["Boolean"];
  isSelect: Scalars["Boolean"];
  transId?: Maybe<Scalars["String"]>;
  transStatus?: Maybe<Scalars["String"]>;
  isoLevel?: Maybe<Scalars["String"]>;
  encoding?: Maybe<Scalars["String"]>;
};

export type DomainList = {
  __typename?: "DomainList";
  name: Scalars["String"];
  dateAdded: Scalars["String"];
  action: Action;
};

export type DomainScore = BaseScore & {
  __typename?: "DomainScore";
  id?: Maybe<Scalars["ID"]>;
  shorthand: Scalars["String"];
  name: Scalars["String"];
  value?: Maybe<Scalars["Float"]>;
  minValue: Scalars["Float"];
  maxValue: Scalars["Float"];
  label?: Maybe<Scalars["String"]>;
  blurb?: Maybe<Scalars["String"]>;
  categoryShorthand: Scalars["String"];
  recommendedRecordings: Array<DomainThemeRecommendedRecordings>;
};

export type DomainThemeRecommendedRecordings = {
  __typename?: "DomainThemeRecommendedRecordings";
  subTitle: Scalars["String"];
  recording: LearnerRecording;
};

export type Domains = {
  __typename?: "Domains";
  title: Scalars["String"];
  addButton: Action;
  subTitle: Scalars["String"];
  labels: Array<Maybe<Scalars["String"]>>;
  domainList: Array<Maybe<DomainList>>;
};

export type AssessmentButton = {
  __typename?: "AssessmentButton";
  text: Scalars["String"];
  url: Scalars["String"];
};

export type ExternalAssessmentType = {
  __typename?: "ExternalAssessmentType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  student: StudentDetailType;
  assessmentPercentage: Scalars["Int"];
  energyScore: Scalars["Int"];
  resilienceScore: Scalars["Int"];
  nutritionScore: Scalars["Int"];
  energyIntention: Scalars["Int"];
  resilienceIntention: Scalars["Int"];
  nutritionIntention: Scalars["Int"];
  energyScorePercentage: Scalars["Int"];
  resilienceScorePercentage: Scalars["Int"];
  nutritionScorePercentage: Scalars["Int"];
  responseJson: Scalars["String"];
  skipCompanyQuestions: Scalars["Boolean"];
  energyDescription?: Maybe<Scalars["String"]>;
  resilienceDescription?: Maybe<Scalars["String"]>;
  nutritionDescription?: Maybe<Scalars["String"]>;
};

export type FcmDeviceInput = {
  name: Scalars["String"];
  registrationID: Scalars["String"];
  deviceID: Scalars["String"];
  active: Scalars["Boolean"];
  type: Scalars["String"];
};

export enum FcmDeviceType {
  Ios = "IOS",
  Android = "ANDROID",
  Web = "WEB",
}

export type FcmDeviceTypeModel = {
  __typename?: "FCMDeviceTypeModel";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  active: Scalars["Boolean"];
  user?: Maybe<UserType>;
  dateCreated?: Maybe<Scalars["DateTime"]>;
  deviceId?: Maybe<Scalars["String"]>;
  registrationId: Scalars["String"];
  type: FcmDeviceType;
};

export type FeedbackMessage = {
  __typename?: "FeedbackMessage";
  title: Scalars["String"];
  senderAvatarUrl: Scalars["String"];
  senderName: Scalars["String"];
  textHtml: Scalars["String"];
  input?: Maybe<Input>;
  buttonText: Scalars["String"];
  skipButtonText?: Maybe<Scalars["String"]>;
};

export enum GroupSessionGroupSessionFor {
  Community = "COMMUNITY",
  Corporate = "CORPORATE",
}

export type GroupSessionInstanceType = {
  __typename?: "GroupSessionInstanceType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  groupSession: GroupSessionType;
  scheduledDate: Scalars["Date"];
  instanceStartDateTime?: Maybe<Scalars["DateTime"]>;
  instanceEndDateTime?: Maybe<Scalars["DateTime"]>;
  instanceDisplayEndDateTime?: Maybe<Scalars["DateTime"]>;
  sessionDurationMinutes: Scalars["Int"];
  teacher?: Maybe<TeacherDetailType>;
  recordingUrlThumbnail?: Maybe<Scalars["String"]>;
  recordingUrlThumbnailWebpFull?: Maybe<Scalars["String"]>;
  recordingUrlThumbnailWebp1080p?: Maybe<Scalars["String"]>;
  recordingUrlThumbnailWebp720p?: Maybe<Scalars["String"]>;
  recordingUrl?: Maybe<Scalars["String"]>;
  recordingUploadedAt?: Maybe<Scalars["DateTime"]>;
  recordingDuration?: Maybe<Scalars["Float"]>;
  showOnClassPage: Scalars["Boolean"];
  showOnTeacherPage: Scalars["Boolean"];
  showOnCommunityPage: Scalars["Boolean"];
  joiningLink?: Maybe<Scalars["String"]>;
  teacherReminderEmail?: Maybe<Scalars["DateTime"]>;
  contentTag: Array<ContentTagType>;
  teacherdetail?: Maybe<TeacherDetailType>;
  groupsessionpeoplejoiningSet: Array<GroupSessionPeopleJoiningType>;
  wonecalendareventSet: Array<WoneCalendarEventType>;
  recordingDurationText?: Maybe<Scalars["String"]>;
  calendarInvitesInitiated?: Maybe<Scalars["Int"]>;
  calendarInvitesSent?: Maybe<Scalars["Int"]>;
  calendarInvitesAccepted?: Maybe<Scalars["Int"]>;
  calendarInvitesDeclined?: Maybe<Scalars["Int"]>;
  calendarInvitesTentative?: Maybe<Scalars["Int"]>;
  calendarInvitesNeedsAction?: Maybe<Scalars["Int"]>;
  isLeadingTheSession?: Maybe<Scalars["Boolean"]>;
  sessionEndDateTime?: Maybe<Scalars["DateTime"]>;
};

export type GroupSessionPeopleJoiningType = {
  __typename?: "GroupSessionPeopleJoiningType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  groupSessionInstance: GroupSessionInstanceType;
  user?: Maybe<UserType>;
  userReminderEmail?: Maybe<Scalars["DateTime"]>;
  userFeedbackEmail?: Maybe<Scalars["DateTime"]>;
  sessionRegistrationPlatform?: Maybe<Scalars["String"]>;
  hasJoined: Scalars["Boolean"];
  sessionJoiningPlatform?: Maybe<Scalars["String"]>;
};

export type GroupSessionReportDataInput = {
  at: Scalars["String"];
  platform: Scalars["String"];
  groupUuid?: Maybe<Scalars["ID"]>;
};

export enum GroupSessionStatus {
  Scheduled = "SCHEDULED",
  Cancelled = "CANCELLED",
}

export type GroupSessionType = {
  __typename?: "GroupSessionType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  groupSessionFor: GroupSessionGroupSessionFor;
  photo?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  service: ServiceType1;
  classObj: TeacherClassModelType;
  description: Scalars["String"];
  startDate: Scalars["Date"];
  stopDate?: Maybe<Scalars["Date"]>;
  repeatWeekly: Scalars["Boolean"];
  startTime?: Maybe<Scalars["String"]>;
  endTime?: Maybe<Scalars["String"]>;
  displayEndTime?: Maybe<Scalars["Time"]>;
  preparationMaterial: Scalars["String"];
  corporateCompany?: Maybe<CorporateCompanyType>;
  pillar?: Maybe<PillarType>;
  calendarInviteTitle?: Maybe<Scalars["String"]>;
  calendarInviteDescription?: Maybe<Scalars["String"]>;
  status: GroupSessionStatus;
  reasonForCancellation?: Maybe<Scalars["String"]>;
  cancelledAt?: Maybe<Scalars["DateTime"]>;
  cancelledBy?: Maybe<UserType>;
  groupsessioninstanceSet: Array<GroupSessionInstanceType>;
  day?: Maybe<Scalars["String"]>;
  duration?: Maybe<Scalars["Int"]>;
};

export type Hris = {
  __typename?: "HRIS";
  title: Scalars["String"];
  subTitle: Scalars["String"];
  connections?: Maybe<Array<Maybe<Connections>>>;
  link: Scalars["String"];
};

export type HrSystemConnectionLink = {
  __typename?: "HrSystemConnectionLink";
  error?: Maybe<Scalars["String"]>;
  link?: Maybe<Scalars["String"]>;
};

export type ImageInput = {
  __typename?: "ImageInput";
  id: Scalars["String"];
  label: Scalars["String"];
  required: Scalars["Boolean"];
  value?: Maybe<Scalars["String"]>;
};

export type IndexScoreSnapshot = {
  __typename?: "IndexScoreSnapshot";
  id: Scalars["ID"];
  takenAt: Scalars["DateTime"];
  responseId: Scalars["ID"];
  overallIndex: OverallIndexScore;
  summary: Scalars["String"];
  categories: Array<Maybe<CategoryScore>>;
  domains: Array<Maybe<DomainScore>>;
  themes: Array<Maybe<ThemeScore>>;
  items: Array<Maybe<ItemScore>>;
};

export enum IndexScreenVersion {
  V1 = "v1",
  V2 = "v2",
}

export type Input =
  | SelectInput
  | MultiSelectInput
  | TextInput
  | DateInput
  | BooleanInput
  | RangeInput
  | ImageInput;

export type InputScreens = SingleInputScreen | MultipleInputsScreen;

export type IntegrationsScreen = {
  __typename?: "IntegrationsScreen";
  title: Scalars["String"];
  subTitle: Scalars["String"];
  domains: Domains;
  sso: CompanySso;
  hris: Hris;
};

export type IntroScreen = {
  __typename?: "IntroScreen";
  imageUrl: Scalars["String"];
  titleHtml: Scalars["String"];
  subtitleHtml: Scalars["String"];
  buttonText: Scalars["String"];
  skipButtonText: Scalars["String"];
  logoutButtonText: Scalars["String"];
};

export type InvitationType = {
  __typename?: "InvitationType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  session: ClassSessionType;
  guestUser?: Maybe<StudentDetailType>;
  guestUserEmail?: Maybe<Scalars["String"]>;
  hasAccepted: Scalars["Boolean"];
  hasJoined: Scalars["Boolean"];
};

export type IsUpgradeNeededType = {
  __typename?: "IsUpgradeNeededType";
  upgradeNeeded?: Maybe<Scalars["Boolean"]>;
};

export type ItemScore = BaseScore & {
  __typename?: "ItemScore";
  id?: Maybe<Scalars["ID"]>;
  shorthand: Scalars["String"];
  name: Scalars["String"];
  value?: Maybe<Scalars["Float"]>;
  minValue: Scalars["Float"];
  maxValue: Scalars["Float"];
  label?: Maybe<Scalars["String"]>;
  blurb?: Maybe<Scalars["String"]>;
  itemId?: Maybe<Scalars["ID"]>;
  themeShorthand: Scalars["String"];
};

export type LeanerCreateAccountOption = {
  __typename?: "LeanerCreateAccountOption";
  id: Scalars["String"];
  name: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
};

export type Learner = {
  __typename?: "Learner";
  id: Scalars["ID"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  fullName: Scalars["String"];
  email: Scalars["String"];
  companyName: Scalars["String"];
  language: Scalars["String"];
  photoUrl?: Maybe<Scalars["String"]>;
  oriDisclaimerAccepted?: Maybe<Scalars["Boolean"]>;
  onboarding?: Maybe<LearnerOnboardingForm>;
  afterGroupSessionFeedbackForm?: Maybe<LearnerAfterGroupSessionFeedbackForm>;
  screens: LearnerScreens;
  biometrics?: Maybe<LearnerBiometrics>;
  featureFlags?: Maybe<Array<Maybe<LearnerFeatureFlag>>>;
  indexScores: LearnerIndexScores;
  assessmentSchedule: AssessmentSchedule;
};

export type LearnerAfterGroupSessionFeedbackForm = {
  __typename?: "LearnerAfterGroupSessionFeedbackForm";
  messages: Array<Maybe<FeedbackMessage>>;
  biometricsBubble?: Maybe<LearnerBiometricsSessionFeedbackBubble>;
  sessionsAttendedThisMonth: LearnerSessionsAttendedThisMonth;
};

export type LearnerArticle = {
  __typename?: "LearnerArticle";
  id: Scalars["ID"];
  title: Scalars["String"];
  subtitle: Scalars["String"];
  author: Scalars["String"];
  readTime: Scalars["String"];
  pillarLabel: PillarLabel;
  filterTags: Array<Scalars["String"]>;
  imageUrl: Scalars["String"];
  contentHtml: Scalars["String"];
  isFavourite: Scalars["Boolean"];
};

export type LearnerArticleFeedback = {
  __typename?: "LearnerArticleFeedback";
  ok?: Maybe<Scalars["Boolean"]>;
};

export type LearnerArticleFeedbackInput = {
  articleId: Scalars["ID"];
  response: StructuredArticleFeedbackResponseInput;
};

export type LearnerArticlesContentList =
  | LearnerFeaturedArticleList
  | LearnerArticlesList;

export type LearnerArticlesList = LearnerContentListInterface & {
  __typename?: "LearnerArticlesList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerArticle>;
};

export type LearnerArticlesListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerArticlesScreen = {
  __typename?: "LearnerArticlesScreen";
  title: Scalars["String"];
  contentList: LearnerArticlesList;
  filteredContentList: LearnerArticlesList;
  landingContentLists: Array<LearnerArticlesContentList>;
};

export type LearnerArticlesScreenContentListArgs = {
  filters?: Maybe<LearnerContentListFilters>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerArticlesScreenFilteredContentListArgs = {
  filters?: Maybe<LearnerContentListFilters>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerBeforeGroupSessionFeedbackForm = {
  __typename?: "LearnerBeforeGroupSessionFeedbackForm";
  messages: Array<Maybe<FeedbackMessage>>;
  biometricsBubble?: Maybe<LearnerBiometricsSessionFeedbackBubble>;
};

export type LearnerBeforeJoiningGroupSessionFeedbackForm = {
  __typename?: "LearnerBeforeJoiningGroupSessionFeedbackForm";
  title: Scalars["String"];
  messages: Array<Maybe<Message>>;
  buttonText: Scalars["String"];
  biometricsBubble?: Maybe<LearnerBiometricsSessionFeedbackBubble>;
};

export type LearnerBiometrics = {
  __typename?: "LearnerBiometrics";
  vitalUserId?: Maybe<Scalars["ID"]>;
  providers: Array<LearnerBiometricsProvider>;
  hasHealthData: Scalars["Boolean"];
  modal?: Maybe<LearnerBiometricsModal>;
  shouldShowWebModal: Scalars["Boolean"];
  hasExperiencedTheAppleHealthConnectionPermissionsIssue: Scalars["Boolean"];
};

export type LearnerBiometricsConnectProvider = {
  __typename?: "LearnerBiometricsConnectProvider";
  ok: Scalars["Boolean"];
  learner: Learner;
  vitalUserId: Scalars["String"];
  vitalLinkToken: Scalars["String"];
  vitalLinkUrl: Scalars["String"];
};

export type LearnerBiometricsDeleteHealthData = {
  __typename?: "LearnerBiometricsDeleteHealthData";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerBiometricsDeviceConnection = {
  __typename?: "LearnerBiometricsDeviceConnection";
  intro: LearnerBiometricsDeviceConnectionIntro;
  input: SingleInputScreen;
  missingDeviceInput: SingleInputScreen;
  ready: LearnerBiometricsDeviceConnectionReady;
};

export type LearnerBiometricsDeviceConnectionIntro = {
  __typename?: "LearnerBiometricsDeviceConnectionIntro";
  sections: Array<Maybe<LearnerBiometricsDeviceConnectionIntroSection>>;
  buttonText: Scalars["String"];
};

export type LearnerBiometricsDeviceConnectionIntroSection = {
  __typename?: "LearnerBiometricsDeviceConnectionIntroSection";
  title: Scalars["String"];
  contentHtml: Scalars["String"];
};

export type LearnerBiometricsDeviceConnectionReady = {
  __typename?: "LearnerBiometricsDeviceConnectionReady";
  title: Scalars["String"];
  contentHtml: Scalars["String"];
  buttonText: Scalars["String"];
};

export type LearnerBiometricsDisconnectProvider = {
  __typename?: "LearnerBiometricsDisconnectProvider";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerBiometricsDismissWebModal = {
  __typename?: "LearnerBiometricsDismissWebModal";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerBiometricsHowItWorks = {
  __typename?: "LearnerBiometricsHowItWorks";
  title: Scalars["String"];
  headingTitle: Scalars["String"];
  headingContentHtml: Scalars["String"];
  callToAction?: Maybe<LearnerBiometricsHowItWorksCallToAction>;
  sections: Array<LearnerBiometricsHowItWorksSection>;
};

export type LearnerBiometricsHowItWorksCallToAction = {
  __typename?: "LearnerBiometricsHowItWorksCallToAction";
  title: Scalars["String"];
  buttonText: Scalars["String"];
};

export type LearnerBiometricsHowItWorksSection = {
  __typename?: "LearnerBiometricsHowItWorksSection";
  title: Scalars["String"];
  items: Array<LearnerBiometricsHowItWorksSectionItem>;
};

export type LearnerBiometricsHowItWorksSectionItem = {
  __typename?: "LearnerBiometricsHowItWorksSectionItem";
  title: Scalars["String"];
  contentHtml: Scalars["String"];
};

export type LearnerBiometricsModal = {
  __typename?: "LearnerBiometricsModal";
  title: Scalars["String"];
  contentHtml: Scalars["String"];
  tellMeMoreButtonText: Scalars["String"];
  remindMeLaterButtonText: Scalars["String"];
  dontAskAgainButtonText: Scalars["String"];
};

export type LearnerBiometricsModalDontAskAgain = {
  __typename?: "LearnerBiometricsModalDontAskAgain";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerBiometricsModalRemindMeLater = {
  __typename?: "LearnerBiometricsModalRemindMeLater";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerBiometricsModalTellMeMore = {
  __typename?: "LearnerBiometricsModalTellMeMore";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerBiometricsProvider = {
  __typename?: "LearnerBiometricsProvider";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type LearnerBiometricsProviders = {
  __typename?: "LearnerBiometricsProviders";
  title: Scalars["String"];
  providers: Array<LearnerBiometricsProvider>;
};

export type LearnerBiometricsReportMissingDevice = {
  __typename?: "LearnerBiometricsReportMissingDevice";
  ok: Scalars["Boolean"];
};

export type LearnerBiometricsSessionFeedbackBubble = {
  __typename?: "LearnerBiometricsSessionFeedbackBubble";
  title: Scalars["String"];
  contentHtml: Scalars["String"];
};

export type LearnerBiometricsSettings = {
  __typename?: "LearnerBiometricsSettings";
  providers: LearnerBiometricsProviders;
  howItWorks: LearnerBiometricsHowItWorks;
};

export type LearnerCalendarInvitePermissionSettings = {
  __typename?: "LearnerCalendarInvitePermissionSettings";
  title: Scalars["String"];
  toggles: Array<BooleanInput>;
};

export type LearnerCalendarSettings = {
  __typename?: "LearnerCalendarSettings";
  title: Scalars["String"];
  toggles: Array<BooleanInput>;
};

export type LearnerContentList =
  | LearnerFeaturedSessionList
  | LearnerSessionsList
  | LearnerGroupSessionsList
  | LearnerPrivateSessionsList
  | LearnerRecordingsList
  | LearnerFeaturedRecordingList
  | LearnerFeaturedArticleList
  | LearnerArticlesList
  | LearnerPractitionersList;

export type LearnerContentListFilters = {
  services?: Maybe<Array<Maybe<Scalars["String"]>>>;
  pillarLabels?: Maybe<Array<Maybe<PillarLabel>>>;
  durations?: Maybe<Array<Maybe<Scalars["String"]>>>;
  type?: Maybe<Array<Maybe<Scalars["String"]>>>;
  topics?: Maybe<Array<Maybe<Scalars["String"]>>>;
  intensity?: Maybe<Array<Maybe<Scalars["String"]>>>;
  format?: Maybe<Array<Maybe<Scalars["String"]>>>;
  setup?: Maybe<Array<Maybe<Scalars["String"]>>>;
  practitioners?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type LearnerContentListInterface = {
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerContentScreen = {
  __typename?: "LearnerContentScreen";
  contentLists: Array<Maybe<LearnerContentList>>;
};

export type LearnerContentScreenContentListsArgs = {
  filters?: Maybe<LearnerContentListFilters>;
};

export type LearnerCreateAccountScreen = {
  __typename?: "LearnerCreateAccountScreen";
  titleHtml: Scalars["String"];
  subtitleHtml?: Maybe<Scalars["String"]>;
  singleSignOnMessageHtml?: Maybe<Scalars["String"]>;
  singleSignOnOptions?: Maybe<Array<LeanerCreateAccountOption>>;
  createPasswordMessageHtml?: Maybe<Scalars["String"]>;
  createPasswordButtonText: Scalars["String"];
  createPasswordOption?: Maybe<LeanerCreateAccountOption>;
  error?: Maybe<LearnerCreateAccountScreenError>;
};

export type LearnerCreateAccountScreenError = {
  __typename?: "LearnerCreateAccountScreenError";
  title: Scalars["String"];
  subTitle?: Maybe<Scalars["String"]>;
  message: Scalars["String"];
  buttonAction: Scalars["String"];
  buttonText?: Maybe<Scalars["String"]>;
};

export type LearnerCreateGoogleConnectionLink = {
  __typename?: "LearnerCreateGoogleConnectionLink";
  ok: Scalars["Boolean"];
  link: Scalars["String"];
};

export type LearnerCreateOutlookConnectionLink = {
  __typename?: "LearnerCreateOutlookConnectionLink";
  ok: Scalars["Boolean"];
  link: Scalars["String"];
};

export type LearnerDeleteOndemandCalendar = {
  __typename?: "LearnerDeleteOndemandCalendar";
  ok: Scalars["Boolean"];
  learnerRecording: LearnerRecording;
};

export type LearnerDismissIndexCtaPrompt = {
  __typename?: "LearnerDismissIndexCTAPrompt";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerEquipment = {
  __typename?: "LearnerEquipment";
  id: Scalars["ID"];
  label: Scalars["String"];
  icon: Scalars["String"];
};

export type LearnerExercise = {
  __typename?: "LearnerExercise";
  title: Scalars["String"];
  subTitle: Scalars["String"];
  videoUrl: Scalars["String"];
  videoThumbnailUrl: Scalars["String"];
  buttonText: Scalars["String"];
};

export type LearnerExternalAssessmentComplete = {
  __typename?: "LearnerExternalAssessmentComplete";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerFavorableItem =
  | LearnerRecording
  | LearnerArticle
  | LearnerPractitioner;

export type LearnerFavourite = {
  __typename?: "LearnerFavourite";
  ok: Scalars["Boolean"];
  item: LearnerFavorableItem;
};

export type LearnerFavourites = {
  __typename?: "LearnerFavourites";
  title: Scalars["String"];
  recordings: LearnerFavouritesRecordings;
  articles: LearnerFavouritesArticles;
};

export type LearnerFavouritesArticles = {
  __typename?: "LearnerFavouritesArticles";
  count: Scalars["Int"];
  label: Scalars["String"];
  contentList: LearnerArticlesList;
};

export type LearnerFavouritesRecordings = {
  __typename?: "LearnerFavouritesRecordings";
  count: Scalars["Int"];
  label: Scalars["String"];
  contentList: LearnerRecordingsList;
};

export type LearnerFavouritesScreen = {
  __typename?: "LearnerFavouritesScreen";
  title: Scalars["String"];
  recordingsList: LearnerRecordingsList;
  articlesList: LearnerArticlesList;
};

export type LearnerFeatureFlag = {
  __typename?: "LearnerFeatureFlag";
  name: Scalars["String"];
  enabled: Scalars["Boolean"];
};

export type SetOwnFeatureFlag = {
  __typename?: "SetOwnFeatureFlag";
  ok: Scalars["Boolean"];
  flags: Array<LearnerFeatureFlag>;
};

export type LearnerFeaturedArticleList = LearnerContentListInterface & {
  __typename?: "LearnerFeaturedArticleList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerArticle>;
};

export type LearnerFeaturedArticleListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerFeaturedRecordingList = LearnerContentListInterface & {
  __typename?: "LearnerFeaturedRecordingList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerRecording>;
};

export type LearnerFeaturedRecordingListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerFeaturedSessionList = LearnerContentListInterface & {
  __typename?: "LearnerFeaturedSessionList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerSession>;
};

export type LearnerFeaturedSessionListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerGoogleAddEvents = {
  __typename?: "LearnerGoogleAddEvents";
  ok: Scalars["Boolean"];
  events?: Maybe<Array<Maybe<WoneCalendarEventType>>>;
};

export type LearnerGoogleReadCalendarEvents = {
  __typename?: "LearnerGoogleReadCalendarEvents";
  ok: Scalars["Boolean"];
  events?: Maybe<Array<Maybe<Scalars["GenericScalar"]>>>;
};

export type LearnerGroupSession = LearnerSessionInterface & {
  __typename?: "LearnerGroupSession";
  id: Scalars["ID"];
  title: Scalars["String"];
  subtitle: Scalars["String"];
  date: Scalars["String"];
  time: Scalars["String"];
  timeZone: Scalars["String"];
  about: Scalars["String"];
  equipment?: Maybe<Array<LearnerEquipment>>;
  preparation?: Maybe<LearnerSessionPreparation>;
  pillarLabel: PillarLabel;
  service: Scalars["String"];
  topic?: Maybe<Scalars["String"]>;
  duration: Scalars["String"];
  filterTags: Array<Scalars["String"]>;
  imageUrl: Scalars["String"];
  practitioner: LearnerPractitioner;
  /** @deprecated Use button_state instead. */
  actionButtons: Array<LearnerGroupSessionActionButton>;
  /** @deprecated Use button_state instead. */
  buttons: LearnerGroupSessionActionButtons;
  buttonState: LearnerGroupSessionButtonState;
  biometrics?: Maybe<LearnerSessionBiometrics>;
};

export enum LearnerGroupSessionAction {
  Register = "REGISTER",
  Unregister = "UNREGISTER",
  Join = "JOIN",
  TrackBiometrics = "TRACK_BIOMETRICS",
}

export type LearnerGroupSessionActionButton = {
  __typename?: "LearnerGroupSessionActionButton";
  style: ButtonStyle;
  action?: Maybe<LearnerGroupSessionAction>;
  text: Scalars["String"];
};

export type LearnerGroupSessionActionButtons = {
  __typename?: "LearnerGroupSessionActionButtons";
  join?: Maybe<LearnerGroupSessionActionButton>;
  register?: Maybe<LearnerGroupSessionActionButton>;
  unRegister?: Maybe<LearnerGroupSessionActionButton>;
  trackBiometrics?: Maybe<LearnerGroupSessionActionButton>;
};

export type LearnerGroupSessionButtonState = {
  __typename?: "LearnerGroupSessionButtonState";
  isRegistered: Scalars["Boolean"];
  isSessionOngoing: Scalars["Boolean"];
  isSessionCompleted: Scalars["Boolean"];
  shouldEnableTrackBiometrics: Scalars["Boolean"];
};

export type LearnerGroupSessionFeedbackInput = {
  id: Scalars["String"];
  value: Scalars["String"];
};

export type LearnerGroupSessionsContentList =
  | LearnerFeaturedSessionList
  | LearnerGroupSessionsList;

export type LearnerGroupSessionsList = LearnerContentListInterface & {
  __typename?: "LearnerGroupSessionsList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerGroupSession>;
};

export type LearnerGroupSessionsListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerGroupSessionsScreen = {
  __typename?: "LearnerGroupSessionsScreen";
  title: Scalars["String"];
  contentList: LearnerGroupSessionsList;
  filteredContentList: LearnerGroupSessionsList;
  landingContentLists: Array<LearnerGroupSessionsContentList>;
};

export type LearnerGroupSessionsScreenContentListArgs = {
  filters?: Maybe<LearnerContentListFilters>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerGroupSessionsScreenFilteredContentListArgs = {
  filters?: Maybe<LearnerContentListFilters>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerHideIndexScreenExercise = {
  __typename?: "LearnerHideIndexScreenExercise";
  ok: Scalars["Boolean"];
  screen: LearnerIndexScreen;
};

export type LearnerHomeFeaturedCard = {
  __typename?: "LearnerHomeFeaturedCard";
  id: Scalars["String"];
  titleHtml: Scalars["String"];
  descriptionHtml: Scalars["String"];
  imageUrl: Scalars["String"];
  action: LearnerHomeFeaturedCardActionTypes;
};

export type LearnerHomeFeaturedCardActionChatWithYourWoneCoach = {
  __typename?: "LearnerHomeFeaturedCardActionChatWithYourWONECoach";
  url: Scalars["String"];
};

export type LearnerHomeFeaturedCardActionConnectBiometrics = {
  __typename?: "LearnerHomeFeaturedCardActionConnectBiometrics";
  /** @deprecated Use __typename instead instead. */
  id: Scalars["String"];
};

export type LearnerHomeFeaturedCardActionNavigate = {
  __typename?: "LearnerHomeFeaturedCardActionNavigate";
  /** @deprecated Use __typename instead instead. */
  id: Scalars["String"];
  path: Scalars["String"];
};

export type LearnerHomeFeaturedCardActionTakeAssessment = {
  __typename?: "LearnerHomeFeaturedCardActionTakeAssessment";
  /** @deprecated Use __typename instead instead. */
  id: Scalars["String"];
  assessmentUrl: Scalars["String"];
};

export type LearnerHomeFeaturedCardActionTypes =
  | LearnerHomeFeaturedCardActionConnectBiometrics
  | LearnerHomeFeaturedCardActionTakeAssessment
  | LearnerHomeFeaturedCardActionNavigate
  | LearnerHomeFeaturedCardActionChatWithYourWoneCoach;

export type LearnerHomeFeaturedList = {
  __typename?: "LearnerHomeFeaturedList";
  id: Scalars["String"];
  titleHtml: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  items: Array<Maybe<LearnerHomeFeaturedCard>>;
};

export type LearnerHomeScreen = {
  __typename?: "LearnerHomeScreen";
  titleHtml: Scalars["String"];
  article?: Maybe<LearnerArticle>;
  dailyPlan: LearnerMixedContentList;
  featured: LearnerHomeFeaturedList;
  forYou?: Maybe<LearnerMixedContentList>;
  continuePractising?: Maybe<LearnerRecordingsContentList>;
  recommendedForYou: LearnerRecordingsList;
  trendingNow: LearnerMixedContentList;
  upcomingLiveSessions: LearnerGroupSessionsList;
};

export type LearnerIndexAssessment = {
  __typename?: "LearnerIndexAssessment";
  count: Scalars["Int"];
  daysLeftToRetake: Scalars["Int"];
  insights?: Maybe<LearnerIndexInsights>;
};

export type LearnerIndexBiometrics = {
  __typename?: "LearnerIndexBiometrics";
  sessionsHistory: LearnerIndexBiometricsSessionsHistory;
};

export type LearnerIndexBiometricsSessionsHistory = {
  __typename?: "LearnerIndexBiometricsSessionsHistory";
  state: LearnerIndexBiometricsSessionsHistoryState;
  contentList: LearnerGroupSessionsList;
  callToActionTitle?: Maybe<Scalars["String"]>;
  callToActionContentHtml?: Maybe<Scalars["String"]>;
  callToActionButtonText?: Maybe<Scalars["String"]>;
};

export type LearnerIndexBiometricsSessionsHistoryContentListArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export enum LearnerIndexBiometricsSessionsHistoryState {
  DeviceNotConnected = "DEVICE_NOT_CONNECTED",
  NoSessionHistory = "NO_SESSION_HISTORY",
  HasSessionHistory = "HAS_SESSION_HISTORY",
}

export type LearnerIndexBreakdown = {
  __typename?: "LearnerIndexBreakdown";
  energy: LearnerIndexBreakdownPillar;
  resilience: LearnerIndexBreakdownPillar;
  activity: LearnerIndexBreakdownPillar;
  nutrition: LearnerIndexBreakdownPillar;
};

export type LearnerIndexBreakdownPillar = {
  __typename?: "LearnerIndexBreakdownPillar";
  pillarLabel: PillarLabel;
  title: Scalars["String"];
  subtitle: Scalars["String"];
  score?: Maybe<LearnerIndexScore>;
  descriptionHtml: Scalars["String"];
  contentLists: Array<LearnerIndexBreakdownPillarContentList>;
  plan: LearnerIndexBreakdownPillarPlan;
  status?: Maybe<PillarStatus>;
};

export type LearnerIndexBreakdownPillarContentList =
  LearnerContentListInterface & {
    __typename?: "LearnerIndexBreakdownPillarContentList";
    id: Scalars["String"];
    label: Scalars["String"];
    descriptionHtml?: Maybe<Scalars["String"]>;
    filters: Array<Maybe<MultiSelectInput>>;
    filterTags?: Maybe<Array<Scalars["String"]>>;
    services?: Maybe<Array<Scalars["String"]>>;
    pillarLabels?: Maybe<Array<Scalars["String"]>>;
    durations?: Maybe<Array<Scalars["String"]>>;
    searchQuery?: Maybe<Scalars["String"]>;
    first?: Maybe<Scalars["Int"]>;
    offset?: Maybe<Scalars["Int"]>;
    items: Array<LearnerIndexBreakdownPillarContentListItem>;
  };

export type LearnerIndexBreakdownPillarContentListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerIndexBreakdownPillarContentListItem =
  | LearnerGroupSession
  | LearnerRecording
  | LearnerArticle;

export type LearnerIndexBreakdownPillarPlan = {
  __typename?: "LearnerIndexBreakdownPillarPlan";
  descriptionHtml?: Maybe<Scalars["String"]>;
  contentLists: Array<LearnerIndexBreakdownPillarPlanContentList>;
};

export type LearnerIndexBreakdownPillarPlanContentList =
  | LearnerGroupSessionsList
  | LearnerRecordingsList
  | LearnerArticlesList;

export type LearnerIndexCtaAction =
  | LearnerIndexCtaActionConnectBiometrics
  | LearnerIndexCtaActionTakeAssessment;

export type LearnerIndexCtaActionConnectBiometrics =
  LearnerIndexCtaActionInterface & {
    __typename?: "LearnerIndexCTAActionConnectBiometrics";
    buttonText: Scalars["String"];
  };

export type LearnerIndexCtaActionInterface = {
  buttonText: Scalars["String"];
};

export type LearnerIndexCtaActionTakeAssessment =
  LearnerIndexCtaActionInterface & {
    __typename?: "LearnerIndexCTAActionTakeAssessment";
    buttonText: Scalars["String"];
    assessmentUrl: Scalars["String"];
  };

export type LearnerIndexCtaActions = {
  __typename?: "LearnerIndexCTAActions";
  takeAssessment?: Maybe<LearnerIndexCtaActionTakeAssessment>;
  connectBiometrics?: Maybe<LearnerIndexCtaActionConnectBiometrics>;
};

export type LearnerIndexCtaPrompt = {
  __typename?: "LearnerIndexCTAPrompt";
  id: Scalars["ID"];
  imageUrl: Scalars["String"];
  descriptionHtml: Scalars["String"];
  variant: LearnerIndexCtaPromptVariant;
  action: LearnerIndexCtaAction;
};

export enum LearnerIndexCtaPromptVariant {
  Toast = "TOAST",
  Inline = "INLINE",
}

export type LearnerIndexCtAs = {
  __typename?: "LearnerIndexCTAs";
  actions?: Maybe<LearnerIndexCtaActions>;
  prompts: Array<LearnerIndexCtaPrompt>;
};

export type LearnerIndexCoach = {
  __typename?: "LearnerIndexCoach";
  name: Scalars["String"];
  avatarUrl: Scalars["String"];
  messageTextHtml: Scalars["String"];
  assessmentButton?: Maybe<AssessmentButton>;
};

export type LearnerIndexInsights = {
  __typename?: "LearnerIndexInsights";
  context: Scalars["String"];
  encouragement: Scalars["String"];
  pillar: Scalars["String"];
  theme: Scalars["String"];
  tips: Scalars["String"];
};

export type LearnerIndexProgress = {
  __typename?: "LearnerIndexProgress";
  title: Scalars["String"];
  labels: Array<Scalars["String"]>;
  minValue: Scalars["Int"];
  maxValue: Scalars["Int"];
  energyData: LearnerIndexProgressData;
  resilienceData: LearnerIndexProgressData;
  activityData: LearnerIndexProgressData;
};

export type LearnerIndexProgressData = {
  __typename?: "LearnerIndexProgressData";
  label: Scalars["String"];
  values: Array<Scalars["Int"]>;
};

export type LearnerIndexScore = {
  __typename?: "LearnerIndexScore";
  pillarLabel?: Maybe<PillarLabel>;
  value?: Maybe<Scalars["String"]>;
  valueFloat?: Maybe<Scalars["Float"]>;
  labelHtml: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  icon?: Maybe<Scalars["String"]>;
  /** @deprecated Use graph instead */
  data: LearnerIndexScoreData;
  pattern?: Maybe<Scalars["WONEGeneratorPattern"]>;
  assessmentButton?: Maybe<AssessmentButton>;
  change?: Maybe<LearnerIndexScoreChange>;
  graph?: Maybe<LearnerIndexScoreGraph>;
};

export type LearnerIndexScoreDataArgs = {
  pillarLabel?: Maybe<PillarLabel>;
  periodLength?: Maybe<LearnerIndexScoreDataPeriodLength>;
  startDate?: Maybe<Scalars["Date"]>;
  endDate?: Maybe<Scalars["Date"]>;
};

export type LearnerIndexScoreGraphArgs = {
  pillarLabel?: Maybe<PillarLabel>;
};

export type LearnerIndexScoreChange = {
  __typename?: "LearnerIndexScoreChange";
  percentage: Scalars["Float"];
  daysSinceStart: Scalars["Int"];
  textHtml: Scalars["String"];
  shortTextHtml: Scalars["String"];
  direction: LearnerIndexScoreChangeDirection;
  startScore: Scalars["Float"];
  startDate: Scalars["Date"];
  endScore: Scalars["Float"];
  endDate: Scalars["Date"];
};

export enum LearnerIndexScoreChangeDirection {
  Up = "UP",
  Down = "DOWN",
  NoChange = "NO_CHANGE",
}

export type LearnerIndexScoreData = {
  __typename?: "LearnerIndexScoreData";
  pillarLabel?: Maybe<PillarLabel>;
  periods: LearnerIndexScoreDataPeriods;
  /** @deprecated Use periods instead */
  periodLength: LearnerIndexScoreDataPeriodLength;
  startDate: Scalars["String"];
  endDate: Scalars["String"];
  /** @deprecated Use periods instead */
  dataPoints: Array<LearnerIndexScoreDataPoint>;
};

export type LearnerIndexScoreDataPeriodsArgs = {
  pillarLabel?: Maybe<PillarLabel>;
};

export type LearnerIndexScoreDataPeriod = {
  __typename?: "LearnerIndexScoreDataPeriod";
  pillarLabel?: Maybe<PillarLabel>;
  previousLabel?: Maybe<Scalars["String"]>;
  nextLabel?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  startDate: Scalars["Date"];
  endDate: Scalars["Date"];
  hasAssessmentValues: Scalars["Boolean"];
  hasBiometricsValues: Scalars["Boolean"];
  averageValue?: Maybe<Scalars["Int"]>;
  averageAssessmentStandaloneValue?: Maybe<Scalars["Int"]>;
  averageBiometricsStandaloneValue?: Maybe<Scalars["Int"]>;
  valueChange?: Maybe<LearnerIndexScoreChange>;
  assessmentStandaloneValueChange?: Maybe<LearnerIndexScoreChange>;
  biometricsStandaloneValueChange?: Maybe<LearnerIndexScoreChange>;
  dataPoints: Array<LearnerIndexScoreDataPoint>;
};

export enum LearnerIndexScoreDataPeriodLength {
  Week = "WEEK",
  Month = "MONTH",
  Year = "YEAR",
}

export type LearnerIndexScoreDataPeriods = {
  __typename?: "LearnerIndexScoreDataPeriods";
  pillarLabel?: Maybe<PillarLabel>;
  week: Array<LearnerIndexScoreDataPeriod>;
  month: Array<LearnerIndexScoreDataPeriod>;
  year: Array<LearnerIndexScoreDataPeriod>;
};

export type LearnerIndexScoreDataPeriodsWeekArgs = {
  fake?: Maybe<Scalars["Boolean"]>;
  pillarLabel?: Maybe<PillarLabel>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerIndexScoreDataPeriodsMonthArgs = {
  fake?: Maybe<Scalars["Boolean"]>;
  pillarLabel?: Maybe<PillarLabel>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerIndexScoreDataPeriodsYearArgs = {
  fake?: Maybe<Scalars["Boolean"]>;
  pillarLabel?: Maybe<PillarLabel>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerIndexScoreDataPoint = {
  __typename?: "LearnerIndexScoreDataPoint";
  date: Scalars["Date"];
  label: Scalars["String"];
  value?: Maybe<Scalars["Int"]>;
  assessmentValue?: Maybe<Scalars["Int"]>;
  assessmentStandaloneValue?: Maybe<Scalars["Int"]>;
  biometricsValue?: Maybe<Scalars["Int"]>;
  biometricsStandaloneValue?: Maybe<Scalars["Int"]>;
};

export type LearnerIndexScoreGraph = {
  __typename?: "LearnerIndexScoreGraph";
  pillarLabel?: Maybe<PillarLabel>;
  scoreTitle: Scalars["String"];
  scoreSubtitle: Scalars["String"];
  assessmentScoreTitle: Scalars["String"];
  assessmentScoreSubtitle: Scalars["String"];
  biometricsScoreTitle: Scalars["String"];
  biometricsScoreSubtitle: Scalars["String"];
  periods: LearnerIndexScoreDataPeriods;
};

export type LearnerIndexScoreGraphPeriodsArgs = {
  pillarLabel?: Maybe<PillarLabel>;
};

export type LearnerIndexScores = {
  __typename?: "LearnerIndexScores";
  overallIndex?: Maybe<OverallIndexScore>;
  summary: Scalars["String"];
  categories: Array<Maybe<CategoryScore>>;
  domains: Array<Maybe<DomainScore>>;
  themes: Array<Maybe<ThemeScore>>;
  items: Array<Maybe<ItemScore>>;
  takenAt?: Maybe<Scalars["DateTime"]>;
  responseId?: Maybe<Scalars["ID"]>;
  history: Array<Maybe<IndexScoreSnapshot>>;
};

export type LearnerIndexScoresHistoryArgs = {
  limit?: Maybe<Scalars["Int"]>;
  startDate?: Maybe<Scalars["DateTime"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
  scoreTypes?: Maybe<Array<Maybe<ScoreType>>>;
};

export type LearnerIndexScreen = {
  __typename?: "LearnerIndexScreen";
  version: IndexScreenVersion;
  showBetaFlag: Scalars["Boolean"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  score?: Maybe<LearnerIndexScore>;
  exercise?: Maybe<LearnerExercise>;
  heartrate?: Maybe<Scalars["String"]>;
  coach?: Maybe<LearnerIndexCoach>;
  breakdown?: Maybe<LearnerIndexBreakdown>;
  progress?: Maybe<LearnerIndexProgress>;
  biometrics?: Maybe<LearnerIndexBiometrics>;
  CTAs?: Maybe<LearnerIndexCtAs>;
  assessment?: Maybe<LearnerIndexAssessment>;
};

export type LearnerJoinGroupSession = {
  __typename?: "LearnerJoinGroupSession";
  ok: Scalars["Boolean"];
  /** @deprecated Use learner_before_group_session_feedback_form instead */
  learnerBeforeJoiningGroupSessionFeedbackForm: LearnerBeforeJoiningGroupSessionFeedbackForm;
  learnerBeforeGroupSessionFeedbackForm?: Maybe<LearnerBeforeGroupSessionFeedbackForm>;
  zoomMtgNumber: Scalars["String"];
  zoomMtgPassWord?: Maybe<Scalars["String"]>;
  zoomMtgSignature: Scalars["String"];
};

export type LearnerJourney = {
  __typename?: "LearnerJourney";
  title: Scalars["String"];
  memberSince: Scalars["String"];
  discover?: Maybe<WelcomeScreen>;
  timeInvested?: Maybe<LearnerJourneyTimeInvested>;
  sessionsAttended?: Maybe<LearnerJourneySessionsAttended>;
};

export type LearnerJourneySessionsAttended = {
  __typename?: "LearnerJourneySessionsAttended";
  value: Scalars["String"];
  label: Scalars["String"];
};

export type LearnerJourneyTimeInvested = {
  __typename?: "LearnerJourneyTimeInvested";
  value: Scalars["String"];
  label: Scalars["String"];
  metric: Scalars["String"];
};

export type LearnerMembership = {
  __typename?: "LearnerMembership";
  title: Scalars["String"];
  type: Scalars["String"];
  advantages: LearnerMembershipAdvantages;
};

export type LearnerMembershipAdvantage = {
  __typename?: "LearnerMembershipAdvantage";
  name: Scalars["String"];
  description: Scalars["String"];
};

export type LearnerMembershipAdvantages = {
  __typename?: "LearnerMembershipAdvantages";
  heading: Scalars["String"];
  items: Array<LearnerMembershipAdvantage>;
};

export type LearnerMixedContentList = LearnerContentListInterface & {
  __typename?: "LearnerMixedContentList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerMixedContentListItem>;
};

export type LearnerMixedContentListItem =
  | LearnerGroupSession
  | LearnerRecording
  | LearnerArticle;

export type LearnerNotificationsSettings = {
  __typename?: "LearnerNotificationsSettings";
  title: Scalars["String"];
  toggles: Array<BooleanInput>;
};

export type LearnerOnDemandRecordingsScreen = {
  __typename?: "LearnerOnDemandRecordingsScreen";
  title: Scalars["String"];
  contentList: LearnerRecordingsList;
  filteredContentList: LearnerRecordingsList;
  landingContentLists: Array<LearnerRecordingsContentList>;
};

export type LearnerOnDemandRecordingsScreenContentListArgs = {
  filters?: Maybe<LearnerContentListFilters>;
};

export type LearnerOnDemandRecordingsScreenFilteredContentListArgs = {
  filters?: Maybe<LearnerContentListFilters>;
};

export type LearnerOnboarding = {
  __typename?: "LearnerOnboarding";
  ok: Scalars["Boolean"];
  learner: Learner;
  welcomeScreen: WelcomeScreen;
};

export type LearnerOnboardingForm = {
  __typename?: "LearnerOnboardingForm";
  intro: IntroScreen;
  inputs: Array<InputScreens>;
  animation: Array<Maybe<ProgressAnimationFrame>>;
};

export type LearnerOnboardingInput = {
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  gender?: Maybe<Scalars["String"]>;
  birthday?: Maybe<Scalars["String"]>;
  calendarPermission?: Maybe<Scalars["Boolean"]>;
  notificationsEnabled?: Maybe<Scalars["Boolean"]>;
};

export type LearnerOurMission = {
  __typename?: "LearnerOurMission";
  title: Scalars["String"];
  heading: Scalars["String"];
  imageUrl: Scalars["String"];
  contentHtml: Scalars["String"];
  isFavourite: Scalars["Boolean"];
};

export type LearnerOutlookAddEvents = {
  __typename?: "LearnerOutlookAddEvents";
  ok: Scalars["Boolean"];
  events?: Maybe<Array<Maybe<WoneCalendarEventType>>>;
};

export type LearnerOutlookReadCalendarEvents = {
  __typename?: "LearnerOutlookReadCalendarEvents";
  ok: Scalars["Boolean"];
  events?: Maybe<Array<Maybe<Scalars["GenericScalar"]>>>;
};

export type LearnerPractitioner = {
  __typename?: "LearnerPractitioner";
  id: Scalars["ID"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  fullName: Scalars["String"];
  photoUrl: Scalars["String"];
  landscapeImageUrl?: Maybe<Scalars["String"]>;
  services: Scalars["String"];
  about: Scalars["String"];
  accreditation?: Maybe<LearnerPractitionerAccreditation>;
  intro?: Maybe<LearnerPractitionerIntro>;
  contentLists: Array<LearnerPractitionerContentList>;
  isFavourite: Scalars["Boolean"];
};

export type LearnerPractitionerAccreditation = {
  __typename?: "LearnerPractitionerAccreditation";
  title: Scalars["String"];
  items?: Maybe<Array<Scalars["String"]>>;
  textHtml?: Maybe<Scalars["String"]>;
};

export type LearnerPractitionerContentList =
  | LearnerSessionsList
  | LearnerGroupSessionsList
  | LearnerPrivateSessionsList
  | LearnerRecordingsList;

export type LearnerPractitionerIntro = {
  __typename?: "LearnerPractitionerIntro";
  title: Scalars["String"];
  textHtml?: Maybe<Scalars["String"]>;
  videoUrl: Scalars["String"];
  videoThumbnailUrl: Scalars["String"];
};

export type LearnerPractitionersList = LearnerContentListInterface & {
  __typename?: "LearnerPractitionersList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerPractitioner>;
};

export type LearnerPractitionersListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerPrivateSession = LearnerSessionInterface & {
  __typename?: "LearnerPrivateSession";
  id: Scalars["ID"];
  title: Scalars["String"];
  subtitle: Scalars["String"];
  date: Scalars["String"];
  time: Scalars["String"];
  timeZone: Scalars["String"];
  about: Scalars["String"];
  equipment?: Maybe<Array<LearnerEquipment>>;
  preparation?: Maybe<LearnerSessionPreparation>;
  pillarLabel: PillarLabel;
  service: Scalars["String"];
  topic?: Maybe<Scalars["String"]>;
  duration: Scalars["String"];
  filterTags: Array<Scalars["String"]>;
  imageUrl: Scalars["String"];
  practitioner: LearnerPractitioner;
  /** @deprecated Use button_state instead. */
  actionButtons: Array<LearnerGroupSessionActionButton>;
  /** @deprecated Use button_state instead. */
  buttons: LearnerGroupSessionActionButtons;
  buttonState: LearnerGroupSessionButtonState;
  biometrics?: Maybe<LearnerSessionBiometrics>;
};

export type LearnerPrivateSessionsList = LearnerContentListInterface & {
  __typename?: "LearnerPrivateSessionsList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerPrivateSession>;
};

export type LearnerPrivateSessionsListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerProfileScreen = {
  __typename?: "LearnerProfileScreen";
  journey: LearnerJourney;
  favourites?: Maybe<LearnerFavourites>;
  settings?: Maybe<LearnerSettings>;
  contentLists: Array<LearnerGroupSessionsList>;
};

export type LearnerProfileSettings = {
  __typename?: "LearnerProfileSettings";
  title: Scalars["String"];
  fields: LearnerProfileSettingsFields;
};

export type LearnerProfileSettingsFields = {
  __typename?: "LearnerProfileSettingsFields";
  photoUrl: ImageInput;
  firstName: TextInput;
  lastName: TextInput;
  injuries: TextInput;
  birthday: DateInput;
  gender: SelectInput;
};

export type LearnerRecommendedRemoveItem = {
  __typename?: "LearnerRecommendedRemoveItem";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerRecommendedRemoveItemInput = {
  itemId: Scalars["ID"];
  typename: Scalars["String"];
  contentListId: Scalars["String"];
};

export type LearnerRecording = {
  __typename?: "LearnerRecording";
  id: Scalars["ID"];
  title: Scalars["String"];
  subtitle: Scalars["String"];
  pillarLabel: PillarLabel;
  service: Scalars["String"];
  topic?: Maybe<Scalars["String"]>;
  filterTags: Array<Scalars["String"]>;
  videoUrl: Scalars["String"];
  videoThumbnailUrl: Scalars["String"];
  videoDurationText: Scalars["String"];
  sessionDuration: Scalars["String"];
  imageUrl: Scalars["String"];
  about: Scalars["String"];
  equipment?: Maybe<Array<LearnerEquipment>>;
  practitioner: LearnerPractitioner;
  isFavourite: Scalars["Boolean"];
  scheduledCalendarEvent?: Maybe<LearnerScheduledCalendarEvent>;
};

export type LearnerRecordingsContentList =
  | LearnerFeaturedRecordingList
  | LearnerRecordingsList;

export type LearnerRecordingsList = LearnerContentListInterface & {
  __typename?: "LearnerRecordingsList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerRecording>;
};

export type LearnerRecordingsListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerRecordingsScreen = {
  __typename?: "LearnerRecordingsScreen";
  title: Scalars["String"];
  contentList: LearnerRecordingsList;
  filteredContentList: LearnerRecordingsList;
  landingContentLists: Array<LearnerRecordingsContentList>;
};

export type LearnerRecordingsScreenContentListArgs = {
  filters?: Maybe<LearnerContentListFilters>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerRecordingsScreenFilteredContentListArgs = {
  filters?: Maybe<LearnerContentListFilters>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerRegisterForGroupSession = {
  __typename?: "LearnerRegisterForGroupSession";
  ok: Scalars["Boolean"];
  learnerGroupSession: LearnerGroupSession;
};

export type LearnerRequestSignUpWithMagicLink = {
  __typename?: "LearnerRequestSignUpWithMagicLink";
  ok: Scalars["Boolean"];
  message: Scalars["String"];
};

export type LearnerRequestSignUpWithPassword = {
  __typename?: "LearnerRequestSignUpWithPassword";
  ok: Scalars["Boolean"];
  message: Scalars["String"];
};

export type LearnerRequestVitalSignInToken = {
  __typename?: "LearnerRequestVitalSignInToken";
  ok?: Maybe<Scalars["Boolean"]>;
  signInToken: Scalars["String"];
};

export type LearnerScheduleOndemandCalendar = {
  __typename?: "LearnerScheduleOndemandCalendar";
  ok: Scalars["Boolean"];
  learnerRecording: LearnerRecording;
};

export type LearnerScheduleScreen = {
  __typename?: "LearnerScheduleScreen";
  title: Scalars["String"];
  contentLists: Array<LearnerMixedContentList>;
};

export type LearnerScheduledCalendarEvent = {
  __typename?: "LearnerScheduledCalendarEvent";
  fromDatetimeUtc: Scalars["DateTime"];
  toDatetimeUtc: Scalars["DateTime"];
};

export type LearnerScreens = {
  __typename?: "LearnerScreens";
  you: LearnerYouScreen;
  sessions: LearnerGroupSessionsScreen;
  schedule: LearnerScheduleScreen;
  index: LearnerIndexScreen;
  recordings: LearnerRecordingsScreen;
  onDemandRecordings: LearnerOnDemandRecordingsScreen;
  articles: LearnerArticlesScreen;
  /** @deprecated No longer needed */
  favourites?: Maybe<LearnerFavouritesScreen>;
  /** @deprecated No longer needed */
  content?: Maybe<LearnerContentScreen>;
  profile: LearnerProfileScreen;
  home: LearnerHomeScreen;
};

export type LearnerSession = LearnerGroupSession | LearnerPrivateSession;

export type LearnerSessionBiometrics = {
  __typename?: "LearnerSessionBiometrics";
  id: Scalars["ID"];
  label: Scalars["String"];
  /** @deprecated Use heartrateGraph instead */
  heartrate?: Maybe<LearnerSessionBiometricsHeartrate>;
  heartrateGraph?: Maybe<LearnerSessionBiometricsHeartrateGraph>;
};

export type LearnerSessionBiometricsHeartrate = {
  __typename?: "LearnerSessionBiometricsHeartrate";
  startValue: Scalars["String"];
  endValue: Scalars["String"];
  differenceLabel: Scalars["String"];
  differenceValue: Scalars["String"];
  minValue: Scalars["Int"];
  maxValue: Scalars["Int"];
  labels: Array<Scalars["String"]>;
  values: Array<Scalars["Int"]>;
};

export type LearnerSessionBiometricsHeartrateGraph = {
  __typename?: "LearnerSessionBiometricsHeartrateGraph";
  startValueLabel: Scalars["String"];
  endValueLabel: Scalars["String"];
  diffMessage: Scalars["String"];
  diffValueLabel: Scalars["String"];
  minValue: Scalars["Int"];
  maxValue: Scalars["Int"];
  stepValue: Scalars["Int"];
  values: Array<Scalars["Float"]>;
  minTimeValue: Scalars["Int"];
  maxTimeValue: Scalars["Int"];
  stepTimeValue: Scalars["Int"];
  timeValues: Array<Scalars["Float"]>;
};

export type LearnerSessionInterface = {
  id: Scalars["ID"];
  title: Scalars["String"];
  subtitle: Scalars["String"];
  date: Scalars["String"];
  time: Scalars["String"];
  timeZone: Scalars["String"];
  about: Scalars["String"];
  equipment?: Maybe<Array<LearnerEquipment>>;
  preparation?: Maybe<LearnerSessionPreparation>;
  pillarLabel: PillarLabel;
  service: Scalars["String"];
  topic?: Maybe<Scalars["String"]>;
  duration: Scalars["String"];
  filterTags: Array<Scalars["String"]>;
  imageUrl: Scalars["String"];
  practitioner: LearnerPractitioner;
  /** @deprecated Use button_state instead. */
  actionButtons: Array<LearnerGroupSessionActionButton>;
  /** @deprecated Use button_state instead. */
  buttons: LearnerGroupSessionActionButtons;
  buttonState: LearnerGroupSessionButtonState;
  biometrics?: Maybe<LearnerSessionBiometrics>;
};

export type LearnerSessionPreparation = {
  __typename?: "LearnerSessionPreparation";
  title: Scalars["String"];
  textHtml?: Maybe<Scalars["String"]>;
};

export type LearnerSessionsAttendedThisMonth = {
  __typename?: "LearnerSessionsAttendedThisMonth";
  value: Scalars["String"];
  label: Scalars["String"];
};

export type LearnerSessionsList = LearnerContentListInterface & {
  __typename?: "LearnerSessionsList";
  id: Scalars["String"];
  label: Scalars["String"];
  descriptionHtml?: Maybe<Scalars["String"]>;
  filters: Array<Maybe<MultiSelectInput>>;
  filterTags?: Maybe<Array<Scalars["String"]>>;
  services?: Maybe<Array<Scalars["String"]>>;
  pillarLabels?: Maybe<Array<Scalars["String"]>>;
  durations?: Maybe<Array<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  items: Array<LearnerSession>;
};

export type LearnerSessionsListItemsArgs = {
  searchQuery?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type LearnerSettings = {
  __typename?: "LearnerSettings";
  title: Scalars["String"];
  canChangePassword: Scalars["Boolean"];
  profile: LearnerProfileSettings;
  notifications: LearnerNotificationsSettings;
  calendar?: Maybe<LearnerCalendarSettings>;
  ourMission: LearnerOurMission;
  membership: LearnerMembership;
  biometrics?: Maybe<LearnerBiometricsSettings>;
};

export type LearnerSignInOption = {
  __typename?: "LearnerSignInOption";
  id: Scalars["String"];
  name: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
};

export type LearnerSignInScreen = {
  __typename?: "LearnerSignInScreen";
  error?: Maybe<LearnerSignInScreenError>;
  option?: Maybe<LearnerSignInOption>;
};

export type LearnerSignInScreenError = {
  __typename?: "LearnerSignInScreenError";
  title: Scalars["String"];
  subTitle?: Maybe<Scalars["String"]>;
  message: Scalars["String"];
  buttonAction: Scalars["String"];
  buttonText?: Maybe<Scalars["String"]>;
};

export type LearnerSignUpError = {
  __typename?: "LearnerSignUpError";
  title: Scalars["String"];
  subTitle?: Maybe<Scalars["String"]>;
  message: Scalars["String"];
  buttonAction: Scalars["String"];
  buttonText?: Maybe<Scalars["String"]>;
};

export type LearnerSignUpOption = {
  __typename?: "LearnerSignUpOption";
  id: Scalars["String"];
  name: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
};

export type LearnerSignUpScreen = {
  __typename?: "LearnerSignUpScreen";
  error?: Maybe<LearnerSignUpError>;
  options?: Maybe<Array<Maybe<LearnerSignUpOption>>>;
};

export type LearnerSignUpWithPassword = {
  __typename?: "LearnerSignUpWithPassword";
  ok: Scalars["Boolean"];
  message: Scalars["String"];
  token?: Maybe<Scalars["String"]>;
};

export type LearnerSubmitAfterGroupSessionFeedback = {
  __typename?: "LearnerSubmitAfterGroupSessionFeedback";
  ok: Scalars["Boolean"];
};

export type LearnerSubmitAssessmentResults = {
  __typename?: "LearnerSubmitAssessmentResults";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerSubmitBeforeGroupSessionFeedback = {
  __typename?: "LearnerSubmitBeforeGroupSessionFeedback";
  ok: Scalars["Boolean"];
};

export type LearnerTrackBiometrics = {
  __typename?: "LearnerTrackBiometrics";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerUnFavourite = {
  __typename?: "LearnerUnFavourite";
  ok: Scalars["Boolean"];
  item: LearnerFavorableItem;
};

export type LearnerUnRegisterForGroupSession = {
  __typename?: "LearnerUnRegisterForGroupSession";
  ok: Scalars["Boolean"];
  learnerGroupSession: LearnerGroupSession;
};

export type LearnerUpdateCalendarSettingsToggle = {
  __typename?: "LearnerUpdateCalendarSettingsToggle";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerUpdateHoursPerWeek = {
  __typename?: "LearnerUpdateHoursPerWeek";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerUpdateLanguage = {
  __typename?: "LearnerUpdateLanguage";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerUpdateNotificationSettingsToggle = {
  __typename?: "LearnerUpdateNotificationSettingsToggle";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerUpdateProfileSettings = {
  __typename?: "LearnerUpdateProfileSettings";
  ok: Scalars["Boolean"];
  learner: Learner;
};

export type LearnerUpdateProfileSettingsInput = {
  photoUrl?: Maybe<Scalars["String"]>;
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  gender: Scalars["String"];
  injuries?: Maybe<Scalars["String"]>;
  birthday?: Maybe<Scalars["String"]>;
};

export type LearnerUpgradeIndexScreenVersion = {
  __typename?: "LearnerUpgradeIndexScreenVersion";
  ok: Scalars["Boolean"];
  screen: LearnerIndexScreen;
  message: Scalars["String"];
};

export type LearnerYouScreen = {
  __typename?: "LearnerYouScreen";
  welcome: WelcomeScreen;
  indexScore?: Maybe<LearnerIndexScore>;
  contentLists: Array<LearnerContentList>;
};

export type LocationType = {
  __typename?: "LocationType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  name: Scalars["String"];
  studentdetailSet: Array<StudentDetailType>;
  onboardingSet: Array<OnboardingType>;
  teacherdetailSet: Array<TeacherDetailType>;
};

export type Members = {
  __typename?: "Members";
  id: Scalars["ID"];
  member: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email: Scalars["String"];
  timezone: Scalars["String"];
  status: Scalars["String"];
  statusDate?: Maybe<Scalars["String"]>;
  action?: Maybe<Action>;
};

export type MembersScreen = {
  __typename?: "MembersScreen";
  title: Scalars["String"];
  subTitle: Scalars["String"];
  labels: Array<Maybe<Scalars["String"]>>;
  searchQuery?: Maybe<Scalars["String"]>;
  exampleCsv: Scalars["String"];
  uploadButton: Action;
  addButton: Action;
  totalPages: Scalars["Int"];
  itemsPerPage?: Maybe<Scalars["Int"]>;
  pageNumber?: Maybe<Scalars["Int"]>;
  statusSort?: Maybe<Scalars["Boolean"]>;
  members: Array<Maybe<Members>>;
};

export type Message = {
  __typename?: "Message";
  senderAvatarUrl: Scalars["String"];
  senderName: Scalars["String"];
  textHtml: Scalars["String"];
  input?: Maybe<Input>;
};

export type MultiSelectInput = {
  __typename?: "MultiSelectInput";
  id: Scalars["String"];
  label: Scalars["String"];
  required: Scalars["Boolean"];
  options: Array<SelectInputOption>;
};

export type MultipleInputsScreen = {
  __typename?: "MultipleInputsScreen";
  id: Scalars["String"];
  titleHtml: Scalars["String"];
  subtitleHtml?: Maybe<Scalars["String"]>;
  inputs: Array<Input>;
  buttonText?: Maybe<Scalars["String"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  createUpdateFcmDevice?: Maybe<CreateUpdateFcmDevice>;
  signIn?: Maybe<SignIn>;
  signInWithToken?: Maybe<SignInWithToken>;
  signOut?: Maybe<SignOut>;
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  verifyToken?: Maybe<Verify>;
  refreshToken?: Maybe<Refresh>;
  changePassword?: Maybe<ChangePassword>;
  resetPassword?: Maybe<ResetPassword>;
  resetPasswordWithLink?: Maybe<ResetPasswordWithLink>;
  /** @deprecated Use updatePasswordWithToken instead */
  changePasswordWithLink?: Maybe<ChangePasswordWithLink>;
  updatePasswordWithToken?: Maybe<UpdatePasswordWithToken>;
  reportAssessmentEvent?: Maybe<ReportAssessmentEvent>;
  reportRecordingOpen?: Maybe<ReportRecordingOpen>;
  reportRecordingVideoStart?: Maybe<ReportRecordingVideoStart>;
  reportRecordingVideoProgress?: Maybe<ReportRecordingVideoProgress>;
  reportRecordingVideoEnd?: Maybe<ReportRecordingVideoEnd>;
  reportArticleOpen?: Maybe<ReportArticleOpen>;
  reportArticleScrollStart?: Maybe<ReportArticleScrollStart>;
  reportArticleScrollProgress?: Maybe<ReportArticleScrollProgress>;
  reportArticleScrollEnd?: Maybe<ReportArticleScrollEnd>;
  reportGroupSessionLeft?: Maybe<ReportGroupSessionLeft>;
  reportGroupSessionPing?: Maybe<ReportGroupSessionPing>;
  userJoinedGroupSession?: Maybe<UserJoinedGroupSession>;
  learnerOnboarding?: Maybe<LearnerOnboarding>;
  learnerJoinGroupSession?: Maybe<LearnerJoinGroupSession>;
  learnerSubmitBeforeGroupSessionFeedback?: Maybe<LearnerSubmitBeforeGroupSessionFeedback>;
  learnerSubmitAfterGroupSessionFeedback?: Maybe<LearnerSubmitAfterGroupSessionFeedback>;
  learnerRegisterForGroupSession?: Maybe<LearnerRegisterForGroupSession>;
  learnerUnRegisterForGroupSession?: Maybe<LearnerUnRegisterForGroupSession>;
  learnerTrackBiometrics?: Maybe<LearnerTrackBiometrics>;
  learnerFavourite?: Maybe<LearnerFavourite>;
  learnerUnFavourite?: Maybe<LearnerUnFavourite>;
  learnerUpdateHoursPerWeek?: Maybe<LearnerUpdateHoursPerWeek>;
  learnerUpdateLanguage?: Maybe<LearnerUpdateLanguage>;
  learnerUpdateProfileSettings?: Maybe<LearnerUpdateProfileSettings>;
  learnerUpdateNotificationSettingsToggle?: Maybe<LearnerUpdateNotificationSettingsToggle>;
  learnerUpdateCalendarSettingsToggle?: Maybe<LearnerUpdateCalendarSettingsToggle>;
  learnerExternalAssessmentComplete?: Maybe<LearnerExternalAssessmentComplete>;
  learnerSubmitAssessmentResults?: Maybe<LearnerSubmitAssessmentResults>;
  startAssessment?: Maybe<StartAssessment>;
  learnerBiometricsConnectProvider?: Maybe<LearnerBiometricsConnectProvider>;
  learnerBiometricsReportMissingDevice?: Maybe<LearnerBiometricsReportMissingDevice>;
  learnerBiometricsDisconnectProvider?: Maybe<LearnerBiometricsDisconnectProvider>;
  learnerBiometricsDeleteHealthData?: Maybe<LearnerBiometricsDeleteHealthData>;
  learnerBiometricsModalTellMeMore?: Maybe<LearnerBiometricsModalTellMeMore>;
  learnerBiometricsModalRemindMeLater?: Maybe<LearnerBiometricsModalRemindMeLater>;
  learnerBiometricsModalDontAskAgain?: Maybe<LearnerBiometricsModalDontAskAgain>;
  requestSignInWithMagicLink?: Maybe<RequestSignInWithMagicLink>;
  learnerRequestSignUpWithPassword?: Maybe<LearnerRequestSignUpWithPassword>;
  learnerRequestSignUpWithMagicLink?: Maybe<LearnerRequestSignUpWithMagicLink>;
  learnerSignUpWithPassword?: Maybe<LearnerSignUpWithPassword>;
  learnerUpgradeIndexScreenVersion?: Maybe<LearnerUpgradeIndexScreenVersion>;
  learnerHideIndexScreenExercise?: Maybe<LearnerHideIndexScreenExercise>;
  learnerBiometricsDismissWebModal?: Maybe<LearnerBiometricsDismissWebModal>;
  companyPortalAdminAdd?: Maybe<CompanyPortalAdminAdd>;
  companyPortalAdminRemove?: Maybe<CompanyPortalAdminRemove>;
  companyPortalMemberAdd?: Maybe<CompanyPortalMemberAdd>;
  companyPortalMemberDeactivate?: Maybe<CompanyPortalMemberDeactivate>;
  companyPortalMemberReactivate?: Maybe<CompanyPortalMemberReactivate>;
  companyPortalMemberSendInvite?: Maybe<CompanyPortalMemberSendInvite>;
  companyPortalDomainAdd?: Maybe<CompanyPortalDomainAdd>;
  companyPortalDomainRemove?: Maybe<CompanyPortalDomainRemove>;
  companyPortalSelfSignUpUpdate?: Maybe<CompanyPortalSelfSignUpUpdate>;
  companyPortalSignInOptionUpdate?: Maybe<CompanyPortalSignInOptionUpdate>;
  companyPortalHrisRemove?: Maybe<CompanyPortalHrisRemove>;
  learnerRecommendedRemoveItem?: Maybe<LearnerRecommendedRemoveItem>;
  learnerDismissIndexCtaPrompt?: Maybe<LearnerDismissIndexCtaPrompt>;
  learnerCreateOutlookConnectionLink?: Maybe<LearnerCreateOutlookConnectionLink>;
  learnerCreateGoogleConnectionLink?: Maybe<LearnerCreateGoogleConnectionLink>;
  learnerOutlookReadCalendarEvents?: Maybe<LearnerOutlookReadCalendarEvents>;
  learnerOutlookAddEvents?: Maybe<LearnerOutlookAddEvents>;
  learnerGoogleReadCalendarEvents?: Maybe<LearnerGoogleReadCalendarEvents>;
  learnerGoogleAddEvents?: Maybe<LearnerGoogleAddEvents>;
  triggerLearnerVerificationEmail?: Maybe<TriggerLearnerVerificationEmail>;
  learnerRequestVitalSignInToken?: Maybe<LearnerRequestVitalSignInToken>;
  learnerArticleFeedback?: Maybe<LearnerArticleFeedback>;
  learnerScheduleOndemandCalendar?: Maybe<LearnerScheduleOndemandCalendar>;
  learnerDeleteOndemandCalendar?: Maybe<LearnerDeleteOndemandCalendar>;
};

export type MutationCreateUpdateFcmDeviceArgs = {
  input: FcmDeviceInput;
};

export type MutationSignInArgs = {
  appInfo?: Maybe<AppInfo>;
  input: SignInInput;
};

export type MutationSignInWithTokenArgs = {
  appInfo: AppInfo;
  input: SignInWithTokenInput;
};

export type MutationSignOutArgs = {
  appInfo?: Maybe<AppInfo>;
};

export type MutationTokenAuthArgs = {
  username: Scalars["String"];
  password: Scalars["String"];
};

export type MutationVerifyTokenArgs = {
  token?: Maybe<Scalars["String"]>;
};

export type MutationRefreshTokenArgs = {
  token?: Maybe<Scalars["String"]>;
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type MutationResetPasswordWithLinkArgs = {
  input: ResetPasswordInput;
};

export type MutationChangePasswordWithLinkArgs = {
  appInfo?: Maybe<AppInfo>;
  input: ChangePasswordInputWithLink;
};

export type MutationUpdatePasswordWithTokenArgs = {
  password: Scalars["String"];
  token: Scalars["String"];
};

export type MutationReportAssessmentEventArgs = {
  appInfo: AppInfo;
  at: Scalars["String"];
  eventType: AssessmentEvent;
  groupUuid?: Maybe<Scalars["String"]>;
  params?: Maybe<Scalars["JSONString"]>;
};

export type MutationReportRecordingOpenArgs = {
  appInfo?: Maybe<AppInfo>;
  at: Scalars["String"];
  groupUuid?: Maybe<Scalars["ID"]>;
  platform: Scalars["String"];
  recordingId: Scalars["ID"];
};

export type MutationReportRecordingVideoStartArgs = {
  appInfo?: Maybe<AppInfo>;
  at: Scalars["String"];
  groupUuid: Scalars["ID"];
  platform: Scalars["String"];
  recordingId: Scalars["ID"];
};

export type MutationReportRecordingVideoProgressArgs = {
  appInfo?: Maybe<AppInfo>;
  at: Scalars["String"];
  currentTime: Scalars["Int"];
  duration: Scalars["Int"];
  groupUuid: Scalars["ID"];
  percentage: Scalars["Int"];
  platform: Scalars["String"];
  recordingId: Scalars["ID"];
};

export type MutationReportRecordingVideoEndArgs = {
  appInfo?: Maybe<AppInfo>;
  at: Scalars["String"];
  groupUuid: Scalars["ID"];
  platform: Scalars["String"];
  recordingId: Scalars["ID"];
};

export type MutationReportArticleOpenArgs = {
  appInfo?: Maybe<AppInfo>;
  articleId: Scalars["ID"];
  at: Scalars["String"];
  platform: Scalars["String"];
};

export type MutationReportArticleScrollStartArgs = {
  appInfo?: Maybe<AppInfo>;
  articleId: Scalars["ID"];
  at: Scalars["String"];
  groupUuid: Scalars["ID"];
  platform: Scalars["String"];
};

export type MutationReportArticleScrollProgressArgs = {
  appInfo?: Maybe<AppInfo>;
  articleId: Scalars["ID"];
  at: Scalars["String"];
  groupUuid: Scalars["ID"];
  percentage: Scalars["Int"];
  platform: Scalars["String"];
};

export type MutationReportArticleScrollEndArgs = {
  appInfo?: Maybe<AppInfo>;
  articleId: Scalars["ID"];
  at: Scalars["String"];
  groupUuid: Scalars["ID"];
  platform: Scalars["String"];
};

export type MutationReportGroupSessionLeftArgs = {
  appInfo?: Maybe<AppInfo>;
  groupSessionInstanceId: Scalars["ID"];
  input: GroupSessionReportDataInput;
};

export type MutationReportGroupSessionPingArgs = {
  appInfo?: Maybe<AppInfo>;
  groupSessionInstanceId: Scalars["ID"];
  input: GroupSessionReportDataInput;
};

export type MutationUserJoinedGroupSessionArgs = {
  appInfo?: Maybe<AppInfo>;
  input: UserJoinedGroupSessionInput;
};

export type MutationLearnerOnboardingArgs = {
  appInfo: AppInfo;
  input: LearnerOnboardingInput;
};

export type MutationLearnerJoinGroupSessionArgs = {
  appInfo: AppInfo;
  id: Scalars["ID"];
  utmParameters?: Maybe<UtmParametersInput>;
};

export type MutationLearnerSubmitBeforeGroupSessionFeedbackArgs = {
  appInfo: AppInfo;
  groupSessionId: Scalars["ID"];
  input: Array<Maybe<LearnerGroupSessionFeedbackInput>>;
  type: Scalars["String"];
};

export type MutationLearnerSubmitAfterGroupSessionFeedbackArgs = {
  appInfo: AppInfo;
  groupSessionId: Scalars["ID"];
  input: Array<Maybe<LearnerGroupSessionFeedbackInput>>;
  type: Scalars["String"];
};

export type MutationLearnerRegisterForGroupSessionArgs = {
  appInfo: AppInfo;
  id: Scalars["ID"];
  utmParameters?: Maybe<UtmParametersInput>;
};

export type MutationLearnerUnRegisterForGroupSessionArgs = {
  appInfo: AppInfo;
  id: Scalars["ID"];
};

export type MutationLearnerTrackBiometricsArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerFavouriteArgs = {
  appInfo: AppInfo;
  id: Scalars["ID"];
  typename: Scalars["String"];
};

export type MutationLearnerUnFavouriteArgs = {
  appInfo: AppInfo;
  id: Scalars["ID"];
  typename: Scalars["String"];
};

export type MutationLearnerUpdateHoursPerWeekArgs = {
  appInfo: AppInfo;
  value: Scalars["Int"];
};

export type MutationLearnerUpdateLanguageArgs = {
  appInfo: AppInfo;
  language: Scalars["String"];
};

export type MutationLearnerUpdateProfileSettingsArgs = {
  appInfo: AppInfo;
  input: LearnerUpdateProfileSettingsInput;
};

export type MutationLearnerUpdateNotificationSettingsToggleArgs = {
  appInfo: AppInfo;
  checked: Scalars["Boolean"];
  id: Scalars["ID"];
};

export type MutationLearnerUpdateCalendarSettingsToggleArgs = {
  appInfo: AppInfo;
  checked: Scalars["Boolean"];
  id: Scalars["ID"];
};

export type MutationLearnerExternalAssessmentCompleteArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerSubmitAssessmentResultsArgs = {
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  input: AssessmentResultsInput;
  offset?: Maybe<Scalars["Int"]>;
};

export type MutationStartAssessmentArgs = {
  appInfo: AppInfo;
  version?: Maybe<Scalars["String"]>;
};

export type MutationLearnerBiometricsConnectProviderArgs = {
  appInfo: AppInfo;
  id: Scalars["ID"];
  redirectUrl?: Maybe<Scalars["String"]>;
};

export type MutationLearnerBiometricsReportMissingDeviceArgs = {
  appInfo: AppInfo;
  deviceName: Scalars["String"];
};

export type MutationLearnerBiometricsDisconnectProviderArgs = {
  appInfo: AppInfo;
  id: Scalars["ID"];
};

export type MutationLearnerBiometricsDeleteHealthDataArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerBiometricsModalTellMeMoreArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerBiometricsModalRemindMeLaterArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerBiometricsModalDontAskAgainArgs = {
  appInfo: AppInfo;
};

export type MutationRequestSignInWithMagicLinkArgs = {
  appInfo: AppInfo;
  email: Scalars["String"];
};

export type MutationLearnerRequestSignUpWithPasswordArgs = {
  appInfo: AppInfo;
  email: Scalars["String"];
  password: Scalars["String"];
};

export type MutationLearnerRequestSignUpWithMagicLinkArgs = {
  appInfo: AppInfo;
  email: Scalars["String"];
};

export type MutationLearnerSignUpWithPasswordArgs = {
  appInfo: AppInfo;
  password: Scalars["String"];
  token: Scalars["String"];
};

export type MutationLearnerUpgradeIndexScreenVersionArgs = {
  appInfo: AppInfo;
  version: IndexScreenVersion;
};

export type MutationLearnerHideIndexScreenExerciseArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerBiometricsDismissWebModalArgs = {
  appInfo: AppInfo;
};

export type MutationCompanyPortalAdminAddArgs = {
  appInfo: AppInfo;
  memberUserId: Scalars["ID"];
};

export type MutationCompanyPortalAdminRemoveArgs = {
  adminUserId: Scalars["ID"];
  appInfo: AppInfo;
};

export type MutationCompanyPortalMemberAddArgs = {
  appInfo: AppInfo;
  input: CompanyPortalMemberAddInput;
};

export type MutationCompanyPortalMemberDeactivateArgs = {
  appInfo: AppInfo;
  memberUserId: Scalars["ID"];
};

export type MutationCompanyPortalMemberReactivateArgs = {
  appInfo: AppInfo;
  memberUserId: Scalars["ID"];
};

export type MutationCompanyPortalMemberSendInviteArgs = {
  appInfo: AppInfo;
  memberUserId: Scalars["ID"];
};

export type MutationCompanyPortalDomainAddArgs = {
  appInfo: AppInfo;
  domain?: Maybe<Scalars["String"]>;
};

export type MutationCompanyPortalDomainRemoveArgs = {
  appInfo: AppInfo;
  domain: Scalars["String"];
};

export type MutationCompanyPortalSelfSignUpUpdateArgs = {
  appInfo: AppInfo;
  isSignUpEnabled: Scalars["Boolean"];
};

export type MutationCompanyPortalSignInOptionUpdateArgs = {
  appInfo: AppInfo;
  input: CompanyPortalSignInOptionSettingsInput;
};

export type MutationCompanyPortalHrisRemoveArgs = {
  appInfo: AppInfo;
  hrisConnectionId: Scalars["ID"];
};

export type MutationLearnerRecommendedRemoveItemArgs = {
  appInfo: AppInfo;
  input: LearnerRecommendedRemoveItemInput;
};

export type MutationLearnerDismissIndexCtaPromptArgs = {
  appInfo: AppInfo;
  id: Scalars["ID"];
};

export type MutationLearnerCreateOutlookConnectionLinkArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerCreateGoogleConnectionLinkArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerOutlookReadCalendarEventsArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerOutlookAddEventsArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerGoogleReadCalendarEventsArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerGoogleAddEventsArgs = {
  appInfo: AppInfo;
};

export type MutationTriggerLearnerVerificationEmailArgs = {
  appInfo: AppInfo;
  companyToken: Scalars["String"];
  email: Scalars["String"];
};

export type MutationLearnerRequestVitalSignInTokenArgs = {
  appInfo: AppInfo;
};

export type MutationLearnerArticleFeedbackArgs = {
  appInfo: AppInfo;
  input: LearnerArticleFeedbackInput;
};

export type MutationLearnerScheduleOndemandCalendarArgs = {
  appInfo: AppInfo;
  datetimeSlotUtc: Scalars["DateTime"];
  recordingId: Scalars["ID"];
};

export type MutationLearnerDeleteOndemandCalendarArgs = {
  appInfo: AppInfo;
  recordingId: Scalars["ID"];
};

export type ObtainJsonWebToken = {
  __typename?: "ObtainJSONWebToken";
  payload: Scalars["GenericScalar"];
  refreshExpiresIn: Scalars["Int"];
  token: Scalars["String"];
};

export type OktaSettingsInput = {
  oktaClientId: Scalars["String"];
  oktaClientSecret: Scalars["String"];
  oktaClientApiUrl: Scalars["String"];
};

export type OnboardingType = {
  __typename?: "OnboardingType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  studentdetailObj: StudentDetailType;
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  city?: Maybe<Scalars["String"]>;
  isLondon: Scalars["Boolean"];
  location?: Maybe<LocationType>;
  plans: Array<PlanType>;
  wellbeingHours?: Maybe<Scalars["Int"]>;
  sendNotifications?: Maybe<Scalars["Boolean"]>;
  injuries?: Maybe<Scalars["String"]>;
  pillar?: Maybe<PillarType>;
  learnerOnboardingData?: Maybe<Scalars["JSONString"]>;
};

export type OverallIndexScore = BaseScore & {
  __typename?: "OverallIndexScore";
  id?: Maybe<Scalars["ID"]>;
  shorthand: Scalars["String"];
  name: Scalars["String"];
  value?: Maybe<Scalars["Float"]>;
  minValue: Scalars["Float"];
  maxValue: Scalars["Float"];
  label?: Maybe<Scalars["String"]>;
  blurb?: Maybe<Scalars["String"]>;
};

export enum PillarLabel {
  Energy = "ENERGY",
  Resilience = "RESILIENCE",
  Activity = "ACTIVITY",
  Nutrition = "NUTRITION",
}

export type PillarStatus = {
  __typename?: "PillarStatus";
  state?: Maybe<State>;
  assessmentUrl?: Maybe<Scalars["String"]>;
};

export type PillarType = {
  __typename?: "PillarType";
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  name: Scalars["String"];
  displayPhrase: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  ordering: Scalars["Int"];
  planSet: Array<PlanType>;
  articleSet: Array<ArticleType>;
  studentdetailSet: Array<StudentDetailType>;
  onboardingSet: Array<OnboardingType>;
  groupsessionSet: Array<GroupSessionType>;
};

export type PlanType = {
  __typename?: "PlanType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  photo?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  description: Scalars["String"];
  displayPhrase?: Maybe<Scalars["String"]>;
  showOnSite: Scalars["Boolean"];
  doughnutColorCode: Scalars["String"];
  pillar?: Maybe<PillarType>;
  articleSet: Array<ArticleType>;
  studentdetailSet: Array<StudentDetailType>;
  onboardingSet: Array<OnboardingType>;
  classSet: Array<TeacherClassModelType>;
  classsessionSet: Array<ClassSessionType>;
};

export enum Platform {
  Web = "WEB",
  Ios = "IOS",
  Android = "ANDROID",
}

export type PricingSystemType = {
  __typename?: "PricingSystemType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  classObj: TeacherClassModelType;
  credit: Scalars["Int"];
};

export type ProgressAnimationFrame = {
  __typename?: "ProgressAnimationFrame";
  percentageStart: Scalars["Int"];
  percentageEnd: Scalars["Int"];
  transitionDurationSec: Scalars["Int"];
  textHtml: Scalars["String"];
};

export type Query = {
  __typename?: "Query";
  _debug?: Maybe<DjangoDebug>;
  isUpgradeNeeded?: Maybe<IsUpgradeNeededType>;
  user?: Maybe<UserType>;
  learner: Learner;
  learnerSession: LearnerSession;
  learnerPractitioner: LearnerPractitioner;
  learnerRecording: LearnerRecording;
  recentContent?: Maybe<Array<Maybe<LearnerRecording>>>;
  learnerFavourites?: Maybe<LearnerFavourites>;
  learnerArticle: LearnerArticle;
  learnerBeforeGroupSessionFeedbackForm: LearnerBeforeGroupSessionFeedbackForm;
  learnerAfterGroupSessionFeedbackForm: LearnerAfterGroupSessionFeedbackForm;
  learnerContentList: LearnerContentList;
  learnerScreenSessions: LearnerGroupSessionsScreen;
  learnerBiometricsDeviceConnection: LearnerBiometricsDeviceConnection;
  verifyCompanyToken: VerifyToken;
  /** @deprecated Use LearnerCreateAccountScreen instead */
  learnerGetSignUpOptions: LearnerSignUpScreen;
  learnerSignInScreen: LearnerSignInScreen;
  learnerCreateAccountScreen: LearnerCreateAccountScreen;
  companyAdmin: CompanyAdmin;
  linkCompanyHrsystem: HrSystemConnectionLink;
  companyPortalMembersScreen: MembersScreen;
  companyPortalAdminSettingsScreen: AdminSettingsScreen;
  companyPortalIntegrationsScreen: IntegrationsScreen;
  companyPortalDashboardScreen?: Maybe<DashboardScreen>;
  userProfiles: UserProfiles;
};

export type QueryIsUpgradeNeededArgs = {
  appName: Scalars["String"];
  appVersion: Scalars["String"];
};

export type QueryUserArgs = {
  email: Scalars["String"];
};

export type QueryLearnerArgs = {
  appInfo: AppInfo;
};

export type QueryLearnerSessionArgs = {
  id: Scalars["ID"];
  appInfo: AppInfo;
};

export type QueryLearnerPractitionerArgs = {
  id: Scalars["ID"];
  appInfo: AppInfo;
};

export type QueryLearnerRecordingArgs = {
  id: Scalars["ID"];
  appInfo: AppInfo;
};

export type QueryRecentContentArgs = {
  appInfo: AppInfo;
};

export type QueryLearnerFavouritesArgs = {
  appInfo: AppInfo;
};

export type QueryLearnerArticleArgs = {
  id: Scalars["ID"];
  appInfo: AppInfo;
};

export type QueryLearnerBeforeGroupSessionFeedbackFormArgs = {
  groupSessionId: Scalars["ID"];
  appInfo: AppInfo;
};

export type QueryLearnerAfterGroupSessionFeedbackFormArgs = {
  groupSessionId: Scalars["ID"];
  appInfo: AppInfo;
};

export type QueryLearnerContentListArgs = {
  id: Scalars["ID"];
  searchQuery: Scalars["String"];
  filters: LearnerContentListFilters;
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type QueryLearnerScreenSessionsArgs = {
  appInfo: AppInfo;
};

export type QueryLearnerBiometricsDeviceConnectionArgs = {
  appInfo: AppInfo;
};

export type QueryVerifyCompanyTokenArgs = {
  appInfo: AppInfo;
  companyToken: Scalars["String"];
};

export type QueryLearnerGetSignUpOptionsArgs = {
  appInfo: AppInfo;
  email: Scalars["String"];
};

export type QueryLearnerSignInScreenArgs = {
  appInfo: AppInfo;
  email: Scalars["String"];
  authBackendId: Scalars["String"];
};

export type QueryLearnerCreateAccountScreenArgs = {
  appInfo: AppInfo;
  email: Scalars["String"];
};

export type QueryCompanyAdminArgs = {
  appInfo: AppInfo;
};

export type QueryLinkCompanyHrsystemArgs = {
  appInfo: AppInfo;
};

export type QueryCompanyPortalMembersScreenArgs = {
  appInfo: AppInfo;
  searchQuery?: Maybe<Scalars["String"]>;
  statusSort?: Maybe<Scalars["Boolean"]>;
  itemsPerPage?: Maybe<Scalars["Int"]>;
  pageNumber?: Maybe<Scalars["Int"]>;
};

export type QueryCompanyPortalAdminSettingsScreenArgs = {
  appInfo: AppInfo;
};

export type QueryCompanyPortalIntegrationsScreenArgs = {
  appInfo: AppInfo;
};

export type QueryCompanyPortalDashboardScreenArgs = {
  appInfo: AppInfo;
};

export type QueryUserProfilesArgs = {
  appInfo: AppInfo;
};

export type RangeInput = {
  __typename?: "RangeInput";
  id: Scalars["String"];
  label: Scalars["String"];
  required: Scalars["Boolean"];
  min: Scalars["Int"];
  minLabel: Scalars["String"];
  mid: Scalars["Int"];
  max: Scalars["Int"];
  maxLabel: Scalars["String"];
  step: Scalars["Int"];
  value?: Maybe<Scalars["String"]>;
};

export type Refresh = {
  __typename?: "Refresh";
  payload: Scalars["GenericScalar"];
  refreshExpiresIn: Scalars["Int"];
  token: Scalars["String"];
};

export type ReportArticleOpen = {
  __typename?: "ReportArticleOpen";
  ok?: Maybe<Scalars["Boolean"]>;
  groupUuid?: Maybe<Scalars["String"]>;
};

export type ReportArticleScrollEnd = {
  __typename?: "ReportArticleScrollEnd";
  ok?: Maybe<Scalars["Boolean"]>;
};

export type ReportArticleScrollProgress = {
  __typename?: "ReportArticleScrollProgress";
  ok?: Maybe<Scalars["Boolean"]>;
};

export type ReportArticleScrollStart = {
  __typename?: "ReportArticleScrollStart";
  ok?: Maybe<Scalars["Boolean"]>;
};

export type ReportAssessmentEvent = {
  __typename?: "ReportAssessmentEvent";
  ok?: Maybe<Scalars["Boolean"]>;
  groupUuid?: Maybe<Scalars["String"]>;
};

export type ReportGroupSessionLeft = {
  __typename?: "ReportGroupSessionLeft";
  ok?: Maybe<Scalars["Boolean"]>;
  eventCreated?: Maybe<Scalars["Boolean"]>;
};

export type ReportGroupSessionPing = {
  __typename?: "ReportGroupSessionPing";
  ok?: Maybe<Scalars["Boolean"]>;
  eventCreated?: Maybe<Scalars["Boolean"]>;
};

export type ReportRecordingOpen = {
  __typename?: "ReportRecordingOpen";
  ok?: Maybe<Scalars["Boolean"]>;
  groupUuid?: Maybe<Scalars["ID"]>;
};

export type ReportRecordingVideoEnd = {
  __typename?: "ReportRecordingVideoEnd";
  ok?: Maybe<Scalars["Boolean"]>;
};

export type ReportRecordingVideoProgress = {
  __typename?: "ReportRecordingVideoProgress";
  ok?: Maybe<Scalars["Boolean"]>;
};

export type ReportRecordingVideoStart = {
  __typename?: "ReportRecordingVideoStart";
  ok?: Maybe<Scalars["Boolean"]>;
};

export type RequestSignInWithMagicLink = {
  __typename?: "RequestSignInWithMagicLink";
  ok: Scalars["Boolean"];
  message: Scalars["String"];
};

export type ResetPassword = {
  __typename?: "ResetPassword";
  sentMail?: Maybe<Scalars["Boolean"]>;
  ok?: Maybe<Scalars["Boolean"]>;
  user?: Maybe<UserType>;
};

export type ResetPasswordInput = {
  email: Scalars["String"];
};

export type ResetPasswordWithLink = {
  __typename?: "ResetPasswordWithLink";
  ok?: Maybe<Scalars["Boolean"]>;
  /** @deprecated Use messageHtml instead */
  message?: Maybe<Scalars["String"]>;
  messageHtml: Scalars["String"];
};

export type RoleType = {
  __typename?: "RoleType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  name: Scalars["String"];
  userdetailSet: Array<UserDetailType>;
};

export type SsoItems = {
  __typename?: "SSOItems";
  order: Scalars["Int"];
  id: Scalars["String"];
  name: Scalars["String"];
  isEnabled: Scalars["Boolean"];
};

export enum ScoreType {
  Overall = "OVERALL",
  Category = "CATEGORY",
  Domain = "DOMAIN",
  Theme = "THEME",
  Item = "ITEM",
  Response = "RESPONSE",
  Pillar = "PILLAR",
}

export type SelectAdminList = {
  __typename?: "SelectAdminList";
  id: Scalars["ID"];
  member: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email: Scalars["String"];
};

export type SelectInput = {
  __typename?: "SelectInput";
  id: Scalars["String"];
  label: Scalars["String"];
  required: Scalars["Boolean"];
  options: Array<SelectInputOption>;
};

export type SelectInputOption = {
  __typename?: "SelectInputOption";
  id?: Maybe<Scalars["String"]>;
  label: Scalars["String"];
  displayOrder?: Maybe<Scalars["Int"]>;
  lowerBound?: Maybe<Scalars["Int"]>;
  value: Scalars["String"];
  imageUrl?: Maybe<Scalars["String"]>;
  clickLink?: Maybe<Scalars["String"]>;
  selected?: Maybe<Scalars["Boolean"]>;
};

export type ServiceType1 = {
  __typename?: "ServiceType1";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  name: Scalars["String"];
  photo?: Maybe<Scalars["String"]>;
  barChartColor: Scalars["String"];
  showOnApp: Scalars["Boolean"];
  worksWithBiometrics: Scalars["Boolean"];
  classSet: Array<TeacherClassModelType>;
  groupsessionSet: Array<GroupSessionType>;
  classCount?: Maybe<Scalars["Int"]>;
};

export type SignIn = {
  __typename?: "SignIn";
  ok?: Maybe<Scalars["Boolean"]>;
  authToken?: Maybe<Scalars["String"]>;
  refreshToken?: Maybe<Scalars["String"]>;
  user?: Maybe<UserType>;
  learner?: Maybe<Learner>;
  companyAdmin?: Maybe<CompanyAdmin>;
  roles: Array<Maybe<Scalars["String"]>>;
};

export type SignInInput = {
  email?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
};

export type SignInOptions = {
  __typename?: "SignInOptions";
  title: Scalars["String"];
  items: Array<Maybe<SsoItems>>;
};

export type SignInWithToken = {
  __typename?: "SignInWithToken";
  ok?: Maybe<Scalars["Boolean"]>;
  authToken?: Maybe<Scalars["String"]>;
  refreshToken?: Maybe<Scalars["String"]>;
  user?: Maybe<UserType>;
  userProfiles?: Maybe<UserProfiles>;
};

export type SignInWithTokenInput = {
  action: Scalars["String"];
  authBackendId: Scalars["String"];
};

export type SignOut = {
  __typename?: "SignOut";
  ok?: Maybe<Scalars["Boolean"]>;
};

export type SignUpOptions = {
  __typename?: "SignUpOptions";
  title: Scalars["String"];
  isEnabled: Scalars["Boolean"];
};

export type SingleInputScreen = {
  __typename?: "SingleInputScreen";
  id: Scalars["String"];
  titleHtml: Scalars["String"];
  subtitleHtml?: Maybe<Scalars["String"]>;
  input: Input;
  buttonText?: Maybe<Scalars["String"]>;
  skipButtonText: Scalars["String"];
  logoutButtonText?: Maybe<Scalars["String"]>;
};

export type StartAssessment = {
  __typename?: "StartAssessment";
  steps: Array<Maybe<AssessmentStep>>;
  version: Scalars["String"];
  ok: Scalars["Boolean"];
  saveAndResumeSupported: Scalars["Boolean"];
  resumeStepId?: Maybe<Scalars["ID"]>;
  progressSavedAt?: Maybe<Scalars["DateTime"]>;
  progressExpiresAt?: Maybe<Scalars["DateTime"]>;
};

export type AssessmentStepResponseInput = {
  stepId: Scalars["ID"];
  text: Scalars["String"];
  score: Scalars["Int"];
};

export type SaveAndExitAssessment = {
  __typename?: "SaveAndExitAssessment";
  ok: Scalars["Boolean"];
};

export enum State {
  Started = "STARTED",
  Completed = "COMPLETED",
  Lapsed = "LAPSED",
}

export type StructuredArticleFeedbackResponseInput = {
  id: Scalars["String"];
  question: Scalars["String"];
  options: Array<Maybe<ArticleFeedbackChoiceInput>>;
  response: ArticleFeedbackChoiceInput;
};

export enum StudentDetailIndexScreenCtasPromptVariant {
  Toast = "TOAST",
  Inline = "INLINE",
}

export enum StudentDetailIndexScreenVersion {
  V1 = "V1",
  V2 = "V2",
}

export type StudentDetailType = {
  __typename?: "StudentDetailType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  userdetailObj: UserDetailType;
  availableCredits: Scalars["Int"];
  location?: Maybe<LocationType>;
  phone?: Maybe<Scalars["String"]>;
  wellbeingHours?: Maybe<Scalars["Int"]>;
  gender?: Maybe<Scalars["String"]>;
  dob?: Maybe<Scalars["Date"]>;
  company?: Maybe<CorporateCompanyType>;
  isLondon: Scalars["Boolean"];
  plans: Array<PlanType>;
  isSubscribed: Scalars["Boolean"];
  subscriptionExipiryDate?: Maybe<Scalars["Date"]>;
  injuries?: Maybe<Scalars["String"]>;
  companyLocation?: Maybe<CompanyLocationType>;
  businessUnit?: Maybe<BusinessUnitType>;
  assessmentTaken: Scalars["Boolean"];
  shouldRetakeAssessment: Scalars["Boolean"];
  isWaitingForAssessmentResults: Scalars["Boolean"];
  shouldShowWaitingForAssessmentResultsExercisePopup: Scalars["Boolean"];
  waitingForAssessmentResultsStartedAt?: Maybe<Scalars["DateTime"]>;
  jobTitle?: Maybe<Scalars["String"]>;
  permissionToSendCalendarInvites?: Maybe<Scalars["Boolean"]>;
  pillar?: Maybe<PillarType>;
  indexScreenVersion: StudentDetailIndexScreenVersion;
  indexScreenCtasPromptsEnabled: Scalars["Boolean"];
  indexScreenCtasPromptVariant: StudentDetailIndexScreenCtasPromptVariant;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  rawDataJson?: Maybe<Scalars["JSONString"]>;
  onboarding?: Maybe<OnboardingType>;
  corporatecompanyadminSet: Array<CorporateCompanyAdminType>;
  externalassessmentSet: Array<ExternalAssessmentType>;
  classsessionSet: Array<ClassSessionType>;
  invitationSet: Array<InvitationType>;
};

export enum SubscriptionProductBillingCycle {
  Monthly = "MONTHLY",
  Yearly = "YEARLY",
}

export enum SubscriptionProductCurrency {
  Gbp = "GBP",
  Usd = "USD",
}

export enum SubscriptionProductType {
  Managedbystripe = "MANAGEDBYSTRIPE",
  Managedbysales = "MANAGEDBYSALES",
}

export type SubscriptionProductType1 = {
  __typename?: "SubscriptionProductType1";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  name: Scalars["String"];
  type: SubscriptionProductType;
  billingCycle: SubscriptionProductBillingCycle;
  cost: Scalars["Float"];
  includedFeatures?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  currency: SubscriptionProductCurrency;
  stripePriceId?: Maybe<Scalars["String"]>;
  isActive: Scalars["Boolean"];
  stripeProductId?: Maybe<Scalars["String"]>;
  corporatecompanySet: Array<CorporateCompanyType>;
};

export type TeacherBankDetailType = {
  __typename?: "TeacherBankDetailType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  teacherdetailObj: TeacherDetailType;
  accountHolderName: Scalars["String"];
  accountCountry: Scalars["String"];
  accountNo: Scalars["String"];
  sortCode?: Maybe<Scalars["String"]>;
  iban?: Maybe<Scalars["String"]>;
  bicSwift?: Maybe<Scalars["String"]>;
  billingAddress?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  postCode?: Maybe<Scalars["String"]>;
};

export type TeacherCalendarDaysOffType = {
  __typename?: "TeacherCalendarDaysOffType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  teacherdetailObj: TeacherDetailType;
  dayOffName?: Maybe<Scalars["String"]>;
  daysOffFrom: Scalars["Date"];
  daysOffTo: Scalars["Date"];
};

export type TeacherCalendarType = {
  __typename?: "TeacherCalendarType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  teacherdetailObj: TeacherDetailType;
  availableDay: Scalars["String"];
  fromTime?: Maybe<Scalars["String"]>;
  toTime?: Maybe<Scalars["String"]>;
};

export type TeacherClassModelType = {
  __typename?: "TeacherClassModelType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  photo?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  description: Scalars["String"];
  service: ServiceType1;
  plans: Array<PlanType>;
  preparationMaterials: Scalars["String"];
  showOnApp: Scalars["Boolean"];
  teacherdetailSet: Array<TeacherDetailType>;
  pricingsystemSet: Array<PricingSystemType>;
  groupsessionSet: Array<GroupSessionType>;
  classsessionSet: Array<ClassSessionType>;
  minCredits?: Maybe<Scalars["Int"]>;
  maxCredits?: Maybe<Scalars["Int"]>;
};

export type TeacherDetailType = {
  __typename?: "TeacherDetailType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  userdetailObj: UserDetailType;
  phone?: Maybe<Scalars["String"]>;
  bio?: Maybe<Scalars["String"]>;
  location?: Maybe<LocationType>;
  teachingAccreditations?: Maybe<Scalars["String"]>;
  classes: Array<TeacherClassModelType>;
  introVideo?: Maybe<Scalars["String"]>;
  introVideoThumbnail?: Maybe<Scalars["String"]>;
  landscapePhoto?: Maybe<Scalars["String"]>;
  recentSession?: Maybe<GroupSessionInstanceType>;
  teacherbankdetail?: Maybe<TeacherBankDetailType>;
  teachercalendarSet: Array<TeacherCalendarType>;
  teachercalendardaysoffSet: Array<TeacherCalendarDaysOffType>;
  groupsessioninstanceSet: Array<GroupSessionInstanceType>;
  classsessionSet: Array<ClassSessionType>;
  teacherGroupSessions?: Maybe<Array<Maybe<TeacherGroupSessionInstanceType>>>;
};

export type TeacherGroupSessionInstanceType = {
  __typename?: "TeacherGroupSessionInstanceType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  groupSession: GroupSessionType;
  scheduledDate: Scalars["Date"];
  instanceStartDateTime?: Maybe<Scalars["DateTime"]>;
  instanceEndDateTime?: Maybe<Scalars["DateTime"]>;
  instanceDisplayEndDateTime?: Maybe<Scalars["DateTime"]>;
  sessionDurationMinutes: Scalars["Int"];
  teacher?: Maybe<TeacherDetailType>;
  recordingUrlThumbnail?: Maybe<Scalars["String"]>;
  recordingUrlThumbnailWebpFull?: Maybe<Scalars["String"]>;
  recordingUrlThumbnailWebp1080p?: Maybe<Scalars["String"]>;
  recordingUrlThumbnailWebp720p?: Maybe<Scalars["String"]>;
  recordingUrl?: Maybe<Scalars["String"]>;
  recordingUploadedAt?: Maybe<Scalars["DateTime"]>;
  recordingDuration?: Maybe<Scalars["Float"]>;
  showOnClassPage: Scalars["Boolean"];
  showOnTeacherPage: Scalars["Boolean"];
  showOnCommunityPage: Scalars["Boolean"];
  joiningLink?: Maybe<Scalars["String"]>;
  teacherReminderEmail?: Maybe<Scalars["DateTime"]>;
  contentTag: Array<ContentTagType>;
  teacherdetail?: Maybe<TeacherDetailType>;
  groupsessionpeoplejoiningSet: Array<GroupSessionPeopleJoiningType>;
  wonecalendareventSet: Array<WoneCalendarEventType>;
  recordingDurationText?: Maybe<Scalars["String"]>;
};

export type TextInput = {
  __typename?: "TextInput";
  id: Scalars["String"];
  label: Scalars["String"];
  required: Scalars["Boolean"];
  minLength: Scalars["Int"];
  maxLength: Scalars["Int"];
  placeholder?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  min?: Maybe<Scalars["Int"]>;
  max?: Maybe<Scalars["Int"]>;
};

export type ThemeScore = BaseScore & {
  __typename?: "ThemeScore";
  id?: Maybe<Scalars["ID"]>;
  shorthand: Scalars["String"];
  name: Scalars["String"];
  value?: Maybe<Scalars["Float"]>;
  minValue: Scalars["Float"];
  maxValue: Scalars["Float"];
  label?: Maybe<Scalars["String"]>;
  blurb?: Maybe<Scalars["String"]>;
  domainShorthand: Scalars["String"];
};

export type TriggerLearnerVerificationEmail = {
  __typename?: "TriggerLearnerVerificationEmail";
  response?: Maybe<VerifyToken>;
};

export type UtmParametersInput = {
  utmSource?: Maybe<Scalars["String"]>;
  utmMedium?: Maybe<Scalars["String"]>;
  utmCampaign?: Maybe<Scalars["String"]>;
  utmTerm?: Maybe<Scalars["String"]>;
  utmContent?: Maybe<Scalars["String"]>;
};

export type UpdatePasswordWithToken = {
  __typename?: "UpdatePasswordWithToken";
  ok: Scalars["Boolean"];
  message: Scalars["String"];
};

export enum UserDetailTimezone {
  AfricaAbidjan = "AFRICA_ABIDJAN",
  AfricaAccra = "AFRICA_ACCRA",
  AfricaAddisAbaba = "AFRICA_ADDIS_ABABA",
  AfricaAlgiers = "AFRICA_ALGIERS",
  AfricaAsmara = "AFRICA_ASMARA",
  AfricaAsmera = "AFRICA_ASMERA",
  AfricaBamako = "AFRICA_BAMAKO",
  AfricaBangui = "AFRICA_BANGUI",
  AfricaBanjul = "AFRICA_BANJUL",
  AfricaBissau = "AFRICA_BISSAU",
  AfricaBlantyre = "AFRICA_BLANTYRE",
  AfricaBrazzaville = "AFRICA_BRAZZAVILLE",
  AfricaBujumbura = "AFRICA_BUJUMBURA",
  AfricaCairo = "AFRICA_CAIRO",
  AfricaCasablanca = "AFRICA_CASABLANCA",
  AfricaCeuta = "AFRICA_CEUTA",
  AfricaConakry = "AFRICA_CONAKRY",
  AfricaDakar = "AFRICA_DAKAR",
  AfricaDarEsSalaam = "AFRICA_DAR_ES_SALAAM",
  AfricaDjibouti = "AFRICA_DJIBOUTI",
  AfricaDouala = "AFRICA_DOUALA",
  AfricaElAaiun = "AFRICA_EL_AAIUN",
  AfricaFreetown = "AFRICA_FREETOWN",
  AfricaGaborone = "AFRICA_GABORONE",
  AfricaHarare = "AFRICA_HARARE",
  AfricaJohannesburg = "AFRICA_JOHANNESBURG",
  AfricaJuba = "AFRICA_JUBA",
  AfricaKampala = "AFRICA_KAMPALA",
  AfricaKhartoum = "AFRICA_KHARTOUM",
  AfricaKigali = "AFRICA_KIGALI",
  AfricaKinshasa = "AFRICA_KINSHASA",
  AfricaLagos = "AFRICA_LAGOS",
  AfricaLibreville = "AFRICA_LIBREVILLE",
  AfricaLome = "AFRICA_LOME",
  AfricaLuanda = "AFRICA_LUANDA",
  AfricaLubumbashi = "AFRICA_LUBUMBASHI",
  AfricaLusaka = "AFRICA_LUSAKA",
  AfricaMalabo = "AFRICA_MALABO",
  AfricaMaputo = "AFRICA_MAPUTO",
  AfricaMaseru = "AFRICA_MASERU",
  AfricaMbabane = "AFRICA_MBABANE",
  AfricaMogadishu = "AFRICA_MOGADISHU",
  AfricaMonrovia = "AFRICA_MONROVIA",
  AfricaNairobi = "AFRICA_NAIROBI",
  AfricaNdjamena = "AFRICA_NDJAMENA",
  AfricaNiamey = "AFRICA_NIAMEY",
  AfricaNouakchott = "AFRICA_NOUAKCHOTT",
  AfricaOuagadougou = "AFRICA_OUAGADOUGOU",
  AfricaPortoNovo = "AFRICA_PORTO_NOVO",
  AfricaSaoTome = "AFRICA_SAO_TOME",
  AfricaTimbuktu = "AFRICA_TIMBUKTU",
  AfricaTripoli = "AFRICA_TRIPOLI",
  AfricaTunis = "AFRICA_TUNIS",
  AfricaWindhoek = "AFRICA_WINDHOEK",
  AmericaAdak = "AMERICA_ADAK",
  AmericaAnchorage = "AMERICA_ANCHORAGE",
  AmericaAnguilla = "AMERICA_ANGUILLA",
  AmericaAntigua = "AMERICA_ANTIGUA",
  AmericaAraguaina = "AMERICA_ARAGUAINA",
  AmericaArgentinaBuenosAires = "AMERICA_ARGENTINA_BUENOS_AIRES",
  AmericaArgentinaCatamarca = "AMERICA_ARGENTINA_CATAMARCA",
  AmericaArgentinaComodrivadavia = "AMERICA_ARGENTINA_COMODRIVADAVIA",
  AmericaArgentinaCordoba = "AMERICA_ARGENTINA_CORDOBA",
  AmericaArgentinaJujuy = "AMERICA_ARGENTINA_JUJUY",
  AmericaArgentinaLaRioja = "AMERICA_ARGENTINA_LA_RIOJA",
  AmericaArgentinaMendoza = "AMERICA_ARGENTINA_MENDOZA",
  AmericaArgentinaRioGallegos = "AMERICA_ARGENTINA_RIO_GALLEGOS",
  AmericaArgentinaSalta = "AMERICA_ARGENTINA_SALTA",
  AmericaArgentinaSanJuan = "AMERICA_ARGENTINA_SAN_JUAN",
  AmericaArgentinaSanLuis = "AMERICA_ARGENTINA_SAN_LUIS",
  AmericaArgentinaTucuman = "AMERICA_ARGENTINA_TUCUMAN",
  AmericaArgentinaUshuaia = "AMERICA_ARGENTINA_USHUAIA",
  AmericaAruba = "AMERICA_ARUBA",
  AmericaAsuncion = "AMERICA_ASUNCION",
  AmericaAtikokan = "AMERICA_ATIKOKAN",
  AmericaAtka = "AMERICA_ATKA",
  AmericaBahia = "AMERICA_BAHIA",
  AmericaBahiaBanderas = "AMERICA_BAHIA_BANDERAS",
  AmericaBarbados = "AMERICA_BARBADOS",
  AmericaBelem = "AMERICA_BELEM",
  AmericaBelize = "AMERICA_BELIZE",
  AmericaBlancSablon = "AMERICA_BLANC_SABLON",
  AmericaBoaVista = "AMERICA_BOA_VISTA",
  AmericaBogota = "AMERICA_BOGOTA",
  AmericaBoise = "AMERICA_BOISE",
  AmericaBuenosAires = "AMERICA_BUENOS_AIRES",
  AmericaCambridgeBay = "AMERICA_CAMBRIDGE_BAY",
  AmericaCampoGrande = "AMERICA_CAMPO_GRANDE",
  AmericaCancun = "AMERICA_CANCUN",
  AmericaCaracas = "AMERICA_CARACAS",
  AmericaCatamarca = "AMERICA_CATAMARCA",
  AmericaCayenne = "AMERICA_CAYENNE",
  AmericaCayman = "AMERICA_CAYMAN",
  AmericaChicago = "AMERICA_CHICAGO",
  AmericaChihuahua = "AMERICA_CHIHUAHUA",
  AmericaCoralHarbour = "AMERICA_CORAL_HARBOUR",
  AmericaCordoba = "AMERICA_CORDOBA",
  AmericaCostaRica = "AMERICA_COSTA_RICA",
  AmericaCreston = "AMERICA_CRESTON",
  AmericaCuiaba = "AMERICA_CUIABA",
  AmericaCuracao = "AMERICA_CURACAO",
  AmericaDanmarkshavn = "AMERICA_DANMARKSHAVN",
  AmericaDawson = "AMERICA_DAWSON",
  AmericaDawsonCreek = "AMERICA_DAWSON_CREEK",
  AmericaDenver = "AMERICA_DENVER",
  AmericaDetroit = "AMERICA_DETROIT",
  AmericaDominica = "AMERICA_DOMINICA",
  AmericaEdmonton = "AMERICA_EDMONTON",
  AmericaEirunepe = "AMERICA_EIRUNEPE",
  AmericaElSalvador = "AMERICA_EL_SALVADOR",
  AmericaEnsenada = "AMERICA_ENSENADA",
  AmericaFortNelson = "AMERICA_FORT_NELSON",
  AmericaFortWayne = "AMERICA_FORT_WAYNE",
  AmericaFortaleza = "AMERICA_FORTALEZA",
  AmericaGlaceBay = "AMERICA_GLACE_BAY",
  AmericaGodthab = "AMERICA_GODTHAB",
  AmericaGooseBay = "AMERICA_GOOSE_BAY",
  AmericaGrandTurk = "AMERICA_GRAND_TURK",
  AmericaGrenada = "AMERICA_GRENADA",
  AmericaGuadeloupe = "AMERICA_GUADELOUPE",
  AmericaGuatemala = "AMERICA_GUATEMALA",
  AmericaGuayaquil = "AMERICA_GUAYAQUIL",
  AmericaGuyana = "AMERICA_GUYANA",
  AmericaHalifax = "AMERICA_HALIFAX",
  AmericaHavana = "AMERICA_HAVANA",
  AmericaHermosillo = "AMERICA_HERMOSILLO",
  AmericaIndianaIndianapolis = "AMERICA_INDIANA_INDIANAPOLIS",
  AmericaIndianaKnox = "AMERICA_INDIANA_KNOX",
  AmericaIndianaMarengo = "AMERICA_INDIANA_MARENGO",
  AmericaIndianaPetersburg = "AMERICA_INDIANA_PETERSBURG",
  AmericaIndianaTellCity = "AMERICA_INDIANA_TELL_CITY",
  AmericaIndianaVevay = "AMERICA_INDIANA_VEVAY",
  AmericaIndianaVincennes = "AMERICA_INDIANA_VINCENNES",
  AmericaIndianaWinamac = "AMERICA_INDIANA_WINAMAC",
  AmericaIndianapolis = "AMERICA_INDIANAPOLIS",
  AmericaInuvik = "AMERICA_INUVIK",
  AmericaIqaluit = "AMERICA_IQALUIT",
  AmericaJamaica = "AMERICA_JAMAICA",
  AmericaJujuy = "AMERICA_JUJUY",
  AmericaJuneau = "AMERICA_JUNEAU",
  AmericaKentuckyLouisville = "AMERICA_KENTUCKY_LOUISVILLE",
  AmericaKentuckyMonticello = "AMERICA_KENTUCKY_MONTICELLO",
  AmericaKnoxIn = "AMERICA_KNOX_IN",
  AmericaKralendijk = "AMERICA_KRALENDIJK",
  AmericaLaPaz = "AMERICA_LA_PAZ",
  AmericaLima = "AMERICA_LIMA",
  AmericaLosAngeles = "AMERICA_LOS_ANGELES",
  AmericaLouisville = "AMERICA_LOUISVILLE",
  AmericaLowerPrinces = "AMERICA_LOWER_PRINCES",
  AmericaMaceio = "AMERICA_MACEIO",
  AmericaManagua = "AMERICA_MANAGUA",
  AmericaManaus = "AMERICA_MANAUS",
  AmericaMarigot = "AMERICA_MARIGOT",
  AmericaMartinique = "AMERICA_MARTINIQUE",
  AmericaMatamoros = "AMERICA_MATAMOROS",
  AmericaMazatlan = "AMERICA_MAZATLAN",
  AmericaMendoza = "AMERICA_MENDOZA",
  AmericaMenominee = "AMERICA_MENOMINEE",
  AmericaMerida = "AMERICA_MERIDA",
  AmericaMetlakatla = "AMERICA_METLAKATLA",
  AmericaMexicoCity = "AMERICA_MEXICO_CITY",
  AmericaMiquelon = "AMERICA_MIQUELON",
  AmericaMoncton = "AMERICA_MONCTON",
  AmericaMonterrey = "AMERICA_MONTERREY",
  AmericaMontevideo = "AMERICA_MONTEVIDEO",
  AmericaMontreal = "AMERICA_MONTREAL",
  AmericaMontserrat = "AMERICA_MONTSERRAT",
  AmericaNassau = "AMERICA_NASSAU",
  AmericaNewYork = "AMERICA_NEW_YORK",
  AmericaNipigon = "AMERICA_NIPIGON",
  AmericaNome = "AMERICA_NOME",
  AmericaNoronha = "AMERICA_NORONHA",
  AmericaNorthDakotaBeulah = "AMERICA_NORTH_DAKOTA_BEULAH",
  AmericaNorthDakotaCenter = "AMERICA_NORTH_DAKOTA_CENTER",
  AmericaNorthDakotaNewSalem = "AMERICA_NORTH_DAKOTA_NEW_SALEM",
  AmericaNuuk = "AMERICA_NUUK",
  AmericaOjinaga = "AMERICA_OJINAGA",
  AmericaPanama = "AMERICA_PANAMA",
  AmericaPangnirtung = "AMERICA_PANGNIRTUNG",
  AmericaParamaribo = "AMERICA_PARAMARIBO",
  AmericaPhoenix = "AMERICA_PHOENIX",
  AmericaPortAuPrince = "AMERICA_PORT_AU_PRINCE",
  AmericaPortOfSpain = "AMERICA_PORT_OF_SPAIN",
  AmericaPortoAcre = "AMERICA_PORTO_ACRE",
  AmericaPortoVelho = "AMERICA_PORTO_VELHO",
  AmericaPuertoRico = "AMERICA_PUERTO_RICO",
  AmericaPuntaArenas = "AMERICA_PUNTA_ARENAS",
  AmericaRainyRiver = "AMERICA_RAINY_RIVER",
  AmericaRankinInlet = "AMERICA_RANKIN_INLET",
  AmericaRecife = "AMERICA_RECIFE",
  AmericaRegina = "AMERICA_REGINA",
  AmericaResolute = "AMERICA_RESOLUTE",
  AmericaRioBranco = "AMERICA_RIO_BRANCO",
  AmericaRosario = "AMERICA_ROSARIO",
  AmericaSantaIsabel = "AMERICA_SANTA_ISABEL",
  AmericaSantarem = "AMERICA_SANTAREM",
  AmericaSantiago = "AMERICA_SANTIAGO",
  AmericaSantoDomingo = "AMERICA_SANTO_DOMINGO",
  AmericaSaoPaulo = "AMERICA_SAO_PAULO",
  AmericaScoresbysund = "AMERICA_SCORESBYSUND",
  AmericaShiprock = "AMERICA_SHIPROCK",
  AmericaSitka = "AMERICA_SITKA",
  AmericaStBarthelemy = "AMERICA_ST_BARTHELEMY",
  AmericaStJohns = "AMERICA_ST_JOHNS",
  AmericaStKitts = "AMERICA_ST_KITTS",
  AmericaStLucia = "AMERICA_ST_LUCIA",
  AmericaStThomas = "AMERICA_ST_THOMAS",
  AmericaStVincent = "AMERICA_ST_VINCENT",
  AmericaSwiftCurrent = "AMERICA_SWIFT_CURRENT",
  AmericaTegucigalpa = "AMERICA_TEGUCIGALPA",
  AmericaThule = "AMERICA_THULE",
  AmericaThunderBay = "AMERICA_THUNDER_BAY",
  AmericaTijuana = "AMERICA_TIJUANA",
  AmericaToronto = "AMERICA_TORONTO",
  AmericaTortola = "AMERICA_TORTOLA",
  AmericaVancouver = "AMERICA_VANCOUVER",
  AmericaVirgin = "AMERICA_VIRGIN",
  AmericaWhitehorse = "AMERICA_WHITEHORSE",
  AmericaWinnipeg = "AMERICA_WINNIPEG",
  AmericaYakutat = "AMERICA_YAKUTAT",
  AmericaYellowknife = "AMERICA_YELLOWKNIFE",
  AntarcticaCasey = "ANTARCTICA_CASEY",
  AntarcticaDavis = "ANTARCTICA_DAVIS",
  AntarcticaDumontdurville = "ANTARCTICA_DUMONTDURVILLE",
  AntarcticaMacquarie = "ANTARCTICA_MACQUARIE",
  AntarcticaMawson = "ANTARCTICA_MAWSON",
  AntarcticaMcmurdo = "ANTARCTICA_MCMURDO",
  AntarcticaPalmer = "ANTARCTICA_PALMER",
  AntarcticaRothera = "ANTARCTICA_ROTHERA",
  AntarcticaSouthPole = "ANTARCTICA_SOUTH_POLE",
  AntarcticaSyowa = "ANTARCTICA_SYOWA",
  AntarcticaTroll = "ANTARCTICA_TROLL",
  AntarcticaVostok = "ANTARCTICA_VOSTOK",
  ArcticLongyearbyen = "ARCTIC_LONGYEARBYEN",
  AsiaAden = "ASIA_ADEN",
  AsiaAlmaty = "ASIA_ALMATY",
  AsiaAmman = "ASIA_AMMAN",
  AsiaAnadyr = "ASIA_ANADYR",
  AsiaAqtau = "ASIA_AQTAU",
  AsiaAqtobe = "ASIA_AQTOBE",
  AsiaAshgabat = "ASIA_ASHGABAT",
  AsiaAshkhabad = "ASIA_ASHKHABAD",
  AsiaAtyrau = "ASIA_ATYRAU",
  AsiaBaghdad = "ASIA_BAGHDAD",
  AsiaBahrain = "ASIA_BAHRAIN",
  AsiaBaku = "ASIA_BAKU",
  AsiaBangkok = "ASIA_BANGKOK",
  AsiaBarnaul = "ASIA_BARNAUL",
  AsiaBeirut = "ASIA_BEIRUT",
  AsiaBishkek = "ASIA_BISHKEK",
  AsiaBrunei = "ASIA_BRUNEI",
  AsiaCalcutta = "ASIA_CALCUTTA",
  AsiaChita = "ASIA_CHITA",
  AsiaChoibalsan = "ASIA_CHOIBALSAN",
  AsiaChongqing = "ASIA_CHONGQING",
  AsiaChungking = "ASIA_CHUNGKING",
  AsiaColombo = "ASIA_COLOMBO",
  AsiaDacca = "ASIA_DACCA",
  AsiaDamascus = "ASIA_DAMASCUS",
  AsiaDhaka = "ASIA_DHAKA",
  AsiaDili = "ASIA_DILI",
  AsiaDubai = "ASIA_DUBAI",
  AsiaDushanbe = "ASIA_DUSHANBE",
  AsiaFamagusta = "ASIA_FAMAGUSTA",
  AsiaGaza = "ASIA_GAZA",
  AsiaHarbin = "ASIA_HARBIN",
  AsiaHebron = "ASIA_HEBRON",
  AsiaHoChiMinh = "ASIA_HO_CHI_MINH",
  AsiaHongKong = "ASIA_HONG_KONG",
  AsiaHovd = "ASIA_HOVD",
  AsiaIrkutsk = "ASIA_IRKUTSK",
  AsiaIstanbul = "ASIA_ISTANBUL",
  AsiaJakarta = "ASIA_JAKARTA",
  AsiaJayapura = "ASIA_JAYAPURA",
  AsiaJerusalem = "ASIA_JERUSALEM",
  AsiaKabul = "ASIA_KABUL",
  AsiaKamchatka = "ASIA_KAMCHATKA",
  AsiaKarachi = "ASIA_KARACHI",
  AsiaKashgar = "ASIA_KASHGAR",
  AsiaKathmandu = "ASIA_KATHMANDU",
  AsiaKatmandu = "ASIA_KATMANDU",
  AsiaKhandyga = "ASIA_KHANDYGA",
  AsiaKolkata = "ASIA_KOLKATA",
  AsiaKrasnoyarsk = "ASIA_KRASNOYARSK",
  AsiaKualaLumpur = "ASIA_KUALA_LUMPUR",
  AsiaKuching = "ASIA_KUCHING",
  AsiaKuwait = "ASIA_KUWAIT",
  AsiaMacao = "ASIA_MACAO",
  AsiaMacau = "ASIA_MACAU",
  AsiaMagadan = "ASIA_MAGADAN",
  AsiaMakassar = "ASIA_MAKASSAR",
  AsiaManila = "ASIA_MANILA",
  AsiaMuscat = "ASIA_MUSCAT",
  AsiaNicosia = "ASIA_NICOSIA",
  AsiaNovokuznetsk = "ASIA_NOVOKUZNETSK",
  AsiaNovosibirsk = "ASIA_NOVOSIBIRSK",
  AsiaOmsk = "ASIA_OMSK",
  AsiaOral = "ASIA_ORAL",
  AsiaPhnomPenh = "ASIA_PHNOM_PENH",
  AsiaPontianak = "ASIA_PONTIANAK",
  AsiaPyongyang = "ASIA_PYONGYANG",
  AsiaQatar = "ASIA_QATAR",
  AsiaQostanay = "ASIA_QOSTANAY",
  AsiaQyzylorda = "ASIA_QYZYLORDA",
  AsiaRangoon = "ASIA_RANGOON",
  AsiaRiyadh = "ASIA_RIYADH",
  AsiaSaigon = "ASIA_SAIGON",
  AsiaSakhalin = "ASIA_SAKHALIN",
  AsiaSamarkand = "ASIA_SAMARKAND",
  AsiaSeoul = "ASIA_SEOUL",
  AsiaShanghai = "ASIA_SHANGHAI",
  AsiaSingapore = "ASIA_SINGAPORE",
  AsiaSrednekolymsk = "ASIA_SREDNEKOLYMSK",
  AsiaTaipei = "ASIA_TAIPEI",
  AsiaTashkent = "ASIA_TASHKENT",
  AsiaTbilisi = "ASIA_TBILISI",
  AsiaTehran = "ASIA_TEHRAN",
  AsiaTelAviv = "ASIA_TEL_AVIV",
  AsiaThimbu = "ASIA_THIMBU",
  AsiaThimphu = "ASIA_THIMPHU",
  AsiaTokyo = "ASIA_TOKYO",
  AsiaTomsk = "ASIA_TOMSK",
  AsiaUjungPandang = "ASIA_UJUNG_PANDANG",
  AsiaUlaanbaatar = "ASIA_ULAANBAATAR",
  AsiaUlanBator = "ASIA_ULAN_BATOR",
  AsiaUrumqi = "ASIA_URUMQI",
  AsiaUstNera = "ASIA_UST_NERA",
  AsiaVientiane = "ASIA_VIENTIANE",
  AsiaVladivostok = "ASIA_VLADIVOSTOK",
  AsiaYakutsk = "ASIA_YAKUTSK",
  AsiaYangon = "ASIA_YANGON",
  AsiaYekaterinburg = "ASIA_YEKATERINBURG",
  AsiaYerevan = "ASIA_YEREVAN",
  AtlanticAzores = "ATLANTIC_AZORES",
  AtlanticBermuda = "ATLANTIC_BERMUDA",
  AtlanticCanary = "ATLANTIC_CANARY",
  AtlanticCapeVerde = "ATLANTIC_CAPE_VERDE",
  AtlanticFaeroe = "ATLANTIC_FAEROE",
  AtlanticFaroe = "ATLANTIC_FAROE",
  AtlanticJanMayen = "ATLANTIC_JAN_MAYEN",
  AtlanticMadeira = "ATLANTIC_MADEIRA",
  AtlanticReykjavik = "ATLANTIC_REYKJAVIK",
  AtlanticSouthGeorgia = "ATLANTIC_SOUTH_GEORGIA",
  AtlanticStHelena = "ATLANTIC_ST_HELENA",
  AtlanticStanley = "ATLANTIC_STANLEY",
  AustraliaAct = "AUSTRALIA_ACT",
  AustraliaAdelaide = "AUSTRALIA_ADELAIDE",
  AustraliaBrisbane = "AUSTRALIA_BRISBANE",
  AustraliaBrokenHill = "AUSTRALIA_BROKEN_HILL",
  AustraliaCanberra = "AUSTRALIA_CANBERRA",
  AustraliaCurrie = "AUSTRALIA_CURRIE",
  AustraliaDarwin = "AUSTRALIA_DARWIN",
  AustraliaEucla = "AUSTRALIA_EUCLA",
  AustraliaHobart = "AUSTRALIA_HOBART",
  AustraliaLhi = "AUSTRALIA_LHI",
  AustraliaLindeman = "AUSTRALIA_LINDEMAN",
  AustraliaLordHowe = "AUSTRALIA_LORD_HOWE",
  AustraliaMelbourne = "AUSTRALIA_MELBOURNE",
  AustraliaNsw = "AUSTRALIA_NSW",
  AustraliaNorth = "AUSTRALIA_NORTH",
  AustraliaPerth = "AUSTRALIA_PERTH",
  AustraliaQueensland = "AUSTRALIA_QUEENSLAND",
  AustraliaSouth = "AUSTRALIA_SOUTH",
  AustraliaSydney = "AUSTRALIA_SYDNEY",
  AustraliaTasmania = "AUSTRALIA_TASMANIA",
  AustraliaVictoria = "AUSTRALIA_VICTORIA",
  AustraliaWest = "AUSTRALIA_WEST",
  AustraliaYancowinna = "AUSTRALIA_YANCOWINNA",
  BrazilAcre = "BRAZIL_ACRE",
  BrazilDenoronha = "BRAZIL_DENORONHA",
  BrazilEast = "BRAZIL_EAST",
  BrazilWest = "BRAZIL_WEST",
  Cet = "CET",
  Cst6Cdt = "CST6CDT",
  CanadaAtlantic = "CANADA_ATLANTIC",
  CanadaCentral = "CANADA_CENTRAL",
  CanadaEastern = "CANADA_EASTERN",
  CanadaMountain = "CANADA_MOUNTAIN",
  CanadaNewfoundland = "CANADA_NEWFOUNDLAND",
  CanadaPacific = "CANADA_PACIFIC",
  CanadaSaskatchewan = "CANADA_SASKATCHEWAN",
  CanadaYukon = "CANADA_YUKON",
  ChileContinental = "CHILE_CONTINENTAL",
  ChileEasterisland = "CHILE_EASTERISLAND",
  Cuba = "CUBA",
  Eet = "EET",
  Est = "EST",
  Est5Edt = "EST5EDT",
  Egypt = "EGYPT",
  Eire = "EIRE",
  EtcGmt = "ETC_GMT",
  EtcGmt_0 = "ETC_GMT_0",
  EtcGmt_1 = "ETC_GMT_1",
  EtcGmt_10 = "ETC_GMT_10",
  EtcGmt_11 = "ETC_GMT_11",
  EtcGmt_12 = "ETC_GMT_12",
  EtcGmt_2 = "ETC_GMT_2",
  EtcGmt_3 = "ETC_GMT_3",
  EtcGmt_4 = "ETC_GMT_4",
  EtcGmt_5 = "ETC_GMT_5",
  EtcGmt_6 = "ETC_GMT_6",
  EtcGmt_7 = "ETC_GMT_7",
  EtcGmt_8 = "ETC_GMT_8",
  EtcGmt_9 = "ETC_GMT_9",
  EtcGmt_0_404 = "ETC_GMT_0_404",
  EtcGmt_1_405 = "ETC_GMT_1_405",
  EtcGmt_10_406 = "ETC_GMT_10_406",
  EtcGmt_11_407 = "ETC_GMT_11_407",
  EtcGmt_12_408 = "ETC_GMT_12_408",
  EtcGmt_13 = "ETC_GMT_13",
  EtcGmt_14 = "ETC_GMT_14",
  EtcGmt_2_411 = "ETC_GMT_2_411",
  EtcGmt_3_412 = "ETC_GMT_3_412",
  EtcGmt_4_413 = "ETC_GMT_4_413",
  EtcGmt_5_414 = "ETC_GMT_5_414",
  EtcGmt_6_415 = "ETC_GMT_6_415",
  EtcGmt_7_416 = "ETC_GMT_7_416",
  EtcGmt_8_417 = "ETC_GMT_8_417",
  EtcGmt_9_418 = "ETC_GMT_9_418",
  EtcGmt0 = "ETC_GMT0",
  EtcGreenwich = "ETC_GREENWICH",
  EtcUct = "ETC_UCT",
  EtcUtc = "ETC_UTC",
  EtcUniversal = "ETC_UNIVERSAL",
  EtcZulu = "ETC_ZULU",
  EuropeAmsterdam = "EUROPE_AMSTERDAM",
  EuropeAndorra = "EUROPE_ANDORRA",
  EuropeAstrakhan = "EUROPE_ASTRAKHAN",
  EuropeAthens = "EUROPE_ATHENS",
  EuropeBelfast = "EUROPE_BELFAST",
  EuropeBelgrade = "EUROPE_BELGRADE",
  EuropeBerlin = "EUROPE_BERLIN",
  EuropeBratislava = "EUROPE_BRATISLAVA",
  EuropeBrussels = "EUROPE_BRUSSELS",
  EuropeBucharest = "EUROPE_BUCHAREST",
  EuropeBudapest = "EUROPE_BUDAPEST",
  EuropeBusingen = "EUROPE_BUSINGEN",
  EuropeChisinau = "EUROPE_CHISINAU",
  EuropeCopenhagen = "EUROPE_COPENHAGEN",
  EuropeDublin = "EUROPE_DUBLIN",
  EuropeGibraltar = "EUROPE_GIBRALTAR",
  EuropeGuernsey = "EUROPE_GUERNSEY",
  EuropeHelsinki = "EUROPE_HELSINKI",
  EuropeIsleOfMan = "EUROPE_ISLE_OF_MAN",
  EuropeIstanbul = "EUROPE_ISTANBUL",
  EuropeJersey = "EUROPE_JERSEY",
  EuropeKaliningrad = "EUROPE_KALININGRAD",
  EuropeKiev = "EUROPE_KIEV",
  EuropeKirov = "EUROPE_KIROV",
  EuropeKyiv = "EUROPE_KYIV",
  EuropeLisbon = "EUROPE_LISBON",
  EuropeLjubljana = "EUROPE_LJUBLJANA",
  EuropeLondon = "EUROPE_LONDON",
  EuropeLuxembourg = "EUROPE_LUXEMBOURG",
  EuropeMadrid = "EUROPE_MADRID",
  EuropeMalta = "EUROPE_MALTA",
  EuropeMariehamn = "EUROPE_MARIEHAMN",
  EuropeMinsk = "EUROPE_MINSK",
  EuropeMonaco = "EUROPE_MONACO",
  EuropeMoscow = "EUROPE_MOSCOW",
  EuropeNicosia = "EUROPE_NICOSIA",
  EuropeOslo = "EUROPE_OSLO",
  EuropeParis = "EUROPE_PARIS",
  EuropePodgorica = "EUROPE_PODGORICA",
  EuropePrague = "EUROPE_PRAGUE",
  EuropeRiga = "EUROPE_RIGA",
  EuropeRome = "EUROPE_ROME",
  EuropeSamara = "EUROPE_SAMARA",
  EuropeSanMarino = "EUROPE_SAN_MARINO",
  EuropeSarajevo = "EUROPE_SARAJEVO",
  EuropeSaratov = "EUROPE_SARATOV",
  EuropeSimferopol = "EUROPE_SIMFEROPOL",
  EuropeSkopje = "EUROPE_SKOPJE",
  EuropeSofia = "EUROPE_SOFIA",
  EuropeStockholm = "EUROPE_STOCKHOLM",
  EuropeTallinn = "EUROPE_TALLINN",
  EuropeTirane = "EUROPE_TIRANE",
  EuropeTiraspol = "EUROPE_TIRASPOL",
  EuropeUlyanovsk = "EUROPE_ULYANOVSK",
  EuropeUzhgorod = "EUROPE_UZHGOROD",
  EuropeVaduz = "EUROPE_VADUZ",
  EuropeVatican = "EUROPE_VATICAN",
  EuropeVienna = "EUROPE_VIENNA",
  EuropeVilnius = "EUROPE_VILNIUS",
  EuropeVolgograd = "EUROPE_VOLGOGRAD",
  EuropeWarsaw = "EUROPE_WARSAW",
  EuropeZagreb = "EUROPE_ZAGREB",
  EuropeZaporozhye = "EUROPE_ZAPOROZHYE",
  EuropeZurich = "EUROPE_ZURICH",
  Gb = "GB",
  GbEire = "GB_EIRE",
  Gmt = "GMT",
  Gmt_0 = "GMT_0",
  Gmt_0_493 = "GMT_0_493",
  Gmt0 = "GMT0",
  Greenwich = "GREENWICH",
  Hst = "HST",
  Hongkong = "HONGKONG",
  Iceland = "ICELAND",
  IndianAntananarivo = "INDIAN_ANTANANARIVO",
  IndianChagos = "INDIAN_CHAGOS",
  IndianChristmas = "INDIAN_CHRISTMAS",
  IndianCocos = "INDIAN_COCOS",
  IndianComoro = "INDIAN_COMORO",
  IndianKerguelen = "INDIAN_KERGUELEN",
  IndianMahe = "INDIAN_MAHE",
  IndianMaldives = "INDIAN_MALDIVES",
  IndianMauritius = "INDIAN_MAURITIUS",
  IndianMayotte = "INDIAN_MAYOTTE",
  IndianReunion = "INDIAN_REUNION",
  Iran = "IRAN",
  Israel = "ISRAEL",
  Jamaica = "JAMAICA",
  Japan = "JAPAN",
  Kwajalein = "KWAJALEIN",
  Libya = "LIBYA",
  Met = "MET",
  Mst = "MST",
  Mst7Mdt = "MST7MDT",
  MexicoBajanorte = "MEXICO_BAJANORTE",
  MexicoBajasur = "MEXICO_BAJASUR",
  MexicoGeneral = "MEXICO_GENERAL",
  Nz = "NZ",
  NzChat = "NZ_CHAT",
  Navajo = "NAVAJO",
  Prc = "PRC",
  Pst8Pdt = "PST8PDT",
  PacificApia = "PACIFIC_APIA",
  PacificAuckland = "PACIFIC_AUCKLAND",
  PacificBougainville = "PACIFIC_BOUGAINVILLE",
  PacificChatham = "PACIFIC_CHATHAM",
  PacificChuuk = "PACIFIC_CHUUK",
  PacificEaster = "PACIFIC_EASTER",
  PacificEfate = "PACIFIC_EFATE",
  PacificEnderbury = "PACIFIC_ENDERBURY",
  PacificFakaofo = "PACIFIC_FAKAOFO",
  PacificFiji = "PACIFIC_FIJI",
  PacificFunafuti = "PACIFIC_FUNAFUTI",
  PacificGalapagos = "PACIFIC_GALAPAGOS",
  PacificGambier = "PACIFIC_GAMBIER",
  PacificGuadalcanal = "PACIFIC_GUADALCANAL",
  PacificGuam = "PACIFIC_GUAM",
  PacificHonolulu = "PACIFIC_HONOLULU",
  PacificJohnston = "PACIFIC_JOHNSTON",
  PacificKanton = "PACIFIC_KANTON",
  PacificKiritimati = "PACIFIC_KIRITIMATI",
  PacificKosrae = "PACIFIC_KOSRAE",
  PacificKwajalein = "PACIFIC_KWAJALEIN",
  PacificMajuro = "PACIFIC_MAJURO",
  PacificMarquesas = "PACIFIC_MARQUESAS",
  PacificMidway = "PACIFIC_MIDWAY",
  PacificNauru = "PACIFIC_NAURU",
  PacificNiue = "PACIFIC_NIUE",
  PacificNorfolk = "PACIFIC_NORFOLK",
  PacificNoumea = "PACIFIC_NOUMEA",
  PacificPagoPago = "PACIFIC_PAGO_PAGO",
  PacificPalau = "PACIFIC_PALAU",
  PacificPitcairn = "PACIFIC_PITCAIRN",
  PacificPohnpei = "PACIFIC_POHNPEI",
  PacificPonape = "PACIFIC_PONAPE",
  PacificPortMoresby = "PACIFIC_PORT_MORESBY",
  PacificRarotonga = "PACIFIC_RAROTONGA",
  PacificSaipan = "PACIFIC_SAIPAN",
  PacificSamoa = "PACIFIC_SAMOA",
  PacificTahiti = "PACIFIC_TAHITI",
  PacificTarawa = "PACIFIC_TARAWA",
  PacificTongatapu = "PACIFIC_TONGATAPU",
  PacificTruk = "PACIFIC_TRUK",
  PacificWake = "PACIFIC_WAKE",
  PacificWallis = "PACIFIC_WALLIS",
  PacificYap = "PACIFIC_YAP",
  Poland = "POLAND",
  Portugal = "PORTUGAL",
  Roc = "ROC",
  Rok = "ROK",
  Singapore = "SINGAPORE",
  Turkey = "TURKEY",
  Uct = "UCT",
  UsAlaska = "US_ALASKA",
  UsAleutian = "US_ALEUTIAN",
  UsArizona = "US_ARIZONA",
  UsCentral = "US_CENTRAL",
  UsEastIndiana = "US_EAST_INDIANA",
  UsEastern = "US_EASTERN",
  UsHawaii = "US_HAWAII",
  UsIndianaStarke = "US_INDIANA_STARKE",
  UsMichigan = "US_MICHIGAN",
  UsMountain = "US_MOUNTAIN",
  UsPacific = "US_PACIFIC",
  UsSamoa = "US_SAMOA",
  Utc = "UTC",
  Universal = "UNIVERSAL",
  WSu = "W_SU",
  Wet = "WET",
  Zulu = "ZULU",
}

export type UserDetailType = {
  __typename?: "UserDetailType";
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  uuid: Scalars["UUID"];
  userObj: UserType;
  photo?: Maybe<Scalars["String"]>;
  role: Array<RoleType>;
  addresses: Array<AddressType>;
  timezone: UserDetailTimezone;
  deactivatedDateTime?: Maybe<Scalars["DateTime"]>;
  hasLoggedInWebAppAfterRebrand: Scalars["Boolean"];
  hasBiometricsFeaturesEnabled: Scalars["Boolean"];
  reasonForDeactivation?: Maybe<Scalars["String"]>;
  biometricsModalDisplayedAfter?: Maybe<Scalars["DateTime"]>;
  hasClickedBiometricsModalTellMeMore: Scalars["Boolean"];
  hasClickedBiometricsModalRemindMeLater: Scalars["Boolean"];
  biometricsModalNextTriggerDate?: Maybe<Scalars["Date"]>;
  hasClickedBiometricsModalDontAskAgain: Scalars["Boolean"];
  hasTrackBiometricsCtaEnabled: Scalars["Boolean"];
  shouldShowBiometricsWebModal: Scalars["Boolean"];
  hasDismissedBiometricsWebModal: Scalars["Boolean"];
  signedUpVia?: Maybe<Scalars["String"]>;
  hasExperiencedTheAppleHealthConnectionPermissionsIssue: Scalars["Boolean"];
  hasDismissedConnectBiometricsActionPrompt: Scalars["Boolean"];
  hasWoneCoachFeaturesEnabled: Scalars["Boolean"];
  hasWoneCalendarFeaturesEnabled: Scalars["Boolean"];
  hasWoneCalendarAutomaticEventsFeaturesEnabled: Scalars["Boolean"];
  invitationSentAt?: Maybe<Scalars["DateTime"]>;
  accessInitializedAt?: Maybe<Scalars["DateTime"]>;
  firstLogin?: Maybe<Scalars["DateTime"]>;
  usernotificationpermissions?: Maybe<UserNotificationPermissionsType>;
  studentdetail?: Maybe<StudentDetailType>;
  teacherdetail?: Maybe<TeacherDetailType>;
  biometricsvitaluser?: Maybe<BiometricsVitalUserType>;
};

export type UserJoinedGroupSession = {
  __typename?: "UserJoinedGroupSession";
  ok?: Maybe<Scalars["Boolean"]>;
  eventCreated?: Maybe<Scalars["Boolean"]>;
  groupSessionPersonJoining?: Maybe<GroupSessionPeopleJoiningType>;
};

export type UserJoinedGroupSessionInput = {
  groupSessionInstanceID: Scalars["ID"];
  sessionJoiningPlatform: Scalars["String"];
};

export type UserNotificationPermissionsType = {
  __typename?: "UserNotificationPermissionsType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  userdetailObj: UserDetailType;
  sessionReminders?: Maybe<Scalars["Boolean"]>;
  permissionToSendCalendarInvites?: Maybe<Scalars["Boolean"]>;
  biometricsPushNotifications?: Maybe<Scalars["Boolean"]>;
  smartCalendarInvites?: Maybe<Scalars["Boolean"]>;
  mindfulMoments?: Maybe<Scalars["Boolean"]>;
  trackingAndGoals?: Maybe<Scalars["Boolean"]>;
};

export type UserProfiles = {
  __typename?: "UserProfiles";
  learner?: Maybe<Learner>;
  companyAdmin?: Maybe<CompanyAdmin>;
};

export type UserType = {
  __typename?: "UserType";
  id: Scalars["ID"];
  lastLogin?: Maybe<Scalars["DateTime"]>;
  isSuperuser: Scalars["Boolean"];
  username: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email: Scalars["String"];
  isStaff: Scalars["Boolean"];
  isActive: Scalars["Boolean"];
  dateJoined: Scalars["DateTime"];
  fcmdeviceSet: Array<FcmDeviceTypeModel>;
  userdetail?: Maybe<UserDetailType>;
  groupsessionSet: Array<GroupSessionType>;
  groupsessionpeoplejoiningSet: Array<GroupSessionPeopleJoiningType>;
  classsessionSet: Array<ClassSessionType>;
  wonecalendareventSet: Array<WoneCalendarEventType>;
  biometrics?: Maybe<BiometricsType>;
  isFirstSignIn?: Maybe<Scalars["String"]>;
};

export type Verify = {
  __typename?: "Verify";
  payload: Scalars["GenericScalar"];
};

export type VerifyToken = {
  __typename?: "VerifyToken";
  success: Scalars["String"];
  email?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  subTitle?: Maybe<Scalars["String"]>;
  pageState: Scalars["String"];
  companyLogo?: Maybe<Scalars["String"]>;
};

export type VitalProviderType = {
  __typename?: "VitalProviderType";
  name?: Maybe<Scalars["String"]>;
  slug?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  logo?: Maybe<Scalars["String"]>;
  authType?: Maybe<Scalars["String"]>;
  supportedResources?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type WelcomeScreen = {
  __typename?: "WelcomeScreen";
  titleHtml: Scalars["String"];
  subtitleHtml: Scalars["String"];
  buttonText?: Maybe<Scalars["String"]>;
};

export enum WoneCalendarEventSessionType {
  Live = "LIVE",
  Recording = "RECORDING",
}

export enum WoneCalendarEventStatus {
  Pending = "PENDING",
  Sent = "SENT",
}

export type WoneCalendarEventType = {
  __typename?: "WoneCalendarEventType";
  id: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  user: UserType;
  sessionType: WoneCalendarEventSessionType;
  status: WoneCalendarEventStatus;
  session?: Maybe<GroupSessionInstanceType>;
  eventId: Scalars["String"];
  createdDatetime: Scalars["DateTime"];
  subject: Scalars["String"];
  startDateTime: Scalars["DateTime"];
  startTimeZone: Scalars["String"];
  endDateTime: Scalars["DateTime"];
  endTimeZone: Scalars["String"];
  organizerEmail: Scalars["String"];
  eventDataJson?: Maybe<Scalars["JSONString"]>;
};

export type LearnerGroupSessionsListPartsFragment = {
  __typename?: "LearnerGroupSessionsList";
} & Pick<LearnerGroupSessionsList, "id" | "label"> & {
    items: Array<
      {
        __typename: "LearnerGroupSession";
      } & LearnerSessionCardParts_LearnerGroupSession_Fragment
    >;
  };

export type LearnerFeaturedSessionsListPartsFragment = {
  __typename?: "LearnerFeaturedSessionList";
} & Pick<LearnerFeaturedSessionList, "id" | "label"> & {
    items: Array<
      | ({
          __typename: "LearnerGroupSession";
        } & LearnerSessionCardParts_LearnerGroupSession_Fragment)
      | { __typename: "LearnerPrivateSession" }
    >;
  };

export type LearnerSessionsListPartsFragment = {
  __typename?: "LearnerSessionsList";
} & Pick<LearnerSessionsList, "id" | "label"> & {
    items: Array<
      | ({
          __typename: "LearnerGroupSession";
        } & LearnerSessionCardParts_LearnerGroupSession_Fragment)
      | { __typename: "LearnerPrivateSession" }
    >;
  };

export type LearnerGroupSessionPartsFragment = {
  __typename?: "LearnerGroupSession";
} & Pick<
  LearnerGroupSession,
  | "id"
  | "title"
  | "subtitle"
  | "pillarLabel"
  | "service"
  | "duration"
  | "filterTags"
  | "date"
  | "time"
  | "timeZone"
  | "about"
  | "imageUrl"
> & {
    equipment?: Maybe<
      Array<
        { __typename?: "LearnerEquipment" } & Pick<
          LearnerEquipment,
          "id" | "label" | "icon"
        >
      >
    >;
    preparation?: Maybe<
      { __typename?: "LearnerSessionPreparation" } & Pick<
        LearnerSessionPreparation,
        "title" | "textHtml"
      >
    >;
    practitioner: {
      __typename?: "LearnerPractitioner";
    } & LearnerPractitionerCardPartsFragment;
    buttons: { __typename?: "LearnerGroupSessionActionButtons" } & {
      join?: Maybe<
        { __typename?: "LearnerGroupSessionActionButton" } & Pick<
          LearnerGroupSessionActionButton,
          "style" | "action" | "text"
        >
      >;
      register?: Maybe<
        { __typename?: "LearnerGroupSessionActionButton" } & Pick<
          LearnerGroupSessionActionButton,
          "style" | "action" | "text"
        >
      >;
      unRegister?: Maybe<
        { __typename?: "LearnerGroupSessionActionButton" } & Pick<
          LearnerGroupSessionActionButton,
          "style" | "action" | "text"
        >
      >;
      trackBiometrics?: Maybe<
        { __typename?: "LearnerGroupSessionActionButton" } & Pick<
          LearnerGroupSessionActionButton,
          "style" | "action" | "text"
        >
      >;
    };
    buttonState: { __typename?: "LearnerGroupSessionButtonState" } & Pick<
      LearnerGroupSessionButtonState,
      | "isRegistered"
      | "isSessionOngoing"
      | "isSessionCompleted"
      | "shouldEnableTrackBiometrics"
    >;
    biometrics?: Maybe<
      { __typename?: "LearnerSessionBiometrics" } & Pick<
        LearnerSessionBiometrics,
        "label"
      >
    >;
  };

export type LearnerArticlePartsFragment = {
  __typename?: "LearnerArticle";
} & Pick<
  LearnerArticle,
  | "id"
  | "title"
  | "subtitle"
  | "pillarLabel"
  | "imageUrl"
  | "contentHtml"
  | "isFavourite"
>;

export type LearnerArticlesListPartsFragment = {
  __typename?: "LearnerArticlesList";
} & Pick<LearnerArticlesList, "id" | "label"> & {
    items: Array<
      { __typename: "LearnerArticle" } & LearnerArticlePartsFragment
    >;
  };

export type LearnerRecordingPartsFragment = {
  __typename?: "LearnerRecording";
} & Pick<
  LearnerRecording,
  | "id"
  | "title"
  | "subtitle"
  | "pillarLabel"
  | "service"
  | "videoUrl"
  | "videoThumbnailUrl"
  | "videoDurationText"
  | "imageUrl"
  | "about"
  | "isFavourite"
> & {
    equipment?: Maybe<
      Array<
        { __typename?: "LearnerEquipment" } & Pick<
          LearnerEquipment,
          "id" | "label" | "icon"
        >
      >
    >;
    practitioner: { __typename?: "LearnerPractitioner" } & Pick<
      LearnerPractitioner,
      "id" | "fullName" | "services"
    >;
    scheduledCalendarEvent?: Maybe<
      { __typename?: "LearnerScheduledCalendarEvent" } & Pick<
        LearnerScheduledCalendarEvent,
        "fromDatetimeUtc" | "toDatetimeUtc"
      >
    >;
  };

export type LearnerRecordingsListPartsFragment = {
  __typename?: "LearnerRecordingsList";
} & Pick<LearnerRecordingsList, "id" | "label"> & {
    items: Array<
      { __typename: "LearnerRecording" } & LearnerRecordingCardPartsFragment
    >;
  };

export type LearnerPractitionerCardPartsFragment = {
  __typename?: "LearnerPractitioner";
} & Pick<LearnerPractitioner, "id" | "fullName" | "photoUrl" | "services">;

export type LearnerPractitionerPartsFragment = {
  __typename?: "LearnerPractitioner";
} & Pick<
  LearnerPractitioner,
  "id" | "landscapeImageUrl" | "fullName" | "about" | "isFavourite"
> & {
    accreditation?: Maybe<
      { __typename?: "LearnerPractitionerAccreditation" } & Pick<
        LearnerPractitionerAccreditation,
        "title" | "items"
      >
    >;
    intro?: Maybe<
      { __typename?: "LearnerPractitionerIntro" } & Pick<
        LearnerPractitionerIntro,
        "title" | "textHtml" | "videoUrl" | "videoThumbnailUrl"
      >
    >;
    contentLists: Array<
      | { __typename: "LearnerSessionsList" }
      | ({
          __typename: "LearnerGroupSessionsList";
        } & LearnerGroupSessionsListPartsFragment)
      | { __typename: "LearnerPrivateSessionsList" }
      | ({
          __typename: "LearnerRecordingsList";
        } & LearnerRecordingsListPartsFragment)
    >;
  };

export type LearnerPractitionersListPartsFragment = {
  __typename?: "LearnerPractitionersList";
} & Pick<LearnerPractitionersList, "id" | "label"> & {
    items: Array<
      { __typename: "LearnerPractitioner" } & LearnerPractitionerPartsFragment
    >;
  };

export type LearnerOnboardingPartsFragment = {
  __typename: "LearnerOnboardingForm";
} & {
  intro: { __typename: "IntroScreen" } & Pick<
    IntroScreen,
    "titleHtml" | "subtitleHtml" | "buttonText" | "skipButtonText"
  >;
  inputs: Array<
    | ({ __typename: "SingleInputScreen" } & Pick<
        SingleInputScreen,
        "id" | "titleHtml" | "subtitleHtml" | "buttonText" | "skipButtonText"
      > & {
          input:
            | ({ __typename: "SelectInput" } & Pick<
                SelectInput,
                "id" | "label" | "required"
              > & {
                  options: Array<
                    { __typename: "SelectInputOption" } & Pick<
                      SelectInputOption,
                      "label" | "imageUrl" | "clickLink" | "value"
                    >
                  >;
                })
            | ({ __typename: "MultiSelectInput" } & Pick<
                MultiSelectInput,
                "id" | "required"
              > & {
                  options: Array<
                    { __typename: "SelectInputOption" } & Pick<
                      SelectInputOption,
                      "label" | "value"
                    >
                  >;
                })
            | { __typename: "TextInput" }
            | ({ __typename: "DateInput" } & Pick<
                DateInput,
                "id" | "label" | "required"
              >)
            | ({ __typename: "BooleanInput" } & Pick<
                BooleanInput,
                "id" | "label" | "required" | "reverseLogic"
              >)
            | { __typename: "RangeInput" }
            | { __typename: "ImageInput" };
        })
    | ({ __typename: "MultipleInputsScreen" } & Pick<
        MultipleInputsScreen,
        "id" | "titleHtml" | "subtitleHtml"
      > & {
          inputs: Array<
            | ({ __typename: "SelectInput" } & Pick<
                SelectInput,
                "id" | "label" | "required"
              > & {
                  options: Array<
                    { __typename: "SelectInputOption" } & Pick<
                      SelectInputOption,
                      "label" | "value"
                    >
                  >;
                })
            | ({ __typename: "MultiSelectInput" } & Pick<
                MultiSelectInput,
                "id" | "required"
              > & {
                  options: Array<
                    { __typename: "SelectInputOption" } & Pick<
                      SelectInputOption,
                      "label" | "value"
                    >
                  >;
                })
            | ({ __typename: "TextInput" } & Pick<
                TextInput,
                "id" | "label" | "required" | "minLength" | "maxLength"
              >)
            | ({ __typename: "DateInput" } & Pick<
                DateInput,
                "id" | "label" | "required"
              >)
            | ({ __typename: "BooleanInput" } & Pick<
                BooleanInput,
                "id" | "label" | "required" | "reverseLogic"
              >)
            | { __typename: "RangeInput" }
            | { __typename: "ImageInput" }
          >;
        })
  >;
  animation: Array<
    Maybe<
      { __typename: "ProgressAnimationFrame" } & Pick<
        ProgressAnimationFrame,
        | "percentageStart"
        | "percentageEnd"
        | "transitionDurationSec"
        | "textHtml"
      >
    >
  >;
};

export type LearnerPartsFragment = { __typename?: "Learner" } & Pick<
  Learner,
  "id" | "firstName" | "lastName" | "fullName" | "photoUrl" | "companyName"
>;

export type LearnerIndexAssessmentPartsFragment = {
  __typename?: "LearnerIndexAssessment";
} & Pick<LearnerIndexAssessment, "count" | "daysLeftToRetake"> & {
    insights?: Maybe<
      { __typename?: "LearnerIndexInsights" } & Pick<
        LearnerIndexInsights,
        "context" | "encouragement" | "pillar" | "theme" | "tips"
      >
    >;
  };

export type LearnerQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    onboarding?: Maybe<
      { __typename?: "LearnerOnboardingForm" } & LearnerOnboardingPartsFragment
    >;
    biometrics?: Maybe<
      { __typename?: "LearnerBiometrics" } & LearnerBiometricsPartsFragment
    >;
  } & LearnerPartsFragment;
};

export type LearnerYouExpandedQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerYouExpandedQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      you: { __typename?: "LearnerYouScreen" } & {
        welcome: { __typename?: "WelcomeScreen" } & Pick<
          WelcomeScreen,
          "titleHtml" | "subtitleHtml"
        >;
        indexScore?: Maybe<
          { __typename?: "LearnerIndexScore" } & Pick<
            LearnerIndexScore,
            "value" | "valueFloat" | "labelHtml" | "icon"
          >
        >;
        contentLists: Array<
          | ({
              __typename: "LearnerFeaturedSessionList";
            } & LearnerFeaturedSessionsListPartsFragment)
          | ({
              __typename: "LearnerSessionsList";
            } & LearnerSessionsListPartsFragment)
          | ({
              __typename: "LearnerGroupSessionsList";
            } & LearnerGroupSessionsListPartsFragment)
          | { __typename: "LearnerPrivateSessionsList" }
          | ({
              __typename: "LearnerRecordingsList";
            } & LearnerRecordingsListPartsFragment)
          | { __typename: "LearnerFeaturedRecordingList" }
          | { __typename: "LearnerFeaturedArticleList" }
          | ({
              __typename: "LearnerArticlesList";
            } & LearnerArticlesListPartsFragment)
          | ({
              __typename: "LearnerPractitionersList";
            } & LearnerPractitionersListPartsFragment)
        >;
      };
    };
  };
};

export type LearnerScreenYouQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerScreenYouQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      you: { __typename?: "LearnerYouScreen" } & {
        welcome: { __typename?: "WelcomeScreen" } & Pick<
          WelcomeScreen,
          "titleHtml" | "subtitleHtml"
        >;
        indexScore?: Maybe<
          { __typename?: "LearnerIndexScore" } & Pick<
            LearnerIndexScore,
            "value" | "valueFloat" | "labelHtml" | "icon"
          >
        >;
        contentLists: Array<
          | { __typename: "LearnerFeaturedSessionList" }
          | ({ __typename: "LearnerSessionsList" } & Pick<
              LearnerSessionsList,
              "id" | "label"
            > & {
                items: Array<
                  | ({ __typename: "LearnerGroupSession" } & Pick<
                      LearnerGroupSession,
                      | "id"
                      | "title"
                      | "subtitle"
                      | "pillarLabel"
                      | "service"
                      | "date"
                      | "time"
                      | "timeZone"
                      | "imageUrl"
                    >)
                  | { __typename: "LearnerPrivateSession" }
                >;
              })
          | ({ __typename: "LearnerGroupSessionsList" } & Pick<
              LearnerGroupSessionsList,
              "id" | "label"
            > & {
                items: Array<
                  { __typename: "LearnerGroupSession" } & Pick<
                    LearnerGroupSession,
                    | "id"
                    | "title"
                    | "subtitle"
                    | "pillarLabel"
                    | "service"
                    | "date"
                    | "time"
                    | "timeZone"
                    | "imageUrl"
                  >
                >;
              })
          | { __typename: "LearnerPrivateSessionsList" }
          | ({ __typename: "LearnerRecordingsList" } & Pick<
              LearnerRecordingsList,
              "id" | "label"
            > & {
                items: Array<
                  { __typename: "LearnerRecording" } & Pick<
                    LearnerRecording,
                    | "id"
                    | "title"
                    | "subtitle"
                    | "pillarLabel"
                    | "service"
                    | "videoDurationText"
                  >
                >;
              })
          | { __typename: "LearnerFeaturedRecordingList" }
          | { __typename: "LearnerFeaturedArticleList" }
          | ({ __typename: "LearnerArticlesList" } & Pick<
              LearnerArticlesList,
              "id" | "label"
            > & {
                items: Array<
                  { __typename: "LearnerArticle" } & Pick<
                    LearnerArticle,
                    "id" | "title" | "subtitle" | "imageUrl"
                  >
                >;
              })
          | ({ __typename: "LearnerPractitionersList" } & Pick<
              LearnerPractitionersList,
              "id" | "label"
            > & {
                items: Array<
                  { __typename: "LearnerPractitioner" } & Pick<
                    LearnerPractitioner,
                    "id" | "fullName" | "services"
                  >
                >;
              })
        >;
      };
    };
  };
};

type LearnerSessionCardParts_LearnerGroupSession_Fragment = {
  __typename: "LearnerGroupSession";
} & Pick<
  LearnerGroupSession,
  | "id"
  | "title"
  | "subtitle"
  | "pillarLabel"
  | "service"
  | "topic"
  | "duration"
  | "filterTags"
  | "date"
  | "time"
  | "timeZone"
  | "imageUrl"
>;

type LearnerSessionCardParts_LearnerPrivateSession_Fragment = {
  __typename: "LearnerPrivateSession";
} & Pick<
  LearnerPrivateSession,
  | "id"
  | "title"
  | "subtitle"
  | "pillarLabel"
  | "service"
  | "topic"
  | "duration"
  | "filterTags"
  | "date"
  | "time"
  | "timeZone"
  | "imageUrl"
>;

export type LearnerSessionCardPartsFragment =
  | LearnerSessionCardParts_LearnerGroupSession_Fragment
  | LearnerSessionCardParts_LearnerPrivateSession_Fragment;

type LearnerSessionCardBiometricsParts_LearnerGroupSession_Fragment = {
  __typename?: "LearnerGroupSession";
} & {
  biometrics?: Maybe<
    { __typename?: "LearnerSessionBiometrics" } & {
      heartrateGraph?: Maybe<
        { __typename?: "LearnerSessionBiometricsHeartrateGraph" } & Pick<
          LearnerSessionBiometricsHeartrateGraph,
          | "startValueLabel"
          | "endValueLabel"
          | "diffMessage"
          | "diffValueLabel"
          | "minValue"
          | "maxValue"
          | "stepValue"
          | "values"
          | "minTimeValue"
          | "maxTimeValue"
          | "stepTimeValue"
          | "timeValues"
        >
      >;
    }
  >;
} & LearnerSessionCardParts_LearnerGroupSession_Fragment;

type LearnerSessionCardBiometricsParts_LearnerPrivateSession_Fragment = {
  __typename?: "LearnerPrivateSession";
} & {
  biometrics?: Maybe<
    { __typename?: "LearnerSessionBiometrics" } & {
      heartrateGraph?: Maybe<
        { __typename?: "LearnerSessionBiometricsHeartrateGraph" } & Pick<
          LearnerSessionBiometricsHeartrateGraph,
          | "startValueLabel"
          | "endValueLabel"
          | "diffMessage"
          | "diffValueLabel"
          | "minValue"
          | "maxValue"
          | "stepValue"
          | "values"
          | "minTimeValue"
          | "maxTimeValue"
          | "stepTimeValue"
          | "timeValues"
        >
      >;
    }
  >;
} & LearnerSessionCardParts_LearnerPrivateSession_Fragment;

export type LearnerSessionCardBiometricsPartsFragment =
  | LearnerSessionCardBiometricsParts_LearnerGroupSession_Fragment
  | LearnerSessionCardBiometricsParts_LearnerPrivateSession_Fragment;

export type LearnerScreenSessionsOldQueryVariables = Exact<{
  appInfo: AppInfo;
  searchQuery: Scalars["String"];
  filters: LearnerContentListFilters;
}>;

export type LearnerScreenSessionsOldQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      sessions: { __typename?: "LearnerGroupSessionsScreen" } & Pick<
        LearnerGroupSessionsScreen,
        "title"
      > & {
          landingContentLists: Array<
            | ({ __typename: "LearnerFeaturedSessionList" } & Pick<
                LearnerFeaturedSessionList,
                "id" | "label"
              > & {
                  items: Array<
                    | ({
                        __typename?: "LearnerGroupSession";
                      } & LearnerSessionCardParts_LearnerGroupSession_Fragment)
                    | ({
                        __typename?: "LearnerPrivateSession";
                      } & LearnerSessionCardParts_LearnerPrivateSession_Fragment)
                  >;
                })
            | ({ __typename: "LearnerGroupSessionsList" } & Pick<
                LearnerGroupSessionsList,
                "id" | "label"
              > & {
                  items: Array<
                    {
                      __typename?: "LearnerGroupSession";
                    } & LearnerSessionCardParts_LearnerGroupSession_Fragment
                  >;
                })
          >;
          filteredContentList: {
            __typename: "LearnerGroupSessionsList";
          } & Pick<LearnerGroupSessionsList, "id"> & {
              filters: Array<
                Maybe<
                  { __typename: "MultiSelectInput" } & Pick<
                    MultiSelectInput,
                    "id" | "label"
                  > & {
                      options: Array<
                        { __typename?: "SelectInputOption" } & Pick<
                          SelectInputOption,
                          "value" | "label" | "imageUrl" | "selected"
                        >
                      >;
                    }
                >
              >;
              items: Array<
                {
                  __typename?: "LearnerGroupSession";
                } & LearnerSessionCardParts_LearnerGroupSession_Fragment
              >;
            };
        };
    };
  };
};

export type LearnerScreenSessionsQueryVariables = Exact<{
  appInfo: AppInfo;
  filters: LearnerContentListFilters;
}>;

export type LearnerScreenSessionsQuery = { __typename?: "Query" } & {
  learnerScreenSessions: { __typename?: "LearnerGroupSessionsScreen" } & Pick<
    LearnerGroupSessionsScreen,
    "title"
  > & {
      contentList: { __typename: "LearnerGroupSessionsList" } & Pick<
        LearnerGroupSessionsList,
        "id" | "filterTags" | "services" | "durations"
      > & {
          items: Array<
            {
              __typename?: "LearnerGroupSession";
            } & LearnerSessionCardWebParts_LearnerGroupSession_Fragment
          >;
        };
    };
};

type LearnerSessionCardWebParts_LearnerGroupSession_Fragment = {
  __typename?: "LearnerGroupSession";
} & {
  buttons: { __typename?: "LearnerGroupSessionActionButtons" } & {
    join?: Maybe<
      { __typename?: "LearnerGroupSessionActionButton" } & Pick<
        LearnerGroupSessionActionButton,
        "style" | "action" | "text"
      >
    >;
    register?: Maybe<
      { __typename?: "LearnerGroupSessionActionButton" } & Pick<
        LearnerGroupSessionActionButton,
        "style" | "action" | "text"
      >
    >;
    unRegister?: Maybe<
      { __typename?: "LearnerGroupSessionActionButton" } & Pick<
        LearnerGroupSessionActionButton,
        "style" | "action" | "text"
      >
    >;
    trackBiometrics?: Maybe<
      { __typename?: "LearnerGroupSessionActionButton" } & Pick<
        LearnerGroupSessionActionButton,
        "style" | "action" | "text"
      >
    >;
  };
  buttonState: { __typename?: "LearnerGroupSessionButtonState" } & Pick<
    LearnerGroupSessionButtonState,
    | "isRegistered"
    | "isSessionOngoing"
    | "isSessionCompleted"
    | "shouldEnableTrackBiometrics"
  >;
  practitioner: { __typename?: "LearnerPractitioner" } & Pick<
    LearnerPractitioner,
    "id" | "firstName" | "fullName"
  >;
} & LearnerSessionCardParts_LearnerGroupSession_Fragment;

type LearnerSessionCardWebParts_LearnerPrivateSession_Fragment = {
  __typename?: "LearnerPrivateSession";
} & {
  buttons: { __typename?: "LearnerGroupSessionActionButtons" } & {
    join?: Maybe<
      { __typename?: "LearnerGroupSessionActionButton" } & Pick<
        LearnerGroupSessionActionButton,
        "style" | "action" | "text"
      >
    >;
    register?: Maybe<
      { __typename?: "LearnerGroupSessionActionButton" } & Pick<
        LearnerGroupSessionActionButton,
        "style" | "action" | "text"
      >
    >;
    unRegister?: Maybe<
      { __typename?: "LearnerGroupSessionActionButton" } & Pick<
        LearnerGroupSessionActionButton,
        "style" | "action" | "text"
      >
    >;
    trackBiometrics?: Maybe<
      { __typename?: "LearnerGroupSessionActionButton" } & Pick<
        LearnerGroupSessionActionButton,
        "style" | "action" | "text"
      >
    >;
  };
  buttonState: { __typename?: "LearnerGroupSessionButtonState" } & Pick<
    LearnerGroupSessionButtonState,
    | "isRegistered"
    | "isSessionOngoing"
    | "isSessionCompleted"
    | "shouldEnableTrackBiometrics"
  >;
  practitioner: { __typename?: "LearnerPractitioner" } & Pick<
    LearnerPractitioner,
    "id" | "firstName" | "fullName"
  >;
} & LearnerSessionCardParts_LearnerPrivateSession_Fragment;

export type LearnerSessionCardWebPartsFragment =
  | LearnerSessionCardWebParts_LearnerGroupSession_Fragment
  | LearnerSessionCardWebParts_LearnerPrivateSession_Fragment;

export type LearnerScreenScheduleQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerScreenScheduleQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      schedule: { __typename?: "LearnerScheduleScreen" } & Pick<
        LearnerScheduleScreen,
        "title"
      > & {
          contentLists: Array<
            { __typename: "LearnerMixedContentList" } & Pick<
              LearnerMixedContentList,
              "id" | "label" | "filterTags" | "services" | "durations"
            > & {
                items: Array<
                  | ({
                      __typename?: "LearnerGroupSession";
                    } & LearnerSessionCardWebParts_LearnerGroupSession_Fragment)
                  | { __typename?: "LearnerRecording" }
                  | { __typename?: "LearnerArticle" }
                >;
              }
          >;
        };
    };
  };
};

export type LearnerScreenMixedContentScheduleQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerScreenMixedContentScheduleQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      schedule: { __typename?: "LearnerScheduleScreen" } & Pick<
        LearnerScheduleScreen,
        "title"
      > & {
          contentLists: Array<
            { __typename: "LearnerMixedContentList" } & Pick<
              LearnerMixedContentList,
              "id" | "label" | "filterTags" | "services" | "durations"
            > & {
                items: Array<
                  | ({
                      __typename: "LearnerGroupSession";
                    } & LearnerSessionCardWebParts_LearnerGroupSession_Fragment)
                  | ({
                      __typename: "LearnerRecording";
                    } & LearnerRecordingCardPartsFragment)
                  | { __typename: "LearnerArticle" }
                >;
              }
          >;
        };
    };
  };
};

export type LearnerArticleCardPartsFragment = {
  __typename?: "LearnerArticle";
} & Pick<
  LearnerArticle,
  | "id"
  | "title"
  | "subtitle"
  | "imageUrl"
  | "readTime"
  | "pillarLabel"
  | "filterTags"
>;

export type LearnerScreenArticlesQueryVariables = Exact<{
  appInfo: AppInfo;
  searchQuery: Scalars["String"];
  filters: LearnerContentListFilters;
}>;

export type LearnerScreenArticlesQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      articles: { __typename?: "LearnerArticlesScreen" } & Pick<
        LearnerArticlesScreen,
        "title"
      > & {
          landingContentLists: Array<
            | ({ __typename: "LearnerFeaturedArticleList" } & Pick<
                LearnerFeaturedArticleList,
                "id" | "label"
              > & {
                  items: Array<
                    {
                      __typename?: "LearnerArticle";
                    } & LearnerArticleCardPartsFragment
                  >;
                })
            | ({ __typename: "LearnerArticlesList" } & Pick<
                LearnerArticlesList,
                "id" | "label"
              > & {
                  items: Array<
                    {
                      __typename?: "LearnerArticle";
                    } & LearnerArticleCardPartsFragment
                  >;
                })
          >;
          filteredContentList: { __typename: "LearnerArticlesList" } & Pick<
            LearnerArticlesList,
            "id" | "filterTags" | "pillarLabels" | "durations"
          > & {
              items: Array<
                {
                  __typename?: "LearnerArticle";
                } & LearnerArticleCardPartsFragment
              >;
            };
        };
    };
  };
};

export type LearnerRecordingCardPartsFragment = {
  __typename?: "LearnerRecording";
} & Pick<
  LearnerRecording,
  | "id"
  | "title"
  | "subtitle"
  | "pillarLabel"
  | "service"
  | "topic"
  | "videoDurationText"
  | "sessionDuration"
  | "filterTags"
  | "imageUrl"
  | "isFavourite"
> & {
    practitioner: { __typename?: "LearnerPractitioner" } & Pick<
      LearnerPractitioner,
      "fullName"
    >;
  };

export type LearnerScreenRecordingsQueryVariables = Exact<{
  appInfo: AppInfo;
  searchQuery: Scalars["String"];
  filters: LearnerContentListFilters;
}>;

export type LearnerScreenRecordingsQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      recordings: { __typename?: "LearnerRecordingsScreen" } & Pick<
        LearnerRecordingsScreen,
        "title"
      > & {
          landingContentLists: Array<
            | ({ __typename: "LearnerFeaturedRecordingList" } & Pick<
                LearnerFeaturedRecordingList,
                "id" | "label"
              > & {
                  items: Array<
                    {
                      __typename?: "LearnerRecording";
                    } & LearnerRecordingCardPartsFragment
                  >;
                })
            | ({ __typename: "LearnerRecordingsList" } & Pick<
                LearnerRecordingsList,
                "id" | "label"
              > & {
                  items: Array<
                    {
                      __typename?: "LearnerRecording";
                    } & LearnerRecordingCardPartsFragment
                  >;
                })
          >;
          filteredContentList: { __typename: "LearnerRecordingsList" } & Pick<
            LearnerRecordingsList,
            "id" | "filterTags" | "services" | "durations"
          > & {
              items: Array<
                {
                  __typename?: "LearnerRecording";
                } & LearnerRecordingCardPartsFragment
              >;
            };
        };
    };
  };
};

export type LearnerOnDemandRecordingsScreenQueryVariables = Exact<{
  appInfo: AppInfo;
  searchQuery: Scalars["String"];
  filters?: Maybe<LearnerContentListFilters>;
}>;

export type LearnerOnDemandRecordingsScreenQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      onDemandRecordings: {
        __typename?: "LearnerOnDemandRecordingsScreen";
      } & Pick<LearnerOnDemandRecordingsScreen, "title"> & {
          landingContentLists: Array<
            | { __typename: "LearnerFeaturedRecordingList" }
            | ({ __typename: "LearnerRecordingsList" } & Pick<
                LearnerRecordingsList,
                "id" | "label"
              > & {
                  items: Array<
                    {
                      __typename?: "LearnerRecording";
                    } & LearnerRecordingCardPartsFragment
                  >;
                })
          >;
          filteredContentList: { __typename: "LearnerRecordingsList" } & Pick<
            LearnerRecordingsList,
            "id" | "filterTags" | "services" | "durations"
          > & {
              items: Array<
                {
                  __typename?: "LearnerRecording";
                } & LearnerRecordingCardPartsFragment
              >;
            };
        };
    };
  };
};

export type LearnerScreenFavouritesQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerScreenFavouritesQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      favourites?: Maybe<
        { __typename?: "LearnerFavouritesScreen" } & Pick<
          LearnerFavouritesScreen,
          "title"
        > & {
            recordingsList: { __typename: "LearnerRecordingsList" } & Pick<
              LearnerRecordingsList,
              "id" | "label"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerRecording";
                  } & LearnerRecordingCardPartsFragment
                >;
              };
            articlesList: { __typename?: "LearnerArticlesList" } & Pick<
              LearnerArticlesList,
              "id" | "label"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerArticle";
                  } & LearnerArticleCardPartsFragment
                >;
              };
          }
      >;
    };
  };
};

export type LearnerIndexScoreChangePartsFragment = {
  __typename?: "LearnerIndexScoreChange";
} & Pick<
  LearnerIndexScoreChange,
  | "percentage"
  | "daysSinceStart"
  | "textHtml"
  | "shortTextHtml"
  | "direction"
  | "startScore"
  | "startDate"
  | "endScore"
  | "endDate"
>;

export type LearnerIndexScoreDataPeriodPartsFragment = {
  __typename?: "LearnerIndexScoreDataPeriod";
} & Pick<
  LearnerIndexScoreDataPeriod,
  | "label"
  | "previousLabel"
  | "nextLabel"
  | "startDate"
  | "endDate"
  | "hasAssessmentValues"
  | "hasBiometricsValues"
  | "averageValue"
  | "averageAssessmentStandaloneValue"
  | "averageBiometricsStandaloneValue"
> & {
    valueChange?: Maybe<
      {
        __typename?: "LearnerIndexScoreChange";
      } & LearnerIndexScoreChangePartsFragment
    >;
    assessmentStandaloneValueChange?: Maybe<
      {
        __typename?: "LearnerIndexScoreChange";
      } & LearnerIndexScoreChangePartsFragment
    >;
    biometricsStandaloneValueChange?: Maybe<
      {
        __typename?: "LearnerIndexScoreChange";
      } & LearnerIndexScoreChangePartsFragment
    >;
    dataPoints: Array<
      { __typename?: "LearnerIndexScoreDataPoint" } & Pick<
        LearnerIndexScoreDataPoint,
        | "date"
        | "label"
        | "value"
        | "assessmentValue"
        | "assessmentStandaloneValue"
        | "biometricsValue"
        | "biometricsStandaloneValue"
      >
    >;
  };

export type LearnerIndexScoreGraphPartsFragment = {
  __typename?: "LearnerIndexScoreGraph";
} & Pick<
  LearnerIndexScoreGraph,
  | "scoreTitle"
  | "scoreSubtitle"
  | "assessmentScoreTitle"
  | "assessmentScoreSubtitle"
  | "biometricsScoreTitle"
  | "biometricsScoreSubtitle"
> & {
    periods: { __typename?: "LearnerIndexScoreDataPeriods" } & {
      week: Array<
        {
          __typename?: "LearnerIndexScoreDataPeriod";
        } & LearnerIndexScoreDataPeriodPartsFragment
      >;
      month: Array<
        {
          __typename?: "LearnerIndexScoreDataPeriod";
        } & LearnerIndexScoreDataPeriodPartsFragment
      >;
      year: Array<
        {
          __typename?: "LearnerIndexScoreDataPeriod";
        } & LearnerIndexScoreDataPeriodPartsFragment
      >;
    };
  };

export type LearnerIndexBreakdownPillarPartsFragment = {
  __typename?: "LearnerIndexBreakdownPillar";
} & Pick<
  LearnerIndexBreakdownPillar,
  "pillarLabel" | "title" | "subtitle" | "descriptionHtml"
> & {
    score?: Maybe<
      { __typename?: "LearnerIndexScore" } & Pick<
        LearnerIndexScore,
        "value" | "valueFloat" | "labelHtml" | "icon"
      > & {
          change?: Maybe<
            {
              __typename?: "LearnerIndexScoreChange";
            } & LearnerIndexScoreChangePartsFragment
          >;
          graph?: Maybe<
            {
              __typename?: "LearnerIndexScoreGraph";
            } & LearnerIndexScoreGraphPartsFragment
          >;
        }
    >;
    contentLists: Array<
      { __typename: "LearnerIndexBreakdownPillarContentList" } & Pick<
        LearnerIndexBreakdownPillarContentList,
        "id" | "label"
      > & {
          items: Array<
            | ({
                __typename: "LearnerGroupSession";
              } & LearnerSessionCardParts_LearnerGroupSession_Fragment)
            | ({
                __typename: "LearnerRecording";
              } & LearnerRecordingCardPartsFragment)
            | ({
                __typename: "LearnerArticle";
              } & LearnerArticleCardPartsFragment)
          >;
        }
    >;
    plan: { __typename?: "LearnerIndexBreakdownPillarPlan" } & Pick<
      LearnerIndexBreakdownPillarPlan,
      "descriptionHtml"
    > & {
        contentLists: Array<
          | ({ __typename: "LearnerGroupSessionsList" } & Pick<
              LearnerGroupSessionsList,
              "id" | "label" | "descriptionHtml"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerGroupSession";
                  } & LearnerSessionCardParts_LearnerGroupSession_Fragment
                >;
              })
          | ({ __typename: "LearnerRecordingsList" } & Pick<
              LearnerRecordingsList,
              "id" | "label" | "descriptionHtml"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerRecording";
                  } & LearnerRecordingCardPartsFragment
                >;
              })
          | ({ __typename: "LearnerArticlesList" } & Pick<
              LearnerArticlesList,
              "id" | "label" | "descriptionHtml"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerArticle";
                  } & LearnerArticleCardPartsFragment
                >;
              })
        >;
      };
  };

export type LearnerIndexScreenPartsFragment = {
  __typename?: "LearnerIndexScreen";
} & Pick<LearnerIndexScreen, "version" | "showBetaFlag" | "descriptionHtml"> & {
    exercise?: Maybe<
      { __typename?: "LearnerExercise" } & Pick<
        LearnerExercise,
        "title" | "subTitle" | "videoUrl" | "videoThumbnailUrl" | "buttonText"
      >
    >;
    score?: Maybe<
      { __typename?: "LearnerIndexScore" } & Pick<
        LearnerIndexScore,
        "value" | "valueFloat" | "labelHtml" | "descriptionHtml" | "icon"
      > & {
          change?: Maybe<
            {
              __typename?: "LearnerIndexScoreChange";
            } & LearnerIndexScoreChangePartsFragment
          >;
          graph?: Maybe<
            {
              __typename?: "LearnerIndexScoreGraph";
            } & LearnerIndexScoreGraphPartsFragment
          >;
        }
    >;
    coach?: Maybe<
      { __typename?: "LearnerIndexCoach" } & Pick<
        LearnerIndexCoach,
        "name" | "avatarUrl" | "messageTextHtml"
      > & {
          assessmentButton?: Maybe<
            { __typename?: "AssessmentButton" } & Pick<
              AssessmentButton,
              "text" | "url"
            >
          >;
        }
    >;
    breakdown?: Maybe<
      { __typename?: "LearnerIndexBreakdown" } & {
        energy: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarPartsFragment;
        resilience: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarPartsFragment;
        activity: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarPartsFragment;
        nutrition: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarPartsFragment;
      }
    >;
    progress?: Maybe<
      { __typename?: "LearnerIndexProgress" } & Pick<
        LearnerIndexProgress,
        "title" | "labels" | "minValue" | "maxValue"
      > & {
          energyData: { __typename?: "LearnerIndexProgressData" } & Pick<
            LearnerIndexProgressData,
            "label" | "values"
          >;
          resilienceData: { __typename?: "LearnerIndexProgressData" } & Pick<
            LearnerIndexProgressData,
            "label" | "values"
          >;
          activityData: { __typename?: "LearnerIndexProgressData" } & Pick<
            LearnerIndexProgressData,
            "label" | "values"
          >;
        }
    >;
    biometrics?: Maybe<
      { __typename?: "LearnerIndexBiometrics" } & {
        sessionsHistory: {
          __typename?: "LearnerIndexBiometricsSessionsHistory";
        } & Pick<
          LearnerIndexBiometricsSessionsHistory,
          | "state"
          | "callToActionTitle"
          | "callToActionContentHtml"
          | "callToActionButtonText"
        > & {
            contentList: { __typename: "LearnerGroupSessionsList" } & Pick<
              LearnerGroupSessionsList,
              "id" | "label" | "descriptionHtml"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerGroupSession";
                  } & LearnerSessionCardBiometricsParts_LearnerGroupSession_Fragment
                >;
              };
          };
      }
    >;
    assessment?: Maybe<
      {
        __typename?: "LearnerIndexAssessment";
      } & LearnerIndexAssessmentPartsFragment
    >;
  };

export type LearnerScreenIndexQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerScreenIndexQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: {
        __typename?: "LearnerIndexScreen";
      } & LearnerIndexScreenPartsFragment;
    };
  };
};

export type LearnerScreenIndexV1QueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerScreenIndexV1Query = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: {
        __typename?: "LearnerIndexScreen";
      } & LearnerIndexScreenV1PartsFragment;
    };
  };
};

export type LearnerIndexScreenV1PartsFragment = {
  __typename?: "LearnerIndexScreen";
} & Pick<LearnerIndexScreen, "version" | "showBetaFlag" | "descriptionHtml"> & {
    exercise?: Maybe<
      { __typename?: "LearnerExercise" } & Pick<
        LearnerExercise,
        "title" | "subTitle" | "videoUrl" | "videoThumbnailUrl" | "buttonText"
      >
    >;
    score?: Maybe<
      { __typename?: "LearnerIndexScore" } & Pick<
        LearnerIndexScore,
        "value" | "valueFloat" | "labelHtml" | "descriptionHtml" | "icon"
      >
    >;
    coach?: Maybe<
      { __typename?: "LearnerIndexCoach" } & Pick<
        LearnerIndexCoach,
        "name" | "avatarUrl" | "messageTextHtml"
      > & {
          assessmentButton?: Maybe<
            { __typename?: "AssessmentButton" } & Pick<
              AssessmentButton,
              "text" | "url"
            >
          >;
        }
    >;
    breakdown?: Maybe<
      { __typename?: "LearnerIndexBreakdown" } & {
        energy: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarV1PartsFragment;
        resilience: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarV1PartsFragment;
        activity: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarV1PartsFragment;
        nutrition: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarV1PartsFragment;
      }
    >;
    progress?: Maybe<
      { __typename?: "LearnerIndexProgress" } & Pick<
        LearnerIndexProgress,
        "title" | "labels" | "minValue" | "maxValue"
      > & {
          energyData: { __typename?: "LearnerIndexProgressData" } & Pick<
            LearnerIndexProgressData,
            "label" | "values"
          >;
          resilienceData: { __typename?: "LearnerIndexProgressData" } & Pick<
            LearnerIndexProgressData,
            "label" | "values"
          >;
          activityData: { __typename?: "LearnerIndexProgressData" } & Pick<
            LearnerIndexProgressData,
            "label" | "values"
          >;
        }
    >;
    biometrics?: Maybe<
      { __typename?: "LearnerIndexBiometrics" } & {
        sessionsHistory: {
          __typename?: "LearnerIndexBiometricsSessionsHistory";
        } & Pick<
          LearnerIndexBiometricsSessionsHistory,
          | "state"
          | "callToActionTitle"
          | "callToActionContentHtml"
          | "callToActionButtonText"
        > & {
            contentList: { __typename: "LearnerGroupSessionsList" } & Pick<
              LearnerGroupSessionsList,
              "id" | "label" | "descriptionHtml"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerGroupSession";
                  } & LearnerSessionCardBiometricsParts_LearnerGroupSession_Fragment
                >;
              };
          };
      }
    >;
    assessment?: Maybe<
      {
        __typename?: "LearnerIndexAssessment";
      } & LearnerIndexAssessmentPartsFragment
    >;
  };

export type LearnerIndexBreakdownPillarV1PartsFragment = {
  __typename?: "LearnerIndexBreakdownPillar";
} & Pick<
  LearnerIndexBreakdownPillar,
  "pillarLabel" | "title" | "subtitle" | "descriptionHtml"
> & {
    score?: Maybe<
      { __typename?: "LearnerIndexScore" } & Pick<
        LearnerIndexScore,
        "value" | "valueFloat" | "labelHtml" | "icon"
      >
    >;
    contentLists: Array<
      { __typename: "LearnerIndexBreakdownPillarContentList" } & Pick<
        LearnerIndexBreakdownPillarContentList,
        "id" | "label"
      > & {
          items: Array<
            | ({
                __typename: "LearnerGroupSession";
              } & LearnerSessionCardParts_LearnerGroupSession_Fragment)
            | ({
                __typename: "LearnerRecording";
              } & LearnerRecordingCardPartsFragment)
            | ({
                __typename: "LearnerArticle";
              } & LearnerArticleCardPartsFragment)
          >;
        }
    >;
  };

type LearnerIndexCtaAction_LearnerIndexCtaActionConnectBiometrics_Fragment = {
  __typename: "LearnerIndexCTAActionConnectBiometrics";
} & Pick<LearnerIndexCtaActionConnectBiometrics, "buttonText">;

type LearnerIndexCtaAction_LearnerIndexCtaActionTakeAssessment_Fragment = {
  __typename: "LearnerIndexCTAActionTakeAssessment";
} & Pick<LearnerIndexCtaActionTakeAssessment, "buttonText" | "assessmentUrl">;

export type LearnerIndexCtaActionFragment =
  | LearnerIndexCtaAction_LearnerIndexCtaActionConnectBiometrics_Fragment
  | LearnerIndexCtaAction_LearnerIndexCtaActionTakeAssessment_Fragment;

export type LearnerIndexCtaPartsFragment = {
  __typename?: "LearnerIndexCTAs";
} & {
  actions?: Maybe<
    { __typename?: "LearnerIndexCTAActions" } & {
      takeAssessment?: Maybe<
        {
          __typename?: "LearnerIndexCTAActionTakeAssessment";
        } & LearnerIndexCtaAction_LearnerIndexCtaActionTakeAssessment_Fragment
      >;
      connectBiometrics?: Maybe<
        {
          __typename?: "LearnerIndexCTAActionConnectBiometrics";
        } & LearnerIndexCtaAction_LearnerIndexCtaActionConnectBiometrics_Fragment
      >;
    }
  >;
  prompts: Array<
    { __typename?: "LearnerIndexCTAPrompt" } & Pick<
      LearnerIndexCtaPrompt,
      "id" | "imageUrl" | "descriptionHtml" | "variant"
    > & {
        action:
          | ({
              __typename?: "LearnerIndexCTAActionConnectBiometrics";
            } & LearnerIndexCtaAction_LearnerIndexCtaActionConnectBiometrics_Fragment)
          | ({
              __typename?: "LearnerIndexCTAActionTakeAssessment";
            } & LearnerIndexCtaAction_LearnerIndexCtaActionTakeAssessment_Fragment);
      }
  >;
};

export type LearnerScreenIndexV2QueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerScreenIndexV2Query = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: {
        __typename?: "LearnerIndexScreen";
      } & LearnerIndexScreenV2PartsFragment;
    };
  };
};

export type LearnerIndexScreenV2PartsFragment = {
  __typename?: "LearnerIndexScreen";
} & Pick<LearnerIndexScreen, "version" | "showBetaFlag" | "descriptionHtml"> & {
    exercise?: Maybe<
      { __typename?: "LearnerExercise" } & Pick<
        LearnerExercise,
        "title" | "subTitle" | "videoUrl" | "videoThumbnailUrl" | "buttonText"
      >
    >;
    score?: Maybe<
      { __typename?: "LearnerIndexScore" } & Pick<
        LearnerIndexScore,
        "value" | "valueFloat" | "labelHtml" | "descriptionHtml" | "icon"
      > & {
          change?: Maybe<
            {
              __typename?: "LearnerIndexScoreChange";
            } & LearnerIndexScoreChangePartsFragment
          >;
          graph?: Maybe<
            {
              __typename?: "LearnerIndexScoreGraph";
            } & LearnerIndexScoreGraphPartsFragment
          >;
        }
    >;
    coach?: Maybe<
      { __typename?: "LearnerIndexCoach" } & Pick<
        LearnerIndexCoach,
        "name" | "avatarUrl" | "messageTextHtml"
      > & {
          assessmentButton?: Maybe<
            { __typename?: "AssessmentButton" } & Pick<
              AssessmentButton,
              "text" | "url"
            >
          >;
        }
    >;
    breakdown?: Maybe<
      { __typename?: "LearnerIndexBreakdown" } & {
        energy: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarV2PartsFragment;
        resilience: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarV2PartsFragment;
        activity: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarV2PartsFragment;
        nutrition: {
          __typename?: "LearnerIndexBreakdownPillar";
        } & LearnerIndexBreakdownPillarV2PartsFragment;
      }
    >;
    biometrics?: Maybe<
      { __typename?: "LearnerIndexBiometrics" } & {
        sessionsHistory: {
          __typename?: "LearnerIndexBiometricsSessionsHistory";
        } & Pick<
          LearnerIndexBiometricsSessionsHistory,
          | "state"
          | "callToActionTitle"
          | "callToActionContentHtml"
          | "callToActionButtonText"
        > & {
            contentList: { __typename: "LearnerGroupSessionsList" } & Pick<
              LearnerGroupSessionsList,
              "id" | "label" | "descriptionHtml"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerGroupSession";
                  } & LearnerSessionCardBiometricsParts_LearnerGroupSession_Fragment
                >;
              };
          };
      }
    >;
    CTAs?: Maybe<
      { __typename?: "LearnerIndexCTAs" } & LearnerIndexCtaPartsFragment
    >;
    assessment?: Maybe<
      {
        __typename?: "LearnerIndexAssessment";
      } & LearnerIndexAssessmentPartsFragment
    >;
  };

export type LearnerIndexBreakdownPillarV2PartsFragment = {
  __typename?: "LearnerIndexBreakdownPillar";
} & Pick<
  LearnerIndexBreakdownPillar,
  "pillarLabel" | "title" | "subtitle" | "descriptionHtml"
> & {
    score?: Maybe<
      { __typename?: "LearnerIndexScore" } & Pick<
        LearnerIndexScore,
        "value" | "valueFloat" | "labelHtml" | "icon"
      > & {
          change?: Maybe<
            {
              __typename?: "LearnerIndexScoreChange";
            } & LearnerIndexScoreChangePartsFragment
          >;
          graph?: Maybe<
            {
              __typename?: "LearnerIndexScoreGraph";
            } & LearnerIndexScoreGraphPartsFragment
          >;
        }
    >;
    plan: { __typename?: "LearnerIndexBreakdownPillarPlan" } & Pick<
      LearnerIndexBreakdownPillarPlan,
      "descriptionHtml"
    > & {
        contentLists: Array<
          | ({ __typename: "LearnerGroupSessionsList" } & Pick<
              LearnerGroupSessionsList,
              "id" | "label" | "descriptionHtml"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerGroupSession";
                  } & LearnerSessionCardParts_LearnerGroupSession_Fragment
                >;
              })
          | ({ __typename: "LearnerRecordingsList" } & Pick<
              LearnerRecordingsList,
              "id" | "label" | "descriptionHtml"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerRecording";
                  } & LearnerRecordingCardPartsFragment
                >;
              })
          | ({ __typename: "LearnerArticlesList" } & Pick<
              LearnerArticlesList,
              "id" | "label" | "descriptionHtml"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerArticle";
                  } & LearnerArticleCardPartsFragment
                >;
              })
        >;
      };
  };

export type LearnerScreenContentQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerScreenContentQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      content?: Maybe<
        { __typename?: "LearnerContentScreen" } & {
          contentLists: Array<
            Maybe<
              | { __typename: "LearnerFeaturedSessionList" }
              | { __typename: "LearnerSessionsList" }
              | { __typename: "LearnerGroupSessionsList" }
              | { __typename: "LearnerPrivateSessionsList" }
              | ({ __typename: "LearnerRecordingsList" } & Pick<
                  LearnerRecordingsList,
                  "id" | "label"
                > & {
                    items: Array<
                      {
                        __typename: "LearnerRecording";
                      } & LearnerRecordingCardPartsFragment
                    >;
                  })
              | ({ __typename: "LearnerFeaturedRecordingList" } & Pick<
                  LearnerFeaturedRecordingList,
                  "id" | "label"
                > & {
                    items: Array<
                      {
                        __typename: "LearnerRecording";
                      } & LearnerRecordingCardPartsFragment
                    >;
                  })
              | { __typename: "LearnerFeaturedArticleList" }
              | ({ __typename: "LearnerArticlesList" } & Pick<
                  LearnerArticlesList,
                  "id" | "label"
                > & {
                    items: Array<
                      {
                        __typename: "LearnerArticle";
                      } & LearnerArticleCardPartsFragment
                    >;
                  })
              | { __typename: "LearnerPractitionersList" }
            >
          >;
        }
      >;
    };
  };
};

export type LearnerScreenProfileQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerScreenProfileQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & Pick<
    Learner,
    "firstName" | "lastName" | "fullName" | "photoUrl"
  > & {
      biometrics?: Maybe<
        { __typename?: "LearnerBiometrics" } & Pick<
          LearnerBiometrics,
          "hasHealthData"
        >
      >;
      screens: { __typename?: "LearnerScreens" } & {
        profile: { __typename?: "LearnerProfileScreen" } & {
          journey: { __typename?: "LearnerJourney" } & Pick<
            LearnerJourney,
            "title" | "memberSince"
          > & {
              timeInvested?: Maybe<
                { __typename?: "LearnerJourneyTimeInvested" } & Pick<
                  LearnerJourneyTimeInvested,
                  "value" | "label" | "metric"
                >
              >;
              sessionsAttended?: Maybe<
                { __typename?: "LearnerJourneySessionsAttended" } & Pick<
                  LearnerJourneySessionsAttended,
                  "value" | "label"
                >
              >;
            };
          favourites?: Maybe<
            { __typename?: "LearnerFavourites" } & Pick<
              LearnerFavourites,
              "title"
            > & {
                recordings: {
                  __typename?: "LearnerFavouritesRecordings";
                } & Pick<LearnerFavouritesRecordings, "count" | "label"> & {
                    contentList: { __typename: "LearnerRecordingsList" } & Pick<
                      LearnerRecordingsList,
                      "id"
                    >;
                  };
                articles: { __typename?: "LearnerFavouritesArticles" } & Pick<
                  LearnerFavouritesArticles,
                  "count" | "label"
                > & {
                    contentList: { __typename: "LearnerArticlesList" } & Pick<
                      LearnerArticlesList,
                      "id"
                    >;
                  };
              }
          >;
          settings?: Maybe<
            { __typename?: "LearnerSettings" } & Pick<
              LearnerSettings,
              "title" | "canChangePassword"
            > & {
                profile: {
                  __typename?: "LearnerProfileSettings";
                } & LearnerProfileSettingsPartsFragment;
                notifications: {
                  __typename?: "LearnerNotificationsSettings";
                } & Pick<LearnerNotificationsSettings, "title"> & {
                    toggles: Array<
                      {
                        __typename?: "BooleanInput";
                      } & BooleanInputPartsFragment
                    >;
                  };
                calendar?: Maybe<
                  { __typename?: "LearnerCalendarSettings" } & Pick<
                    LearnerCalendarSettings,
                    "title"
                  > & {
                      toggles: Array<
                        {
                          __typename?: "BooleanInput";
                        } & BooleanInputPartsFragment
                      >;
                    }
                >;
                ourMission: { __typename?: "LearnerOurMission" } & Pick<
                  LearnerOurMission,
                  "title" | "heading" | "imageUrl" | "contentHtml"
                >;
                membership: { __typename?: "LearnerMembership" } & Pick<
                  LearnerMembership,
                  "title" | "type"
                > & {
                    advantages: {
                      __typename?: "LearnerMembershipAdvantages";
                    } & Pick<LearnerMembershipAdvantages, "heading"> & {
                        items: Array<
                          { __typename?: "LearnerMembershipAdvantage" } & Pick<
                            LearnerMembershipAdvantage,
                            "name" | "description"
                          >
                        >;
                      };
                  };
                biometrics?: Maybe<
                  { __typename?: "LearnerBiometricsSettings" } & {
                    providers: {
                      __typename?: "LearnerBiometricsProviders";
                    } & Pick<LearnerBiometricsProviders, "title"> & {
                        providers: Array<
                          { __typename?: "LearnerBiometricsProvider" } & Pick<
                            LearnerBiometricsProvider,
                            "id" | "name"
                          >
                        >;
                      };
                    howItWorks: {
                      __typename?: "LearnerBiometricsHowItWorks";
                    } & Pick<
                      LearnerBiometricsHowItWorks,
                      "title" | "headingTitle" | "headingContentHtml"
                    > & {
                        callToAction?: Maybe<
                          {
                            __typename?: "LearnerBiometricsHowItWorksCallToAction";
                          } & Pick<
                            LearnerBiometricsHowItWorksCallToAction,
                            "title" | "buttonText"
                          >
                        >;
                        sections: Array<
                          {
                            __typename?: "LearnerBiometricsHowItWorksSection";
                          } & Pick<
                            LearnerBiometricsHowItWorksSection,
                            "title"
                          > & {
                              items: Array<
                                {
                                  __typename?: "LearnerBiometricsHowItWorksSectionItem";
                                } & Pick<
                                  LearnerBiometricsHowItWorksSectionItem,
                                  "title" | "contentHtml"
                                >
                              >;
                            }
                        >;
                      };
                  }
                >;
              }
          >;
          contentLists: Array<
            { __typename: "LearnerGroupSessionsList" } & Pick<
              LearnerGroupSessionsList,
              "id" | "label"
            > & {
                items: Array<
                  {
                    __typename?: "LearnerGroupSession";
                  } & LearnerSessionCardParts_LearnerGroupSession_Fragment
                >;
              }
          >;
        };
      };
    };
};

type InputParts_SelectInput_Fragment = {
  __typename?: "SelectInput";
} & SelectInputPartsFragment;

type InputParts_MultiSelectInput_Fragment = {
  __typename?: "MultiSelectInput";
} & MultiSelectInputPartsFragment;

type InputParts_TextInput_Fragment = {
  __typename?: "TextInput";
} & TextInputPartsFragment;

type InputParts_DateInput_Fragment = {
  __typename?: "DateInput";
} & DateInputPartsFragment;

type InputParts_BooleanInput_Fragment = {
  __typename?: "BooleanInput";
} & BooleanInputPartsFragment;

type InputParts_RangeInput_Fragment = {
  __typename?: "RangeInput";
} & RangeInputPartsFragment;

type InputParts_ImageInput_Fragment = {
  __typename?: "ImageInput";
} & ImageInputPartsFragment;

export type InputPartsFragment =
  | InputParts_SelectInput_Fragment
  | InputParts_MultiSelectInput_Fragment
  | InputParts_TextInput_Fragment
  | InputParts_DateInput_Fragment
  | InputParts_BooleanInput_Fragment
  | InputParts_RangeInput_Fragment
  | InputParts_ImageInput_Fragment;

export type SelectInputPartsFragment = { __typename?: "SelectInput" } & Pick<
  SelectInput,
  "id" | "label" | "required"
> & {
    options: Array<
      { __typename?: "SelectInputOption" } & Pick<
        SelectInputOption,
        "label" | "value" | "imageUrl" | "selected"
      >
    >;
  };

export type MultiSelectInputPartsFragment = {
  __typename?: "MultiSelectInput";
} & Pick<MultiSelectInput, "id" | "label" | "required"> & {
    options: Array<
      { __typename?: "SelectInputOption" } & Pick<
        SelectInputOption,
        "label" | "value" | "imageUrl" | "selected"
      >
    >;
  };

export type BooleanInputPartsFragment = { __typename?: "BooleanInput" } & Pick<
  BooleanInput,
  "id" | "label" | "required" | "reverseLogic" | "checked"
>;

export type DateInputPartsFragment = { __typename?: "DateInput" } & Pick<
  DateInput,
  "id" | "label" | "required" | "minDate" | "maxDate" | "value"
>;

export type ImageInputPartsFragment = { __typename?: "ImageInput" } & Pick<
  ImageInput,
  "id" | "label" | "required" | "value"
>;

export type TextInputPartsFragment = { __typename?: "TextInput" } & Pick<
  TextInput,
  | "id"
  | "label"
  | "required"
  | "minLength"
  | "maxLength"
  | "placeholder"
  | "value"
>;

export type RangeInputPartsFragment = { __typename?: "RangeInput" } & Pick<
  RangeInput,
  | "id"
  | "label"
  | "required"
  | "min"
  | "minLabel"
  | "max"
  | "maxLabel"
  | "step"
  | "value"
>;

export type LearnerJoinGroupSessionMutationVariables = Exact<{
  appInfo: AppInfo;
  id: Scalars["ID"];
}>;

export type LearnerJoinGroupSessionMutation = { __typename?: "Mutation" } & {
  learnerJoinGroupSession?: Maybe<
    { __typename?: "LearnerJoinGroupSession" } & Pick<
      LearnerJoinGroupSession,
      "ok" | "zoomMtgNumber" | "zoomMtgPassWord" | "zoomMtgSignature"
    > & {
        learnerBeforeJoiningGroupSessionFeedbackForm: {
          __typename?: "LearnerBeforeJoiningGroupSessionFeedbackForm";
        } & {
          biometricsBubble?: Maybe<
            { __typename?: "LearnerBiometricsSessionFeedbackBubble" } & Pick<
              LearnerBiometricsSessionFeedbackBubble,
              "title" | "contentHtml"
            >
          >;
        };
        learnerBeforeGroupSessionFeedbackForm?: Maybe<
          { __typename?: "LearnerBeforeGroupSessionFeedbackForm" } & {
            biometricsBubble?: Maybe<
              { __typename?: "LearnerBiometricsSessionFeedbackBubble" } & Pick<
                LearnerBiometricsSessionFeedbackBubble,
                "title" | "contentHtml"
              >
            >;
            messages: Array<
              Maybe<
                { __typename?: "FeedbackMessage" } & Pick<
                  FeedbackMessage,
                  | "title"
                  | "senderAvatarUrl"
                  | "senderName"
                  | "textHtml"
                  | "buttonText"
                  | "skipButtonText"
                > & {
                    input?: Maybe<
                      | ({
                          __typename: "SelectInput";
                        } & SelectInputPartsFragment)
                      | { __typename: "MultiSelectInput" }
                      | ({ __typename: "TextInput" } & TextInputPartsFragment)
                      | { __typename: "DateInput" }
                      | { __typename: "BooleanInput" }
                      | ({ __typename: "RangeInput" } & RangeInputPartsFragment)
                      | { __typename: "ImageInput" }
                    >;
                  }
              >
            >;
          }
        >;
      }
  >;
};

export type LearnerSubmitBeforeGroupSessionFeedbackMutationVariables = Exact<{
  appInfo: AppInfo;
  groupSessionId: Scalars["ID"];
  type: Scalars["String"];
  input:
    | Array<Maybe<LearnerGroupSessionFeedbackInput>>
    | Maybe<LearnerGroupSessionFeedbackInput>;
}>;

export type LearnerSubmitBeforeGroupSessionFeedbackMutation = {
  __typename?: "Mutation";
} & {
  learnerSubmitBeforeGroupSessionFeedback?: Maybe<
    { __typename?: "LearnerSubmitBeforeGroupSessionFeedback" } & Pick<
      LearnerSubmitBeforeGroupSessionFeedback,
      "ok"
    >
  >;
};

export type LearnerRegisterForGroupSessionMutationVariables = Exact<{
  id: Scalars["ID"];
  appInfo: AppInfo;
}>;

export type LearnerRegisterForGroupSessionMutation = {
  __typename?: "Mutation";
} & {
  learnerRegisterForGroupSession?: Maybe<
    { __typename?: "LearnerRegisterForGroupSession" } & Pick<
      LearnerRegisterForGroupSession,
      "ok"
    > & {
        learnerGroupSession: {
          __typename?: "LearnerGroupSession";
        } & LearnerGroupSessionPartsFragment;
      }
  >;
};

export type LearnerUnRegisterForGroupSessionMutationVariables = Exact<{
  id: Scalars["ID"];
  appInfo: AppInfo;
}>;

export type LearnerUnRegisterForGroupSessionMutation = {
  __typename?: "Mutation";
} & {
  learnerUnRegisterForGroupSession?: Maybe<
    { __typename?: "LearnerUnRegisterForGroupSession" } & Pick<
      LearnerUnRegisterForGroupSession,
      "ok"
    > & {
        learnerGroupSession: {
          __typename?: "LearnerGroupSession";
        } & LearnerGroupSessionPartsFragment;
      }
  >;
};

export type LearnerTrackBiometricsMutationVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerTrackBiometricsMutation = { __typename?: "Mutation" } & {
  learnerTrackBiometrics?: Maybe<
    { __typename?: "LearnerTrackBiometrics" } & Pick<
      LearnerTrackBiometrics,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & {
          biometrics?: Maybe<
            { __typename?: "LearnerBiometrics" } & {
              modal?: Maybe<
                { __typename?: "LearnerBiometricsModal" } & Pick<
                  LearnerBiometricsModal,
                  | "title"
                  | "contentHtml"
                  | "remindMeLaterButtonText"
                  | "dontAskAgainButtonText"
                >
              >;
            }
          >;
        };
      }
  >;
};

export type LearnerAfterGroupSessionFeedbackFormQueryVariables = Exact<{
  groupSessionId: Scalars["ID"];
  appInfo: AppInfo;
}>;

export type LearnerAfterGroupSessionFeedbackFormQuery = {
  __typename?: "Query";
} & {
  learnerAfterGroupSessionFeedbackForm: {
    __typename?: "LearnerAfterGroupSessionFeedbackForm";
  } & {
    biometricsBubble?: Maybe<
      { __typename?: "LearnerBiometricsSessionFeedbackBubble" } & Pick<
        LearnerBiometricsSessionFeedbackBubble,
        "title" | "contentHtml"
      >
    >;
    messages: Array<
      Maybe<
        { __typename?: "FeedbackMessage" } & Pick<
          FeedbackMessage,
          | "title"
          | "senderAvatarUrl"
          | "senderName"
          | "textHtml"
          | "buttonText"
          | "skipButtonText"
        > & {
            input?: Maybe<
              | ({ __typename: "SelectInput" } & SelectInputPartsFragment)
              | { __typename: "MultiSelectInput" }
              | ({ __typename: "TextInput" } & TextInputPartsFragment)
              | { __typename: "DateInput" }
              | { __typename: "BooleanInput" }
              | ({ __typename: "RangeInput" } & RangeInputPartsFragment)
              | { __typename: "ImageInput" }
            >;
          }
      >
    >;
    sessionsAttendedThisMonth: {
      __typename: "LearnerSessionsAttendedThisMonth";
    } & Pick<LearnerSessionsAttendedThisMonth, "value" | "label">;
  };
};

export type LearnerBeforeGroupSessionFeedbackFormQueryVariables = Exact<{
  groupSessionId: Scalars["ID"];
  appInfo: AppInfo;
}>;

export type LearnerBeforeGroupSessionFeedbackFormQuery = {
  __typename?: "Query";
} & {
  learnerBeforeGroupSessionFeedbackForm: {
    __typename?: "LearnerBeforeGroupSessionFeedbackForm";
  } & {
    biometricsBubble?: Maybe<
      { __typename?: "LearnerBiometricsSessionFeedbackBubble" } & Pick<
        LearnerBiometricsSessionFeedbackBubble,
        "title" | "contentHtml"
      >
    >;
    messages: Array<
      Maybe<
        { __typename?: "FeedbackMessage" } & Pick<
          FeedbackMessage,
          | "title"
          | "senderAvatarUrl"
          | "senderName"
          | "textHtml"
          | "buttonText"
          | "skipButtonText"
        > & {
            input?: Maybe<
              | ({ __typename: "SelectInput" } & SelectInputPartsFragment)
              | { __typename: "MultiSelectInput" }
              | ({ __typename: "TextInput" } & TextInputPartsFragment)
              | { __typename: "DateInput" }
              | { __typename: "BooleanInput" }
              | ({ __typename: "RangeInput" } & RangeInputPartsFragment)
              | { __typename: "ImageInput" }
            >;
          }
      >
    >;
  };
};

export type LearnerSubmitAfterGroupSessionFeedbackMutationVariables = Exact<{
  appInfo: AppInfo;
  groupSessionId: Scalars["ID"];
  type: Scalars["String"];
  input:
    | Array<Maybe<LearnerGroupSessionFeedbackInput>>
    | Maybe<LearnerGroupSessionFeedbackInput>;
}>;

export type LearnerSubmitAfterGroupSessionFeedbackMutation = {
  __typename?: "Mutation";
} & {
  learnerSubmitAfterGroupSessionFeedback?: Maybe<
    { __typename?: "LearnerSubmitAfterGroupSessionFeedback" } & Pick<
      LearnerSubmitAfterGroupSessionFeedback,
      "ok"
    >
  >;
};

export type LearnerArticleFeedbackMutationVariables = Exact<{
  appInfo: AppInfo;
  input: LearnerArticleFeedbackInput;
}>;

export type LearnerArticleFeedbackMutation = { __typename?: "Mutation" } & {
  learnerArticleFeedback?: Maybe<
    { __typename?: "LearnerArticleFeedback" } & Pick<
      LearnerArticleFeedback,
      "ok"
    >
  >;
};

export type LearnerOnboardingMutationVariables = Exact<{
  appInfo: AppInfo;
  input: LearnerOnboardingInput;
}>;

export type LearnerOnboardingMutation = { __typename?: "Mutation" } & {
  learnerOnboarding?: Maybe<
    { __typename?: "LearnerOnboarding" } & Pick<LearnerOnboarding, "ok"> & {
        learner: { __typename?: "Learner" } & LearnerPartsFragment;
        welcomeScreen: { __typename?: "WelcomeScreen" } & Pick<
          WelcomeScreen,
          "titleHtml" | "subtitleHtml" | "buttonText"
        >;
      }
  >;
};

export type LearnerSessionQueryVariables = Exact<{
  id: Scalars["ID"];
  appInfo: AppInfo;
}>;

export type LearnerSessionQuery = { __typename?: "Query" } & {
  learnerSession:
    | ({ __typename: "LearnerGroupSession" } & LearnerGroupSessionPartsFragment)
    | { __typename: "LearnerPrivateSession" };
};

export type LearnerRecordingQueryVariables = Exact<{
  id: Scalars["ID"];
  appInfo: AppInfo;
}>;

export type LearnerRecordingQuery = { __typename?: "Query" } & {
  learnerRecording: {
    __typename: "LearnerRecording";
  } & LearnerRecordingPartsFragment;
};

export type LearnerArticleQueryVariables = Exact<{
  id: Scalars["ID"];
  appInfo: AppInfo;
}>;

export type LearnerArticleQuery = { __typename?: "Query" } & {
  learnerArticle: {
    __typename: "LearnerArticle";
  } & LearnerArticlePartsFragment;
};

export type LearnerPractitionerQueryVariables = Exact<{
  id: Scalars["ID"];
  appInfo: AppInfo;
}>;

export type LearnerPractitionerQuery = { __typename?: "Query" } & {
  learnerPractitioner: {
    __typename: "LearnerPractitioner";
  } & LearnerPractitionerPartsFragment;
};

export type LearnerContentListQueryVariables = Exact<{
  id: Scalars["ID"];
  searchQuery: Scalars["String"];
  filters: LearnerContentListFilters;
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerContentListQuery = { __typename?: "Query" } & {
  learnerContentList:
    | ({ __typename: "LearnerFeaturedSessionList" } & {
        items: Array<
          | ({
              __typename: "LearnerGroupSession";
            } & LearnerSessionCardParts_LearnerGroupSession_Fragment)
          | ({
              __typename: "LearnerPrivateSession";
            } & LearnerSessionCardParts_LearnerPrivateSession_Fragment)
        >;
      } & LearnerContentListParts_LearnerFeaturedSessionList_Fragment)
    | ({ __typename: "LearnerSessionsList" } & {
        items: Array<
          | ({
              __typename: "LearnerGroupSession";
            } & LearnerSessionCardParts_LearnerGroupSession_Fragment)
          | ({
              __typename: "LearnerPrivateSession";
            } & LearnerSessionCardParts_LearnerPrivateSession_Fragment)
        >;
      } & LearnerContentListParts_LearnerSessionsList_Fragment)
    | ({ __typename: "LearnerGroupSessionsList" } & {
        items: Array<
          {
            __typename: "LearnerGroupSession";
          } & LearnerSessionCardParts_LearnerGroupSession_Fragment
        >;
      } & LearnerContentListParts_LearnerGroupSessionsList_Fragment)
    | ({
        __typename: "LearnerPrivateSessionsList";
      } & LearnerContentListParts_LearnerPrivateSessionsList_Fragment)
    | ({ __typename: "LearnerRecordingsList" } & {
        items: Array<
          { __typename: "LearnerRecording" } & LearnerRecordingCardPartsFragment
        >;
      } & LearnerContentListParts_LearnerRecordingsList_Fragment)
    | ({ __typename: "LearnerFeaturedRecordingList" } & {
        items: Array<
          { __typename: "LearnerRecording" } & LearnerRecordingCardPartsFragment
        >;
      } & LearnerContentListParts_LearnerFeaturedRecordingList_Fragment)
    | ({ __typename: "LearnerFeaturedArticleList" } & {
        items: Array<
          { __typename: "LearnerArticle" } & LearnerArticleCardPartsFragment
        >;
      } & LearnerContentListParts_LearnerFeaturedArticleList_Fragment)
    | ({ __typename: "LearnerArticlesList" } & {
        items: Array<
          { __typename: "LearnerArticle" } & LearnerArticleCardPartsFragment
        >;
      } & LearnerContentListParts_LearnerArticlesList_Fragment)
    | ({ __typename: "LearnerPractitionersList" } & {
        items: Array<
          {
            __typename: "LearnerPractitioner";
          } & LearnerPractitionerCardPartsFragment
        >;
      } & LearnerContentListParts_LearnerPractitionersList_Fragment);
};

type LearnerContentListParts_LearnerArticlesList_Fragment = {
  __typename?: "LearnerArticlesList";
} & Pick<
  LearnerArticlesList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerFeaturedArticleList_Fragment = {
  __typename?: "LearnerFeaturedArticleList";
} & Pick<
  LearnerFeaturedArticleList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerFeaturedRecordingList_Fragment = {
  __typename?: "LearnerFeaturedRecordingList";
} & Pick<
  LearnerFeaturedRecordingList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerFeaturedSessionList_Fragment = {
  __typename?: "LearnerFeaturedSessionList";
} & Pick<
  LearnerFeaturedSessionList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerGroupSessionsList_Fragment = {
  __typename?: "LearnerGroupSessionsList";
} & Pick<
  LearnerGroupSessionsList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerIndexBreakdownPillarContentList_Fragment = {
  __typename?: "LearnerIndexBreakdownPillarContentList";
} & Pick<
  LearnerIndexBreakdownPillarContentList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerMixedContentList_Fragment = {
  __typename?: "LearnerMixedContentList";
} & Pick<
  LearnerMixedContentList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerPractitionersList_Fragment = {
  __typename?: "LearnerPractitionersList";
} & Pick<
  LearnerPractitionersList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerPrivateSessionsList_Fragment = {
  __typename?: "LearnerPrivateSessionsList";
} & Pick<
  LearnerPrivateSessionsList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerRecordingsList_Fragment = {
  __typename?: "LearnerRecordingsList";
} & Pick<
  LearnerRecordingsList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

type LearnerContentListParts_LearnerSessionsList_Fragment = {
  __typename?: "LearnerSessionsList";
} & Pick<
  LearnerSessionsList,
  "id" | "label" | "filterTags" | "services" | "durations"
> & {
    filters: Array<
      Maybe<
        { __typename: "MultiSelectInput" } & Pick<
          MultiSelectInput,
          "id" | "label"
        > & {
            options: Array<
              { __typename?: "SelectInputOption" } & Pick<
                SelectInputOption,
                "value" | "label" | "imageUrl" | "selected"
              >
            >;
          }
      >
    >;
  };

export type LearnerContentListPartsFragment =
  | LearnerContentListParts_LearnerArticlesList_Fragment
  | LearnerContentListParts_LearnerFeaturedArticleList_Fragment
  | LearnerContentListParts_LearnerFeaturedRecordingList_Fragment
  | LearnerContentListParts_LearnerFeaturedSessionList_Fragment
  | LearnerContentListParts_LearnerGroupSessionsList_Fragment
  | LearnerContentListParts_LearnerIndexBreakdownPillarContentList_Fragment
  | LearnerContentListParts_LearnerMixedContentList_Fragment
  | LearnerContentListParts_LearnerPractitionersList_Fragment
  | LearnerContentListParts_LearnerPrivateSessionsList_Fragment
  | LearnerContentListParts_LearnerRecordingsList_Fragment
  | LearnerContentListParts_LearnerSessionsList_Fragment;

export type LearnerFavouriteMutationVariables = Exact<{
  id: Scalars["ID"];
  typename: Scalars["String"];
  appInfo: AppInfo;
}>;

export type LearnerFavouriteMutation = { __typename?: "Mutation" } & {
  learnerFavourite?: Maybe<
    { __typename?: "LearnerFavourite" } & Pick<LearnerFavourite, "ok"> & {
        item:
          | ({ __typename: "LearnerRecording" } & LearnerRecordingPartsFragment)
          | ({ __typename: "LearnerArticle" } & LearnerArticlePartsFragment)
          | ({
              __typename: "LearnerPractitioner";
            } & LearnerPractitionerPartsFragment);
      }
  >;
};

export type LearnerUnFavouriteMutationVariables = Exact<{
  id: Scalars["ID"];
  typename: Scalars["String"];
  appInfo: AppInfo;
}>;

export type LearnerUnFavouriteMutation = { __typename?: "Mutation" } & {
  learnerUnFavourite?: Maybe<
    { __typename?: "LearnerUnFavourite" } & Pick<LearnerUnFavourite, "ok"> & {
        item:
          | ({ __typename: "LearnerRecording" } & LearnerRecordingPartsFragment)
          | ({ __typename: "LearnerArticle" } & LearnerArticlePartsFragment)
          | ({
              __typename: "LearnerPractitioner";
            } & LearnerPractitionerPartsFragment);
      }
  >;
};

export type LearnerUpdateProfileSettingsMutationVariables = Exact<{
  input: LearnerUpdateProfileSettingsInput;
  appInfo: AppInfo;
}>;

export type LearnerUpdateProfileSettingsMutation = {
  __typename?: "Mutation";
} & {
  learnerUpdateProfileSettings?: Maybe<
    { __typename?: "LearnerUpdateProfileSettings" } & Pick<
      LearnerUpdateProfileSettings,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & Pick<
          Learner,
          "firstName" | "lastName" | "fullName" | "photoUrl"
        > & {
            screens: { __typename?: "LearnerScreens" } & {
              profile: { __typename?: "LearnerProfileScreen" } & {
                settings?: Maybe<
                  { __typename?: "LearnerSettings" } & Pick<
                    LearnerSettings,
                    "title"
                  > & {
                      profile: {
                        __typename?: "LearnerProfileSettings";
                      } & LearnerProfileSettingsPartsFragment;
                    }
                >;
              };
            };
          };
      }
  >;
};

export type LearnerProfileSettingsPartsFragment = {
  __typename?: "LearnerProfileSettings";
} & Pick<LearnerProfileSettings, "title"> & {
    fields: { __typename?: "LearnerProfileSettingsFields" } & {
      photoUrl: { __typename?: "ImageInput" } & InputParts_ImageInput_Fragment;
      firstName: { __typename?: "TextInput" } & InputParts_TextInput_Fragment;
      lastName: { __typename?: "TextInput" } & InputParts_TextInput_Fragment;
      injuries: { __typename?: "TextInput" } & InputParts_TextInput_Fragment;
      birthday: { __typename?: "DateInput" } & InputParts_DateInput_Fragment;
      gender: { __typename?: "SelectInput" } & InputParts_SelectInput_Fragment;
    };
  };

export type LearnerUpdateNotificationSettingsToggleMutationVariables = Exact<{
  id: Scalars["ID"];
  checked: Scalars["Boolean"];
  appInfo: AppInfo;
}>;

export type LearnerUpdateNotificationSettingsToggleMutation = {
  __typename?: "Mutation";
} & {
  learnerUpdateNotificationSettingsToggle?: Maybe<
    { __typename?: "LearnerUpdateNotificationSettingsToggle" } & Pick<
      LearnerUpdateNotificationSettingsToggle,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & {
          screens: { __typename?: "LearnerScreens" } & {
            profile: { __typename?: "LearnerProfileScreen" } & {
              settings?: Maybe<
                { __typename?: "LearnerSettings" } & {
                  notifications: {
                    __typename?: "LearnerNotificationsSettings";
                  } & {
                    toggles: Array<
                      {
                        __typename?: "BooleanInput";
                      } & BooleanInputPartsFragment
                    >;
                  };
                }
              >;
            };
          };
        };
      }
  >;
};

export type LearnerUpdateCalendarSettingsToggleMutationVariables = Exact<{
  id: Scalars["ID"];
  checked: Scalars["Boolean"];
  appInfo: AppInfo;
}>;

export type LearnerUpdateCalendarSettingsToggleMutation = {
  __typename?: "Mutation";
} & {
  learnerUpdateCalendarSettingsToggle?: Maybe<
    { __typename?: "LearnerUpdateCalendarSettingsToggle" } & Pick<
      LearnerUpdateCalendarSettingsToggle,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & {
          screens: { __typename?: "LearnerScreens" } & {
            profile: { __typename?: "LearnerProfileScreen" } & {
              settings?: Maybe<
                { __typename?: "LearnerSettings" } & {
                  calendar?: Maybe<
                    { __typename?: "LearnerCalendarSettings" } & {
                      toggles: Array<
                        {
                          __typename?: "BooleanInput";
                        } & BooleanInputPartsFragment
                      >;
                    }
                  >;
                }
              >;
            };
          };
        };
      }
  >;
};

export type LearnerBiometricsConnectProviderMutationVariables = Exact<{
  id: Scalars["ID"];
  appInfo: AppInfo;
  redirectUrl?: Maybe<Scalars["String"]>;
}>;

export type LearnerBiometricsConnectProviderMutation = {
  __typename?: "Mutation";
} & {
  learnerBiometricsConnectProvider?: Maybe<
    { __typename?: "LearnerBiometricsConnectProvider" } & Pick<
      LearnerBiometricsConnectProvider,
      "ok" | "vitalUserId" | "vitalLinkToken" | "vitalLinkUrl"
    > & {
        learner: { __typename?: "Learner" } & {
          screens: { __typename?: "LearnerScreens" } & {
            profile: { __typename?: "LearnerProfileScreen" } & {
              settings?: Maybe<
                { __typename?: "LearnerSettings" } & {
                  biometrics?: Maybe<
                    { __typename?: "LearnerBiometricsSettings" } & {
                      providers: {
                        __typename?: "LearnerBiometricsProviders";
                      } & Pick<LearnerBiometricsProviders, "title"> & {
                          providers: Array<
                            { __typename?: "LearnerBiometricsProvider" } & Pick<
                              LearnerBiometricsProvider,
                              "id" | "name"
                            >
                          >;
                        };
                    }
                  >;
                }
              >;
            };
          };
        };
      }
  >;
};

export type LearnerBiometricsReportMissingDeviceMutationVariables = Exact<{
  deviceName: Scalars["String"];
  appInfo: AppInfo;
}>;

export type LearnerBiometricsReportMissingDeviceMutation = {
  __typename?: "Mutation";
} & {
  learnerBiometricsReportMissingDevice?: Maybe<
    { __typename?: "LearnerBiometricsReportMissingDevice" } & Pick<
      LearnerBiometricsReportMissingDevice,
      "ok"
    >
  >;
};

export type LearnerBiometricsDisconnectProviderMutationVariables = Exact<{
  id: Scalars["ID"];
  appInfo: AppInfo;
}>;

export type LearnerBiometricsDisconnectProviderMutation = {
  __typename?: "Mutation";
} & {
  learnerBiometricsDisconnectProvider?: Maybe<
    { __typename?: "LearnerBiometricsDisconnectProvider" } & Pick<
      LearnerBiometricsDisconnectProvider,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & {
          biometrics?: Maybe<
            { __typename?: "LearnerBiometrics" } & Pick<
              LearnerBiometrics,
              "hasHealthData"
            >
          >;
          screens: { __typename?: "LearnerScreens" } & {
            profile: { __typename?: "LearnerProfileScreen" } & {
              settings?: Maybe<
                { __typename?: "LearnerSettings" } & {
                  biometrics?: Maybe<
                    { __typename?: "LearnerBiometricsSettings" } & {
                      providers: {
                        __typename?: "LearnerBiometricsProviders";
                      } & Pick<LearnerBiometricsProviders, "title"> & {
                          providers: Array<
                            { __typename?: "LearnerBiometricsProvider" } & Pick<
                              LearnerBiometricsProvider,
                              "id" | "name"
                            >
                          >;
                        };
                    }
                  >;
                }
              >;
            };
          };
        };
      }
  >;
};

export type LearnerBiometricsDeleteHealthDataMutationVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerBiometricsDeleteHealthDataMutation = {
  __typename?: "Mutation";
} & {
  learnerBiometricsDeleteHealthData?: Maybe<
    { __typename?: "LearnerBiometricsDeleteHealthData" } & Pick<
      LearnerBiometricsDeleteHealthData,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & {
          biometrics?: Maybe<
            { __typename?: "LearnerBiometrics" } & Pick<
              LearnerBiometrics,
              "hasHealthData"
            >
          >;
          screens: { __typename?: "LearnerScreens" } & {
            profile: { __typename?: "LearnerProfileScreen" } & {
              settings?: Maybe<
                { __typename?: "LearnerSettings" } & {
                  biometrics?: Maybe<
                    { __typename?: "LearnerBiometricsSettings" } & {
                      providers: {
                        __typename?: "LearnerBiometricsProviders";
                      } & Pick<LearnerBiometricsProviders, "title"> & {
                          providers: Array<
                            { __typename?: "LearnerBiometricsProvider" } & Pick<
                              LearnerBiometricsProvider,
                              "id" | "name"
                            >
                          >;
                        };
                    }
                  >;
                }
              >;
            };
          };
        };
      }
  >;
};

export type LearnerBiometricsDeviceConnectionQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerBiometricsDeviceConnectionQuery = {
  __typename?: "Query";
} & {
  learnerBiometricsDeviceConnection: {
    __typename?: "LearnerBiometricsDeviceConnection";
  } & {
    intro: { __typename?: "LearnerBiometricsDeviceConnectionIntro" } & Pick<
      LearnerBiometricsDeviceConnectionIntro,
      "buttonText"
    > & {
        sections: Array<
          Maybe<
            {
              __typename?: "LearnerBiometricsDeviceConnectionIntroSection";
            } & Pick<
              LearnerBiometricsDeviceConnectionIntroSection,
              "title" | "contentHtml"
            >
          >
        >;
      };
    input: { __typename?: "SingleInputScreen" } & Pick<
      SingleInputScreen,
      "titleHtml" | "subtitleHtml" | "buttonText" | "skipButtonText"
    > & {
        input:
          | ({ __typename?: "SelectInput" } & Pick<
              SelectInput,
              "id" | "required"
            > & {
                options: Array<
                  { __typename: "SelectInputOption" } & Pick<
                    SelectInputOption,
                    "label" | "value"
                  >
                >;
              })
          | { __typename?: "MultiSelectInput" }
          | { __typename?: "TextInput" }
          | { __typename?: "DateInput" }
          | { __typename?: "BooleanInput" }
          | { __typename?: "RangeInput" }
          | { __typename?: "ImageInput" };
      };
    missingDeviceInput: { __typename?: "SingleInputScreen" } & Pick<
      SingleInputScreen,
      "titleHtml" | "subtitleHtml" | "buttonText" | "skipButtonText"
    > & {
        input:
          | { __typename?: "SelectInput" }
          | { __typename?: "MultiSelectInput" }
          | ({ __typename?: "TextInput" } & Pick<
              TextInput,
              "id" | "label" | "required" | "minLength" | "maxLength"
            >)
          | { __typename?: "DateInput" }
          | { __typename?: "BooleanInput" }
          | { __typename?: "RangeInput" }
          | { __typename?: "ImageInput" };
      };
    ready: { __typename?: "LearnerBiometricsDeviceConnectionReady" } & Pick<
      LearnerBiometricsDeviceConnectionReady,
      "title" | "contentHtml" | "buttonText"
    >;
  };
};

export type LearnerBiometricsModalTellMeMoreMutationVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerBiometricsModalTellMeMoreMutation = {
  __typename?: "Mutation";
} & {
  learnerBiometricsModalTellMeMore?: Maybe<
    { __typename?: "LearnerBiometricsModalTellMeMore" } & {
      learner: { __typename?: "Learner" } & {
        biometrics?: Maybe<
          { __typename?: "LearnerBiometrics" } & {
            modal?: Maybe<
              { __typename?: "LearnerBiometricsModal" } & Pick<
                LearnerBiometricsModal,
                | "title"
                | "contentHtml"
                | "tellMeMoreButtonText"
                | "remindMeLaterButtonText"
                | "dontAskAgainButtonText"
              >
            >;
          }
        >;
      };
    }
  >;
};

export type LearnerBiometricsModalRemindMeLaterMutationVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerBiometricsModalRemindMeLaterMutation = {
  __typename?: "Mutation";
} & {
  learnerBiometricsModalRemindMeLater?: Maybe<
    { __typename?: "LearnerBiometricsModalRemindMeLater" } & {
      learner: { __typename?: "Learner" } & {
        biometrics?: Maybe<
          { __typename?: "LearnerBiometrics" } & {
            modal?: Maybe<
              { __typename?: "LearnerBiometricsModal" } & Pick<
                LearnerBiometricsModal,
                | "title"
                | "contentHtml"
                | "tellMeMoreButtonText"
                | "remindMeLaterButtonText"
                | "dontAskAgainButtonText"
              >
            >;
          }
        >;
      };
    }
  >;
};

export type LearnerBiometricsModalDontAskAgainMutationVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerBiometricsModalDontAskAgainMutation = {
  __typename?: "Mutation";
} & {
  learnerBiometricsModalDontAskAgain?: Maybe<
    { __typename?: "LearnerBiometricsModalDontAskAgain" } & {
      learner: { __typename?: "Learner" } & {
        biometrics?: Maybe<
          { __typename?: "LearnerBiometrics" } & {
            modal?: Maybe<
              { __typename?: "LearnerBiometricsModal" } & Pick<
                LearnerBiometricsModal,
                | "title"
                | "contentHtml"
                | "tellMeMoreButtonText"
                | "remindMeLaterButtonText"
                | "dontAskAgainButtonText"
              >
            >;
          }
        >;
      };
    }
  >;
};

export type RequestSignInWithMagicLinkMutationVariables = Exact<{
  email: Scalars["String"];
  appInfo: AppInfo;
}>;

export type RequestSignInWithMagicLinkMutation = { __typename?: "Mutation" } & {
  requestSignInWithMagicLink?: Maybe<
    { __typename?: "RequestSignInWithMagicLink" } & Pick<
      RequestSignInWithMagicLink,
      "ok" | "message"
    >
  >;
};

export type LearnerRequestSignUpWithPasswordMutationVariables = Exact<{
  appInfo: AppInfo;
  email: Scalars["String"];
  password: Scalars["String"];
}>;

export type LearnerRequestSignUpWithPasswordMutation = {
  __typename?: "Mutation";
} & {
  learnerRequestSignUpWithPassword?: Maybe<
    { __typename?: "LearnerRequestSignUpWithPassword" } & Pick<
      LearnerRequestSignUpWithPassword,
      "ok" | "message"
    >
  >;
};

export type LearnerRequestSignUpWithMagicLinkMutationVariables = Exact<{
  appInfo: AppInfo;
  email: Scalars["String"];
}>;

export type LearnerRequestSignUpWithMagicLinkMutation = {
  __typename?: "Mutation";
} & {
  learnerRequestSignUpWithMagicLink?: Maybe<
    { __typename?: "LearnerRequestSignUpWithMagicLink" } & Pick<
      LearnerRequestSignUpWithMagicLink,
      "ok" | "message"
    >
  >;
};

export type LearnerSignUpWithPasswordMutationVariables = Exact<{
  appInfo: AppInfo;
  token: Scalars["String"];
  password: Scalars["String"];
}>;

export type LearnerSignUpWithPasswordMutation = { __typename?: "Mutation" } & {
  learnerSignUpWithPassword?: Maybe<
    { __typename?: "LearnerSignUpWithPassword" } & Pick<
      LearnerSignUpWithPassword,
      "ok" | "message" | "token"
    >
  >;
};

export type LearnerGetSignUpOptionsQueryVariables = Exact<{
  appInfo: AppInfo;
  email: Scalars["String"];
}>;

export type LearnerGetSignUpOptionsQuery = { __typename?: "Query" } & {
  learnerGetSignUpOptions: { __typename?: "LearnerSignUpScreen" } & {
    error?: Maybe<
      { __typename?: "LearnerSignUpError" } & Pick<
        LearnerSignUpError,
        "title" | "message" | "buttonAction" | "buttonText"
      >
    >;
    options?: Maybe<
      Array<
        Maybe<
          { __typename?: "LearnerSignUpOption" } & Pick<
            LearnerSignUpOption,
            "id" | "name" | "url"
          >
        >
      >
    >;
  };
};

export type LearnerUpgradeIndexScreenVersionMutationVariables = Exact<{
  version: IndexScreenVersion;
  appInfo: AppInfo;
}>;

export type LearnerUpgradeIndexScreenVersionMutation = {
  __typename?: "Mutation";
} & {
  learnerUpgradeIndexScreenVersion?: Maybe<
    { __typename?: "LearnerUpgradeIndexScreenVersion" } & Pick<
      LearnerUpgradeIndexScreenVersion,
      "ok" | "message"
    > & {
        screen: {
          __typename?: "LearnerIndexScreen";
        } & LearnerIndexScreenPartsFragment;
      }
  >;
};

export type LearnerHideIndexScreenExerciseMutationVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerHideIndexScreenExerciseMutation = {
  __typename?: "Mutation";
} & {
  learnerHideIndexScreenExercise?: Maybe<
    { __typename?: "LearnerHideIndexScreenExercise" } & Pick<
      LearnerHideIndexScreenExercise,
      "ok"
    > & {
        screen: {
          __typename?: "LearnerIndexScreen";
        } & LearnerIndexScreenPartsFragment;
      }
  >;
};

export type LearnerBiometricsDismissWebModalMutationVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerBiometricsDismissWebModalMutation = {
  __typename?: "Mutation";
} & {
  learnerBiometricsDismissWebModal?: Maybe<
    { __typename?: "LearnerBiometricsDismissWebModal" } & Pick<
      LearnerBiometricsDismissWebModal,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & {
          onboarding?: Maybe<
            {
              __typename?: "LearnerOnboardingForm";
            } & LearnerOnboardingPartsFragment
          >;
          biometrics?: Maybe<
            {
              __typename?: "LearnerBiometrics";
            } & LearnerBiometricsPartsFragment
          >;
        } & LearnerPartsFragment;
      }
  >;
};

export type LearnerSignInScreenQueryVariables = Exact<{
  appInfo: AppInfo;
  email: Scalars["String"];
  authBackendId: Scalars["String"];
}>;

export type LearnerSignInScreenQuery = { __typename?: "Query" } & {
  learnerSignInScreen: { __typename?: "LearnerSignInScreen" } & {
    error?: Maybe<
      { __typename?: "LearnerSignInScreenError" } & Pick<
        LearnerSignInScreenError,
        "title" | "subTitle" | "message" | "buttonAction" | "buttonText"
      >
    >;
    option?: Maybe<
      { __typename?: "LearnerSignInOption" } & Pick<
        LearnerSignInOption,
        "id" | "name" | "url"
      >
    >;
  };
};

export type LearnerCreateAccountScreenQueryVariables = Exact<{
  appInfo: AppInfo;
  email: Scalars["String"];
}>;

export type LearnerCreateAccountScreenQuery = { __typename?: "Query" } & {
  learnerCreateAccountScreen: {
    __typename?: "LearnerCreateAccountScreen";
  } & Pick<
    LearnerCreateAccountScreen,
    | "titleHtml"
    | "subtitleHtml"
    | "singleSignOnMessageHtml"
    | "createPasswordMessageHtml"
    | "createPasswordButtonText"
  > & {
      singleSignOnOptions?: Maybe<
        Array<
          { __typename?: "LeanerCreateAccountOption" } & Pick<
            LeanerCreateAccountOption,
            "id" | "name" | "url"
          >
        >
      >;
      createPasswordOption?: Maybe<
        { __typename?: "LeanerCreateAccountOption" } & Pick<
          LeanerCreateAccountOption,
          "id" | "name" | "url"
        >
      >;
      error?: Maybe<
        { __typename?: "LearnerCreateAccountScreenError" } & Pick<
          LearnerCreateAccountScreenError,
          "title" | "message" | "buttonAction" | "buttonText"
        >
      >;
    };
};

export type AdminInfoPartsFragment = { __typename?: "CompanyAdmin" } & Pick<
  CompanyAdmin,
  | "id"
  | "firstName"
  | "lastName"
  | "fullName"
  | "photoUrl"
  | "companyName"
  | "companyId"
  | "companyType"
>;

export type SignInMutationVariables = Exact<{
  appInfo: AppInfo;
  input: SignInInput;
}>;

export type SignInMutation = { __typename?: "Mutation" } & {
  signIn?: Maybe<
    { __typename?: "SignIn" } & Pick<SignIn, "authToken"> & {
        learner?: Maybe<{ __typename?: "Learner" } & Pick<Learner, "id">>;
        companyAdmin?: Maybe<
          { __typename?: "CompanyAdmin" } & {
            adminSettingsScreen: { __typename?: "AdminSettingsScreen" } & Pick<
              AdminSettingsScreen,
              "title" | "subTitle" | "companyName"
            > & {
                admins?: Maybe<
                  { __typename?: "Admins" } & Pick<
                    Admins,
                    "title" | "labels"
                  > & {
                      members: Array<
                        Maybe<
                          { __typename?: "AdminMemberInfo" } & Pick<
                            AdminMemberInfo,
                            | "id"
                            | "member"
                            | "firstName"
                            | "lastName"
                            | "email"
                            | "timezone"
                          > & {
                              action?: Maybe<
                                { __typename?: "Action" } & Pick<
                                  Action,
                                  "buttonAction" | "buttonText" | "buttonStyle"
                                >
                              >;
                            }
                        >
                      >;
                    }
                >;
              };
          } & AdminInfoPartsFragment
        >;
      }
  >;
};

export type SignInWithTokenMutationVariables = Exact<{
  appInfo: AppInfo;
  input: SignInWithTokenInput;
}>;

export type SignInWithTokenMutation = { __typename?: "Mutation" } & {
  signInWithToken?: Maybe<
    { __typename?: "SignInWithToken" } & Pick<
      SignInWithToken,
      "ok" | "authToken" | "refreshToken"
    > & {
        userProfiles?: Maybe<
          { __typename?: "UserProfiles" } & {
            learner?: Maybe<{ __typename?: "Learner" } & LearnerPartsFragment>;
            companyAdmin?: Maybe<
              { __typename?: "CompanyAdmin" } & CompanyAdminPartsFragment
            >;
          }
        >;
      }
  >;
};

export type MembersListPartsFragment = { __typename?: "Members" } & Pick<
  Members,
  | "id"
  | "member"
  | "firstName"
  | "lastName"
  | "email"
  | "timezone"
  | "status"
  | "statusDate"
> & {
    action?: Maybe<
      { __typename?: "Action" } & Pick<
        Action,
        "buttonText" | "buttonStyle" | "buttonAction"
      >
    >;
  };

export type MembersScreenPartsFragment = {
  __typename?: "MembersScreen";
} & Pick<
  MembersScreen,
  | "title"
  | "subTitle"
  | "searchQuery"
  | "totalPages"
  | "itemsPerPage"
  | "pageNumber"
  | "statusSort"
  | "labels"
> & {
    uploadButton: { __typename?: "Action" } & Pick<
      Action,
      "buttonText" | "buttonStyle" | "buttonAction"
    >;
    addButton: { __typename?: "Action" } & Pick<
      Action,
      "buttonText" | "buttonStyle" | "buttonAction"
    >;
    members: Array<
      Maybe<{ __typename?: "Members" } & MembersListPartsFragment>
    >;
  };

export type AdminSettingsScreenPartsFragment = {
  __typename?: "AdminSettingsScreen";
} & Pick<AdminSettingsScreen, "title" | "subTitle" | "companyName"> & {
    admins?: Maybe<
      { __typename?: "Admins" } & Pick<Admins, "labels"> & {
          title: { __typename?: "Action" } & Pick<
            Action,
            "buttonAction" | "buttonText" | "buttonStyle"
          >;
          members: Array<
            Maybe<
              { __typename?: "AdminMemberInfo" } & Pick<
                AdminMemberInfo,
                | "id"
                | "member"
                | "firstName"
                | "lastName"
                | "email"
                | "timezone"
              > & {
                  action?: Maybe<
                    { __typename?: "Action" } & Pick<
                      Action,
                      "buttonAction" | "buttonText" | "buttonStyle"
                    >
                  >;
                }
            >
          >;
        }
    >;
  };

export type IntegrationsScreenPartsFragment = {
  __typename?: "IntegrationsScreen";
} & Pick<IntegrationsScreen, "title" | "subTitle"> & {
    domains: { __typename?: "Domains" } & Pick<Domains, "title"> & {
        addButton: { __typename?: "Action" } & Pick<
          Action,
          "buttonAction" | "buttonText" | "buttonStyle"
        >;
        domainList: Array<
          Maybe<
            { __typename?: "DomainList" } & Pick<
              DomainList,
              "name" | "dateAdded"
            > & {
                action: { __typename?: "Action" } & Pick<
                  Action,
                  "buttonAction" | "buttonText" | "buttonStyle"
                >;
              }
          >
        >;
      };
    sso: { __typename?: "CompanySSO" } & Pick<
      CompanySso,
      "title" | "subTitle"
    > & {
        signIn: { __typename?: "SignInOptions" } & Pick<
          SignInOptions,
          "title"
        > & {
            items: Array<
              Maybe<
                { __typename?: "SSOItems" } & Pick<
                  SsoItems,
                  "order" | "id" | "name" | "isEnabled"
                >
              >
            >;
          };
        signUp: { __typename?: "SignUpOptions" } & Pick<
          SignUpOptions,
          "title" | "isEnabled"
        >;
      };
    hris: { __typename?: "HRIS" } & Pick<
      Hris,
      "title" | "subTitle" | "link"
    > & {
        connections?: Maybe<
          Array<
            Maybe<
              { __typename?: "Connections" } & Pick<
                Connections,
                "id" | "logo" | "name" | "subCompanyName"
              >
            >
          >
        >;
      };
  };

export type DashboardInfoPartsFragment = {
  __typename?: "DashboardScreen";
} & Pick<DashboardScreen, "token" | "views">;

export type CompanyAdminQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type CompanyAdminQuery = { __typename?: "Query" } & {
  companyAdmin: { __typename?: "CompanyAdmin" } & {
    integrationsScreen: {
      __typename?: "IntegrationsScreen";
    } & IntegrationsScreenPartsFragment;
    membersScreen: {
      __typename?: "MembersScreen";
    } & MembersScreenPartsFragment;
    adminSettingsScreen: {
      __typename?: "AdminSettingsScreen";
    } & AdminSettingsScreenPartsFragment;
    dashboardScreen?: Maybe<
      { __typename?: "DashboardScreen" } & DashboardInfoPartsFragment
    >;
  } & AdminInfoPartsFragment;
};

export type CompanyPortalMembersScreenQueryVariables = Exact<{
  appInfo: AppInfo;
  searchQuery?: Maybe<Scalars["String"]>;
  statusSort?: Maybe<Scalars["Boolean"]>;
  itemsPerPage?: Maybe<Scalars["Int"]>;
  pageNumber?: Maybe<Scalars["Int"]>;
}>;

export type CompanyPortalMembersScreenQuery = { __typename?: "Query" } & {
  companyPortalMembersScreen: {
    __typename?: "MembersScreen";
  } & MembersScreenPartsFragment;
};

export type CompanyPortalIntegrationsScreenQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type CompanyPortalIntegrationsScreenQuery = { __typename?: "Query" } & {
  companyPortalIntegrationsScreen: {
    __typename?: "IntegrationsScreen";
  } & IntegrationsScreenPartsFragment;
};

export type CompanyPortalAdminSettingsScreenQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type CompanyPortalAdminSettingsScreenQuery = { __typename?: "Query" } & {
  companyPortalAdminSettingsScreen: {
    __typename?: "AdminSettingsScreen";
  } & AdminSettingsScreenPartsFragment;
};

export type CompanyPortalDashboardScreenQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type CompanyPortalDashboardScreenQuery = { __typename?: "Query" } & {
  companyPortalDashboardScreen?: Maybe<
    { __typename?: "DashboardScreen" } & DashboardInfoPartsFragment
  >;
};

export type CompanyPortalAdminAddMutationVariables = Exact<{
  appInfo: AppInfo;
  memberUserId: Scalars["ID"];
}>;

export type CompanyPortalAdminAddMutation = { __typename?: "Mutation" } & {
  companyPortalAdminAdd?: Maybe<
    { __typename?: "CompanyPortalAdminAdd" } & Pick<
      CompanyPortalAdminAdd,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          adminSettingsScreen: {
            __typename?: "AdminSettingsScreen";
          } & AdminSettingsScreenPartsFragment;
        };
      }
  >;
};

export type CompanyPortalAdminRemoveMutationVariables = Exact<{
  appInfo: AppInfo;
  adminUserId: Scalars["ID"];
}>;

export type CompanyPortalAdminRemoveMutation = { __typename?: "Mutation" } & {
  companyPortalAdminRemove?: Maybe<
    { __typename?: "CompanyPortalAdminRemove" } & Pick<
      CompanyPortalAdminRemove,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          adminSettingsScreen: {
            __typename?: "AdminSettingsScreen";
          } & AdminSettingsScreenPartsFragment;
        };
      }
  >;
};

export type CompanyPortalMemberAddMutationVariables = Exact<{
  appInfo: AppInfo;
  input: CompanyPortalMemberAddInput;
}>;

export type CompanyPortalMemberAddMutation = { __typename?: "Mutation" } & {
  companyPortalMemberAdd?: Maybe<
    { __typename?: "CompanyPortalMemberAdd" } & Pick<
      CompanyPortalMemberAdd,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          membersScreen: { __typename?: "MembersScreen" } & Pick<
            MembersScreen,
            "title" | "subTitle" | "labels" | "searchQuery" | "statusSort"
          > & {
              uploadButton: { __typename?: "Action" } & Pick<
                Action,
                "buttonAction" | "buttonText" | "buttonStyle"
              >;
              addButton: { __typename?: "Action" } & Pick<
                Action,
                "buttonAction" | "buttonText" | "buttonStyle"
              >;
              members: Array<
                Maybe<{ __typename?: "Members" } & MembersListPartsFragment>
              >;
            };
        };
      }
  >;
};

export type CompanyPortalMemberDeactivateMutationVariables = Exact<{
  appInfo: AppInfo;
  memberUserId: Scalars["ID"];
}>;

export type CompanyPortalMemberDeactivateMutation = {
  __typename?: "Mutation";
} & {
  companyPortalMemberDeactivate?: Maybe<
    { __typename?: "CompanyPortalMemberDeactivate" } & Pick<
      CompanyPortalMemberDeactivate,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          membersScreen: {
            __typename?: "MembersScreen";
          } & MembersScreenPartsFragment;
        };
      }
  >;
};

export type CompanyPortalMemberReactivateMutationVariables = Exact<{
  appInfo: AppInfo;
  memberUserId: Scalars["ID"];
}>;

export type CompanyPortalMemberReactivateMutation = {
  __typename?: "Mutation";
} & {
  companyPortalMemberReactivate?: Maybe<
    { __typename?: "CompanyPortalMemberReactivate" } & Pick<
      CompanyPortalMemberReactivate,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          membersScreen: {
            __typename?: "MembersScreen";
          } & MembersScreenPartsFragment;
        };
      }
  >;
};

export type CompanyPortalMemberSendInviteMutationVariables = Exact<{
  appInfo: AppInfo;
  memberUserId: Scalars["ID"];
}>;

export type CompanyPortalMemberSendInviteMutation = {
  __typename?: "Mutation";
} & {
  companyPortalMemberSendInvite?: Maybe<
    { __typename?: "CompanyPortalMemberSendInvite" } & Pick<
      CompanyPortalMemberSendInvite,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          membersScreen: {
            __typename?: "MembersScreen";
          } & MembersScreenPartsFragment;
        };
      }
  >;
};

export type CompanyPortalDomainAddMutationVariables = Exact<{
  appInfo: AppInfo;
  domain: Scalars["String"];
}>;

export type CompanyPortalDomainAddMutation = { __typename?: "Mutation" } & {
  companyPortalDomainAdd?: Maybe<
    { __typename?: "CompanyPortalDomainAdd" } & Pick<
      CompanyPortalDomainAdd,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          integrationsScreen: {
            __typename?: "IntegrationsScreen";
          } & IntegrationsScreenPartsFragment;
        };
      }
  >;
};

export type CompanyPortalDomainRemoveMutationVariables = Exact<{
  appInfo: AppInfo;
  domain: Scalars["String"];
}>;

export type CompanyPortalDomainRemoveMutation = { __typename?: "Mutation" } & {
  companyPortalDomainRemove?: Maybe<
    { __typename?: "CompanyPortalDomainRemove" } & Pick<
      CompanyPortalDomainRemove,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          integrationsScreen: {
            __typename?: "IntegrationsScreen";
          } & IntegrationsScreenPartsFragment;
        };
      }
  >;
};

export type CompanyPortalSignInOptionUpdateMutationVariables = Exact<{
  appInfo: AppInfo;
  input: CompanyPortalSignInOptionSettingsInput;
}>;

export type CompanyPortalSignInOptionUpdateMutation = {
  __typename?: "Mutation";
} & {
  companyPortalSignInOptionUpdate?: Maybe<
    { __typename?: "CompanyPortalSignInOptionUpdate" } & Pick<
      CompanyPortalSignInOptionUpdate,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          integrationsScreen: {
            __typename?: "IntegrationsScreen";
          } & IntegrationsScreenPartsFragment;
        };
      }
  >;
};

export type CompanyPortalSelfSignUpUpdateMutationVariables = Exact<{
  appInfo: AppInfo;
  isSignUpEnabled: Scalars["Boolean"];
}>;

export type CompanyPortalSelfSignUpUpdateMutation = {
  __typename?: "Mutation";
} & {
  companyPortalSelfSignUpUpdate?: Maybe<
    { __typename?: "CompanyPortalSelfSignUpUpdate" } & Pick<
      CompanyPortalSelfSignUpUpdate,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          integrationsScreen: {
            __typename?: "IntegrationsScreen";
          } & IntegrationsScreenPartsFragment;
        };
      }
  >;
};

export type CompanyPortalHrisRemoveMutationVariables = Exact<{
  appInfo: AppInfo;
  hrisConnectionId: Scalars["ID"];
}>;

export type CompanyPortalHrisRemoveMutation = { __typename?: "Mutation" } & {
  companyPortalHrisRemove?: Maybe<
    { __typename?: "CompanyPortalHRISRemove" } & Pick<
      CompanyPortalHrisRemove,
      "ok"
    > & {
        companyAdmin: { __typename?: "CompanyAdmin" } & {
          integrationsScreen: {
            __typename?: "IntegrationsScreen";
          } & IntegrationsScreenPartsFragment;
        };
      }
  >;
};

export type LearnerBiometricsPartsFragment = {
  __typename?: "LearnerBiometrics";
} & Pick<
  LearnerBiometrics,
  | "vitalUserId"
  | "hasHealthData"
  | "shouldShowWebModal"
  | "hasExperiencedTheAppleHealthConnectionPermissionsIssue"
> & {
    providers: Array<
      { __typename?: "LearnerBiometricsProvider" } & Pick<
        LearnerBiometricsProvider,
        "id" | "name"
      >
    >;
    modal?: Maybe<
      { __typename?: "LearnerBiometricsModal" } & Pick<
        LearnerBiometricsModal,
        | "title"
        | "contentHtml"
        | "tellMeMoreButtonText"
        | "remindMeLaterButtonText"
      >
    >;
  };

export type CompanyAdminPartsFragment = { __typename?: "CompanyAdmin" } & Pick<
  CompanyAdmin,
  | "id"
  | "firstName"
  | "lastName"
  | "fullName"
  | "companyName"
  | "photoUrl"
  | "companyType"
>;

export type UserProfilesQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type UserProfilesQuery = { __typename?: "Query" } & {
  userProfiles: { __typename?: "UserProfiles" } & {
    learner?: Maybe<
      { __typename?: "Learner" } & {
        onboarding?: Maybe<
          {
            __typename?: "LearnerOnboardingForm";
          } & LearnerOnboardingPartsFragment
        >;
        biometrics?: Maybe<
          { __typename?: "LearnerBiometrics" } & LearnerBiometricsPartsFragment
        >;
      } & LearnerPartsFragment
    >;
    companyAdmin?: Maybe<
      { __typename?: "CompanyAdmin" } & CompanyAdminPartsFragment
    >;
  };
};

export type LearnerMixedContentListPartsFragment = {
  __typename?: "LearnerMixedContentList";
} & Pick<LearnerMixedContentList, "id" | "label" | "descriptionHtml"> & {
    items: Array<
      | ({
          __typename: "LearnerGroupSession";
        } & LearnerSessionCardParts_LearnerGroupSession_Fragment)
      | ({ __typename: "LearnerRecording" } & LearnerRecordingCardPartsFragment)
      | ({ __typename: "LearnerArticle" } & LearnerArticleCardPartsFragment)
    >;
  };

export type LearnerHomeScreenQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerHomeScreenQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      home: { __typename?: "LearnerHomeScreen" } & Pick<
        LearnerHomeScreen,
        "titleHtml"
      > & {
          article?: Maybe<
            { __typename?: "LearnerArticle" } & LearnerArticlePartsFragment
          >;
          forYou?: Maybe<
            {
              __typename?: "LearnerMixedContentList";
            } & LearnerMixedContentListPartsFragment
          >;
          trendingNow: {
            __typename?: "LearnerMixedContentList";
          } & LearnerMixedContentListPartsFragment;
          upcomingLiveSessions: {
            __typename?: "LearnerGroupSessionsList";
          } & LearnerGroupSessionsListPartsFragment &
            LearnerGroupSessionsListPartsFragment;
          recommendedForYou: {
            __typename?: "LearnerRecordingsList";
          } & LearnerRecordingsListPartsFragment;
        };
    };
  };
};

export type LearnerRecommendedRemoveItemMutationVariables = Exact<{
  appInfo: AppInfo;
  input: LearnerRecommendedRemoveItemInput;
}>;

export type LearnerRecommendedRemoveItemMutation = {
  __typename?: "Mutation";
} & {
  learnerRecommendedRemoveItem?: Maybe<
    { __typename?: "LearnerRecommendedRemoveItem" } & Pick<
      LearnerRecommendedRemoveItem,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & {
          screens: { __typename?: "LearnerScreens" } & {
            home: { __typename?: "LearnerHomeScreen" } & Pick<
              LearnerHomeScreen,
              "titleHtml"
            > & {
                forYou?: Maybe<
                  {
                    __typename?: "LearnerMixedContentList";
                  } & LearnerMixedContentListPartsFragment
                >;
                trendingNow: {
                  __typename?: "LearnerMixedContentList";
                } & LearnerMixedContentListPartsFragment;
                upcomingLiveSessions: {
                  __typename?: "LearnerGroupSessionsList";
                } & LearnerGroupSessionsListPartsFragment &
                  LearnerGroupSessionsListPartsFragment;
                recommendedForYou: {
                  __typename?: "LearnerRecordingsList";
                } & LearnerRecordingsListPartsFragment;
              };
          };
        };
      }
  >;
};

export type LearnerDismissIndexCtaPromptMutationVariables = Exact<{
  appInfo: AppInfo;
  id: Scalars["ID"];
}>;

export type LearnerDismissIndexCtaPromptMutation = {
  __typename?: "Mutation";
} & {
  learnerDismissIndexCtaPrompt?: Maybe<
    { __typename?: "LearnerDismissIndexCTAPrompt" } & Pick<
      LearnerDismissIndexCtaPrompt,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & {
          screens: { __typename?: "LearnerScreens" } & {
            index: { __typename?: "LearnerIndexScreen" } & {
              CTAs?: Maybe<
                {
                  __typename?: "LearnerIndexCTAs";
                } & LearnerIndexCtaPartsFragment
              >;
            };
          };
        };
      }
  >;
};

export type LearnerScreenIndexGraphWeekEnergyQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphWeekEnergyQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & {
        breakdown?: Maybe<
          { __typename?: "LearnerIndexBreakdown" } & {
            energy: { __typename?: "LearnerIndexBreakdownPillar" } & {
              score?: Maybe<
                { __typename?: "LearnerIndexScore" } & {
                  graph?: Maybe<
                    { __typename?: "LearnerIndexScoreGraph" } & {
                      periods: {
                        __typename?: "LearnerIndexScoreDataPeriods";
                      } & {
                        week: Array<
                          {
                            __typename?: "LearnerIndexScoreDataPeriod";
                          } & LearnerIndexScoreDataPeriodPartsFragment
                        >;
                      };
                    }
                  >;
                }
              >;
            };
          }
        >;
      };
    };
  };
};

export type LearnerScreenIndexGraphMonthEnergyQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphMonthEnergyQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & {
        breakdown?: Maybe<
          { __typename?: "LearnerIndexBreakdown" } & {
            energy: { __typename?: "LearnerIndexBreakdownPillar" } & {
              score?: Maybe<
                { __typename?: "LearnerIndexScore" } & {
                  graph?: Maybe<
                    { __typename?: "LearnerIndexScoreGraph" } & {
                      periods: {
                        __typename?: "LearnerIndexScoreDataPeriods";
                      } & {
                        month: Array<
                          {
                            __typename?: "LearnerIndexScoreDataPeriod";
                          } & LearnerIndexScoreDataPeriodPartsFragment
                        >;
                      };
                    }
                  >;
                }
              >;
            };
          }
        >;
      };
    };
  };
};

export type LearnerScreenIndexGraphYearEnergyQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphYearEnergyQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & {
        breakdown?: Maybe<
          { __typename?: "LearnerIndexBreakdown" } & {
            energy: { __typename?: "LearnerIndexBreakdownPillar" } & {
              score?: Maybe<
                { __typename?: "LearnerIndexScore" } & {
                  graph?: Maybe<
                    { __typename?: "LearnerIndexScoreGraph" } & {
                      periods: {
                        __typename?: "LearnerIndexScoreDataPeriods";
                      } & {
                        year: Array<
                          {
                            __typename?: "LearnerIndexScoreDataPeriod";
                          } & LearnerIndexScoreDataPeriodPartsFragment
                        >;
                      };
                    }
                  >;
                }
              >;
            };
          }
        >;
      };
    };
  };
};

export type LearnerScreenIndexGraphWeekResilienceQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphWeekResilienceQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & {
        breakdown?: Maybe<
          { __typename?: "LearnerIndexBreakdown" } & {
            resilience: { __typename?: "LearnerIndexBreakdownPillar" } & {
              score?: Maybe<
                { __typename?: "LearnerIndexScore" } & {
                  graph?: Maybe<
                    { __typename?: "LearnerIndexScoreGraph" } & Pick<
                      LearnerIndexScoreGraph,
                      "pillarLabel"
                    > & {
                        periods: {
                          __typename?: "LearnerIndexScoreDataPeriods";
                        } & {
                          week: Array<
                            {
                              __typename?: "LearnerIndexScoreDataPeriod";
                            } & LearnerIndexScoreDataPeriodPartsFragment
                          >;
                        };
                      }
                  >;
                }
              >;
            };
          }
        >;
      };
    };
  };
};

export type LearnerScreenIndexGraphMonthResilienceQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphMonthResilienceQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & {
        breakdown?: Maybe<
          { __typename?: "LearnerIndexBreakdown" } & {
            resilience: { __typename?: "LearnerIndexBreakdownPillar" } & {
              score?: Maybe<
                { __typename?: "LearnerIndexScore" } & {
                  graph?: Maybe<
                    { __typename?: "LearnerIndexScoreGraph" } & Pick<
                      LearnerIndexScoreGraph,
                      "pillarLabel"
                    > & {
                        periods: {
                          __typename?: "LearnerIndexScoreDataPeriods";
                        } & {
                          month: Array<
                            {
                              __typename?: "LearnerIndexScoreDataPeriod";
                            } & LearnerIndexScoreDataPeriodPartsFragment
                          >;
                        };
                      }
                  >;
                }
              >;
            };
          }
        >;
      };
    };
  };
};

export type LearnerScreenIndexGraphYearResilienceQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphYearResilienceQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & {
        breakdown?: Maybe<
          { __typename?: "LearnerIndexBreakdown" } & {
            resilience: { __typename?: "LearnerIndexBreakdownPillar" } & {
              score?: Maybe<
                { __typename?: "LearnerIndexScore" } & {
                  graph?: Maybe<
                    { __typename?: "LearnerIndexScoreGraph" } & Pick<
                      LearnerIndexScoreGraph,
                      "pillarLabel"
                    > & {
                        periods: {
                          __typename?: "LearnerIndexScoreDataPeriods";
                        } & {
                          year: Array<
                            {
                              __typename?: "LearnerIndexScoreDataPeriod";
                            } & LearnerIndexScoreDataPeriodPartsFragment
                          >;
                        };
                      }
                  >;
                }
              >;
            };
          }
        >;
      };
    };
  };
};

export type LearnerScreenIndexGraphWeekActivityQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphWeekActivityQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & {
        breakdown?: Maybe<
          { __typename?: "LearnerIndexBreakdown" } & {
            activity: { __typename?: "LearnerIndexBreakdownPillar" } & {
              score?: Maybe<
                { __typename?: "LearnerIndexScore" } & {
                  graph?: Maybe<
                    { __typename?: "LearnerIndexScoreGraph" } & Pick<
                      LearnerIndexScoreGraph,
                      "pillarLabel"
                    > & {
                        periods: {
                          __typename?: "LearnerIndexScoreDataPeriods";
                        } & {
                          week: Array<
                            {
                              __typename?: "LearnerIndexScoreDataPeriod";
                            } & LearnerIndexScoreDataPeriodPartsFragment
                          >;
                        };
                      }
                  >;
                }
              >;
            };
          }
        >;
      };
    };
  };
};

export type LearnerScreenIndexGraphMonthActivityQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphMonthActivityQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & {
        breakdown?: Maybe<
          { __typename?: "LearnerIndexBreakdown" } & {
            activity: { __typename?: "LearnerIndexBreakdownPillar" } & {
              score?: Maybe<
                { __typename?: "LearnerIndexScore" } & {
                  graph?: Maybe<
                    { __typename?: "LearnerIndexScoreGraph" } & Pick<
                      LearnerIndexScoreGraph,
                      "pillarLabel"
                    > & {
                        periods: {
                          __typename?: "LearnerIndexScoreDataPeriods";
                        } & {
                          month: Array<
                            {
                              __typename?: "LearnerIndexScoreDataPeriod";
                            } & LearnerIndexScoreDataPeriodPartsFragment
                          >;
                        };
                      }
                  >;
                }
              >;
            };
          }
        >;
      };
    };
  };
};

export type LearnerScreenIndexGraphYearActivityQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphYearActivityQuery = {
  __typename?: "Query";
} & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & {
        breakdown?: Maybe<
          { __typename?: "LearnerIndexBreakdown" } & {
            activity: { __typename?: "LearnerIndexBreakdownPillar" } & {
              score?: Maybe<
                { __typename?: "LearnerIndexScore" } & {
                  graph?: Maybe<
                    { __typename?: "LearnerIndexScoreGraph" } & Pick<
                      LearnerIndexScoreGraph,
                      "pillarLabel"
                    > & {
                        periods: {
                          __typename?: "LearnerIndexScoreDataPeriods";
                        } & {
                          year: Array<
                            {
                              __typename?: "LearnerIndexScoreDataPeriod";
                            } & LearnerIndexScoreDataPeriodPartsFragment
                          >;
                        };
                      }
                  >;
                }
              >;
            };
          }
        >;
      };
    };
  };
};

export type LearnerScreenIndexGraphWeekQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphWeekQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & Pick<
        LearnerIndexScreen,
        "version"
      > & {
          score?: Maybe<
            { __typename?: "LearnerIndexScore" } & {
              graph?: Maybe<
                { __typename?: "LearnerIndexScoreGraph" } & {
                  periods: { __typename?: "LearnerIndexScoreDataPeriods" } & {
                    week: Array<
                      {
                        __typename?: "LearnerIndexScoreDataPeriod";
                      } & LearnerIndexScoreDataPeriodPartsFragment
                    >;
                  };
                }
              >;
            }
          >;
        };
    };
  };
};

export type LearnerScreenIndexGraphMonthQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphMonthQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & Pick<
        LearnerIndexScreen,
        "version"
      > & {
          score?: Maybe<
            { __typename?: "LearnerIndexScore" } & {
              graph?: Maybe<
                { __typename?: "LearnerIndexScoreGraph" } & {
                  periods: { __typename?: "LearnerIndexScoreDataPeriods" } & {
                    month: Array<
                      {
                        __typename?: "LearnerIndexScoreDataPeriod";
                      } & LearnerIndexScoreDataPeriodPartsFragment
                    >;
                  };
                }
              >;
            }
          >;
        };
    };
  };
};

export type LearnerScreenIndexGraphYearQueryVariables = Exact<{
  appInfo: AppInfo;
  first?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
}>;

export type LearnerScreenIndexGraphYearQuery = { __typename?: "Query" } & {
  learner: { __typename?: "Learner" } & {
    screens: { __typename?: "LearnerScreens" } & {
      index: { __typename?: "LearnerIndexScreen" } & Pick<
        LearnerIndexScreen,
        "version"
      > & {
          score?: Maybe<
            { __typename?: "LearnerIndexScore" } & {
              graph?: Maybe<
                { __typename?: "LearnerIndexScoreGraph" } & {
                  periods: { __typename?: "LearnerIndexScoreDataPeriods" } & {
                    year: Array<
                      {
                        __typename?: "LearnerIndexScoreDataPeriod";
                      } & LearnerIndexScoreDataPeriodPartsFragment
                    >;
                  };
                }
              >;
            }
          >;
        };
    };
  };
};

export type UpdatePasswordWithTokenMutationVariables = Exact<{
  password: Scalars["String"];
  token: Scalars["String"];
}>;

export type UpdatePasswordWithTokenMutation = { __typename?: "Mutation" } & {
  updatePasswordWithToken?: Maybe<
    { __typename?: "UpdatePasswordWithToken" } & Pick<
      UpdatePasswordWithToken,
      "ok" | "message"
    >
  >;
};

export type ReportAssessmentEventMutationVariables = Exact<{
  params?: Maybe<Scalars["JSONString"]>;
  eventType: AssessmentEvent;
  at: Scalars["String"];
  appInfo: AppInfo;
  groupUuid?: Maybe<Scalars["String"]>;
}>;

export type ReportAssessmentEventMutation = { __typename?: "Mutation" } & {
  reportAssessmentEvent?: Maybe<
    { __typename?: "ReportAssessmentEvent" } & Pick<ReportAssessmentEvent, "ok">
  >;
};

export type StartAssessmentMutationVariables = Exact<{
  appInfo: AppInfo;
  version?: Maybe<Scalars["String"]>;
}>;

export type StartAssessmentMutation = { __typename?: "Mutation" } & {
  startAssessment?: Maybe<
    { __typename?: "StartAssessment" } & Pick<
      StartAssessment,
      | "version"
      | "saveAndResumeSupported"
      | "resumeStepId"
      | "progressSavedAt"
      | "progressExpiresAt"
    > & {
        steps: Array<
          Maybe<
            | ({ __typename: "AssessmentWelcomeStep" } & Pick<
                AssessmentWelcomeStep,
                "id" | "titleHtml" | "subtitleHtml"
              >)
            | ({ __typename: "AssessmentInfoStep" } & Pick<
                AssessmentInfoStep,
                "id" | "titleHtml" | "subtitleHtml"
              >)
            | ({ __typename: "AssessmentSectionStep" } & Pick<
                AssessmentSectionStep,
                "id" | "titleHtml" | "subtitleHtml"
              >)
            | ({ __typename: "AssessmentQuestionStep" } & Pick<
                AssessmentQuestionStep,
                "id" | "titleHtml" | "subtitleHtml"
              > & {
                  input:
                    | ({ __typename: "SelectInput" } & Pick<
                        SelectInput,
                        "id" | "label" | "required"
                      > & {
                          options: Array<
                            { __typename?: "SelectInputOption" } & Pick<
                              SelectInputOption,
                              "id" | "label" | "value"
                            >
                          >;
                        })
                    | { __typename: "MultiSelectInput" }
                    | ({ __typename: "TextInput" } & Pick<
                        TextInput,
                        "id" | "label" | "required"
                      >)
                    | { __typename: "DateInput" }
                    | { __typename: "BooleanInput" }
                    | { __typename: "RangeInput" }
                    | { __typename: "ImageInput" };
                  response?: Maybe<
                    { __typename?: "AssessmentResponse" } & Pick<
                      AssessmentResponse,
                      "text" | "score" | "optionId"
                    >
                  >;
                })
            | ({ __typename: "AssessmentEndStep" } & Pick<
                AssessmentEndStep,
                "id" | "titleHtml" | "subtitleHtml"
              >)
          >
        >;
      }
  >;
};

export type SaveAndExitAssessmentMutationVariables = Exact<{
  appInfo: AppInfo;
  responses: Array<AssessmentStepResponseInput>;
  stepId?: Maybe<Scalars["ID"]>;
}>;

export type SaveAndExitAssessmentMutation = { __typename?: "Mutation" } & {
  saveAndExitAssessment?: Maybe<
    { __typename?: "SaveAndExitAssessment" } & Pick<SaveAndExitAssessment, "ok">
  >;
};

export type LearnerSubmitAssessmentResultsMutationVariables = Exact<{
  appInfo: AppInfo;
  input: AssessmentResultsInput;
}>;

export type LearnerSubmitAssessmentResultsMutation = {
  __typename?: "Mutation";
} & {
  learnerSubmitAssessmentResults?: Maybe<
    { __typename?: "LearnerSubmitAssessmentResults" } & Pick<
      LearnerSubmitAssessmentResults,
      "ok"
    > & {
        learner: { __typename?: "Learner" } & Pick<Learner, "id"> & {
            screens: { __typename?: "LearnerScreens" } & {
              index: { __typename?: "LearnerIndexScreen" } & {
                score?: Maybe<
                  { __typename?: "LearnerIndexScore" } & Pick<
                    LearnerIndexScore,
                    | "value"
                    | "valueFloat"
                    | "labelHtml"
                    | "descriptionHtml"
                    | "icon"
                  > & {
                      change?: Maybe<
                        {
                          __typename?: "LearnerIndexScoreChange";
                        } & LearnerIndexScoreChangePartsFragment
                      >;
                      graph?: Maybe<
                        {
                          __typename?: "LearnerIndexScoreGraph";
                        } & LearnerIndexScoreGraphPartsFragment
                      >;
                    }
                >;
                coach?: Maybe<
                  { __typename?: "LearnerIndexCoach" } & Pick<
                    LearnerIndexCoach,
                    "messageTextHtml" | "avatarUrl"
                  > & {
                      assessmentButton?: Maybe<
                        { __typename?: "AssessmentButton" } & Pick<
                          AssessmentButton,
                          "text" | "url"
                        >
                      >;
                    }
                >;
                breakdown?: Maybe<
                  { __typename?: "LearnerIndexBreakdown" } & {
                    energy: {
                      __typename?: "LearnerIndexBreakdownPillar";
                    } & LearnerIndexBreakdownPillarV2PartsFragment;
                    resilience: {
                      __typename?: "LearnerIndexBreakdownPillar";
                    } & LearnerIndexBreakdownPillarV2PartsFragment;
                    activity: {
                      __typename?: "LearnerIndexBreakdownPillar";
                    } & LearnerIndexBreakdownPillarV2PartsFragment;
                    nutrition: {
                      __typename?: "LearnerIndexBreakdownPillar";
                    } & LearnerIndexBreakdownPillarV2PartsFragment;
                  }
                >;
              };
            };
          };
      }
  >;
};

export type LearnerRequestVitalSignInTokenMutationVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerRequestVitalSignInTokenMutation = {
  __typename?: "Mutation";
} & {
  learnerRequestVitalSignInToken?: Maybe<
    { __typename?: "LearnerRequestVitalSignInToken" } & Pick<
      LearnerRequestVitalSignInToken,
      "ok" | "signInToken"
    >
  >;
};

export type RecentContentQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type RecentContentQuery = { __typename?: "Query" } & {
  recentContent?: Maybe<
    Array<
      Maybe<
        { __typename?: "LearnerRecording" } & LearnerRecordingCardPartsFragment
      >
    >
  >;
};

export type LearnerFavouritesScreenQueryVariables = Exact<{
  appInfo: AppInfo;
}>;

export type LearnerFavouritesScreenQuery = { __typename?: "Query" } & {
  learnerFavourites?: Maybe<
    { __typename?: "LearnerFavourites" } & LearnerFavouritesFragment
  >;
};

export type LearnerFavouritesFragment = {
  __typename?: "LearnerFavourites";
} & Pick<LearnerFavourites, "title"> & {
    recordings: { __typename?: "LearnerFavouritesRecordings" } & Pick<
      LearnerFavouritesRecordings,
      "count" | "label"
    > & {
        contentList: { __typename: "LearnerRecordingsList" } & Pick<
          LearnerRecordingsList,
          "id"
        > & {
            items: Array<
              {
                __typename?: "LearnerRecording";
              } & LearnerRecordingCardPartsFragment
            >;
          };
      };
    articles: { __typename?: "LearnerFavouritesArticles" } & Pick<
      LearnerFavouritesArticles,
      "count" | "label"
    > & {
        contentList: { __typename: "LearnerArticlesList" } & Pick<
          LearnerArticlesList,
          "id"
        > & {
            items: Array<
              {
                __typename?: "LearnerArticle";
              } & LearnerArticleCardPartsFragment
            >;
          };
      };
  };

export type LearnerScheduleOndemandCalendarMutationVariables = Exact<{
  appInfo: AppInfo;
  recordingId: Scalars["ID"];
  datetimeSlotUtc: Scalars["DateTime"];
}>;

export type LearnerScheduleOndemandCalendarMutation = {
  __typename?: "Mutation";
} & {
  learnerScheduleOndemandCalendar?: Maybe<
    { __typename?: "LearnerScheduleOndemandCalendar" } & Pick<
      LearnerScheduleOndemandCalendar,
      "ok"
    > & {
        learnerRecording: {
          __typename?: "LearnerRecording";
        } & LearnerRecordingPartsFragment;
      }
  >;
};

export type LearnerDeleteOndemandCalendarMutationVariables = Exact<{
  appInfo: AppInfo;
  recordingId: Scalars["ID"];
}>;

export type LearnerDeleteOndemandCalendarMutation = {
  __typename?: "Mutation";
} & {
  learnerDeleteOndemandCalendar?: Maybe<
    { __typename?: "LearnerDeleteOndemandCalendar" } & Pick<
      LearnerDeleteOndemandCalendar,
      "ok"
    > & {
        learnerRecording: {
          __typename?: "LearnerRecording";
        } & LearnerRecordingPartsFragment;
      }
  >;
};

export type AdventDoorCategory =
  | "QUICK_RESET"
  | "MIND"
  | "MOVEMENT"
  | "LIFESTYLE"
  | "SPECIAL";

export type AdventDoorType =
  | "CONTENT"
  | "SELF"
  | "NOTHING"
  | "SOCIAL"
  | "RECAP";

/** What the learner does inside the door; `mechanicConfig` carries its settings. */
export type AdventDoorMechanic =
  | "NONE"
  | "DONE"
  | "WRITE"
  | "TIMER"
  | "BREATH"
  | "CHOICE";

export type AdventDoorInviteDelivery = "COMPANY_CALENDAR" | "EMAIL";

/** A door's calendar slot, and the invite once the learner has asked for it. */
export type AdventDoorInvite = {
  __typename?: "AdventDoorInvite";
  /** "19:00": 24-hour wall time in `timeZone`. */
  localTime: Scalars["String"];
  /** The IANA zone the slot is computed in: the learner's profile timezone. */
  timeZone?: Maybe<Scalars["String"]>;
  durationMinutes: Scalars["Int"];
  /** Null until the learner asks for the invite. */
  sentAt?: Maybe<Scalars["DateTime"]>;
  /** The booked slot's instant; null until the learner asks for the invite. */
  startsAt?: Maybe<Scalars["DateTime"]>;
  delivery?: Maybe<AdventDoorInviteDelivery>;
};

export type AdventDoor = {
  __typename?: "AdventDoor";
  id: Scalars["ID"];
  dayNumber: Scalars["Int"];
  /** YYYY-MM-DD; the door unlocks once the learner's local calendar date reaches it. */
  date: Scalars["Date"];
  category: AdventDoorCategory;
  doorType: AdventDoorType;
  title: Scalars["String"];
  subtitle: Scalars["String"];
  whyThisHelps: Scalars["String"];
  /** Prefixed content id (`re_` / `ls_` / `ar_`) for CONTENT doors. */
  contentId?: Maybe<Scalars["String"]>;
  contentAvailable: Scalars["Boolean"];
  /** The label of the door's single Ori button; `oriPrompt` is what it sends. */
  oriCtaLabel?: Maybe<Scalars["String"]>;
  oriPrompt?: Maybe<Scalars["String"]>;
  closingCopy?: Maybe<Scalars["String"]>;
  mechanic: AdventDoorMechanic;
  /** A JSON object string; its shape depends on `mechanic`. */
  mechanicConfig: Scalars["JSONString"];
  isOpened: Scalars["Boolean"];
  openedAt?: Maybe<Scalars["DateTime"]>;
  isCompleted: Scalars["Boolean"];
  /** The first completion; later saves never move it. */
  completedAt?: Maybe<Scalars["DateTime"]>;
  /** The latest response as a JSON object string; null until completed. */
  response?: Maybe<Scalars["JSONString"]>;
  /** Null when the door has no calendar slot to offer. */
  invite?: Maybe<AdventDoorInvite>;
};

export type AdventCampaign = {
  __typename?: "AdventCampaign";
  id: Scalars["ID"];
  name: Scalars["String"];
  slug: Scalars["String"];
  startDate: Scalars["Date"];
  endDate: Scalars["Date"];
  introTitle: Scalars["String"];
  introBody: Scalars["String"];
  totalDoors: Scalars["Int"];
  openedCount: Scalars["Int"];
  doors: Array<AdventDoor>;
};

export type AdventCampaignQuery = {
  adventCampaign?: Maybe<AdventCampaign>;
};

export type OpenAdventDoorMutation = {
  openAdventDoor?: Maybe<{
    __typename?: "OpenAdventDoor";
    ok: Scalars["Boolean"];
    door: Pick<AdventDoor, "__typename" | "id" | "isOpened" | "openedAt">;
    campaign: Pick<AdventCampaign, "__typename" | "id" | "openedCount">;
  }>;
};

export type CompleteAdventDoorMutation = {
  completeAdventDoor?: Maybe<{
    __typename?: "CompleteAdventDoor";
    ok: Scalars["Boolean"];
    door: Pick<
      AdventDoor,
      | "__typename"
      | "id"
      | "isOpened"
      | "openedAt"
      | "isCompleted"
      | "completedAt"
      | "response"
    >;
    campaign: Pick<AdventCampaign, "__typename" | "id" | "openedCount">;
  }>;
};

export type CompleteAdventDoorMutationVariables = {
  doorId: Scalars["ID"];
  response?: Maybe<Scalars["JSONString"]>;
};

export type SendAdventDoorInviteMutation = {
  sendAdventDoorInvite?: Maybe<{
    __typename?: "SendAdventDoorInvite";
    ok: Scalars["Boolean"];
    /** The learner already had this door's invite; nothing new was sent. */
    alreadySent: Scalars["Boolean"];
    door?: Maybe<Pick<AdventDoor, "__typename" | "id" | "invite">>;
  }>;
};

export type SendAdventDoorInviteMutationVariables = {
  doorId: Scalars["ID"];
};
